(function(dt) {
    typeof define == "function" && define.amd ? define(dt) : dt()
})(function() {
    "use strict";
    var dt = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {},
        Et = {
            exports: {}
        };
    /*!
     * jQuery JavaScript Library v3.6.1
     * https://jquery.com/
     *
     * Includes Sizzle.js
     * https://sizzlejs.com/
     *
     * Copyright OpenJS Foundation and other contributors
     * Released under the MIT license
     * https://jquery.org/license
     *
     * Date: 2022-08-26T17:52Z
     */
    (function(K) {
        (function(H, T) {
            K.exports = H.document ? T(H, !0) : function(S) {
                if (!S.document) throw new Error("jQuery requires a window with a document");
                return T(S)
            }
        })(typeof window != "undefined" ? window : dt, function(H, T) {
            var S = [],
                i = Object.getPrototypeOf,
                s = S.slice,
                c = S.flat ? function(e) {
                    return S.flat.call(e)
                } : function(e) {
                    return S.concat.apply([], e)
                },
                h = S.push,
                y = S.indexOf,
                D = {},
                j = D.toString,
                G = D.hasOwnProperty,
                L = G.toString,
                ae = L.call(Object),
                X = {},
                q = function(t) {
                    return typeof t == "function" && typeof t.nodeType != "number" && typeof t.item != "function"
                },
                he = function(t) {
                    return t != null && t === t.window
                },
                U = H.document,
                Fe = {
                    type: !0,
                    src: !0,
                    nonce: !0,
                    noModule: !0
                };

            function Be(e, t, n) {
                n = n || U;
                var r, a, l = n.createElement("script");
                if (l.text = e, t)
                    for (r in Fe) a = t[r] || t.getAttribute && t.getAttribute(r), a && l.setAttribute(r, a);
                n.head.appendChild(l).parentNode.removeChild(l)
            }

            function Ue(e) {
                return e == null ? e + "" : typeof e == "object" || typeof e == "function" ? D[j.call(e)] || "object" : typeof e
            }
            var Zt = "3.6.1",
                o = function(e, t) {
                    return new o.fn.init(e, t)
                };
            o.fn = o.prototype = {
                jquery: Zt,
                constructor: o,
                length: 0,
                toArray: function() {
                    return s.call(this)
                },
                get: function(e) {
                    return e == null ? s.call(this) : e < 0 ? this[e + this.length] : this[e]
                },
                pushStack: function(e) {
                    var t = o.merge(this.constructor(), e);
                    return t.prevObject = this, t
                },
                each: function(e) {
                    return o.each(this, e)
                },
                map: function(e) {
                    return this.pushStack(o.map(this, function(t, n) {
                        return e.call(t, n, t)
                    }))
                },
                slice: function() {
                    return this.pushStack(s.apply(this, arguments))
                },
                first: function() {
                    return this.eq(0)
                },
                last: function() {
                    return this.eq(-1)
                },
                even: function() {
                    return this.pushStack(o.grep(this, function(e, t) {
                        return (t + 1) % 2
                    }))
                },
                odd: function() {
                    return this.pushStack(o.grep(this, function(e, t) {
                        return t % 2
                    }))
                },
                eq: function(e) {
                    var t = this.length,
                        n = +e + (e < 0 ? t : 0);
                    return this.pushStack(n >= 0 && n < t ? [this[n]] : [])
                },
                end: function() {
                    return this.prevObject || this.constructor()
                },
                push: h,
                sort: S.sort,
                splice: S.splice
            }, o.extend = o.fn.extend = function() {
                var e, t, n, r, a, l, u = arguments[0] || {},
                    g = 1,
                    d = arguments.length,
                    w = !1;
                for (typeof u == "boolean" && (w = u, u = arguments[g] || {}, g++), typeof u != "object" && !q(u) && (u = {}), g === d && (u = this, g--); g < d; g++)
                    if ((e = arguments[g]) != null)
                        for (t in e) r = e[t], !(t === "__proto__" || u === r) && (w && r && (o.isPlainObject(r) || (a = Array.isArray(r))) ? (n = u[t], a && !Array.isArray(n) ? l = [] : !a && !o.isPlainObject(n) ? l = {} : l = n, a = !1, u[t] = o.extend(w, l, r)) : r !== void 0 && (u[t] = r));
                return u
            }, o.extend({
                expando: "jQuery" + (Zt + Math.random()).replace(/\D/g, ""),
                isReady: !0,
                error: function(e) {
                    throw new Error(e)
                },
                noop: function() {},
                isPlainObject: function(e) {
                    var t, n;
                    return !e || j.call(e) !== "[object Object]" ? !1 : (t = i(e), t ? (n = G.call(t, "constructor") && t.constructor, typeof n == "function" && L.call(n) === ae) : !0)
                },
                isEmptyObject: function(e) {
                    var t;
                    for (t in e) return !1;
                    return !0
                },
                globalEval: function(e, t, n) {
                    Be(e, {
                        nonce: t && t.nonce
                    }, n)
                },
                each: function(e, t) {
                    var n, r = 0;
                    if ($t(e))
                        for (n = e.length; r < n && t.call(e[r], r, e[r]) !== !1; r++);
                    else
                        for (r in e)
                            if (t.call(e[r], r, e[r]) === !1) break;
                    return e
                },
                makeArray: function(e, t) {
                    var n = t || [];
                    return e != null && ($t(Object(e)) ? o.merge(n, typeof e == "string" ? [e] : e) : h.call(n, e)), n
                },
                inArray: function(e, t, n) {
                    return t == null ? -1 : y.call(t, e, n)
                },
                merge: function(e, t) {
                    for (var n = +t.length, r = 0, a = e.length; r < n; r++) e[a++] = t[r];
                    return e.length = a, e
                },
                grep: function(e, t, n) {
                    for (var r, a = [], l = 0, u = e.length, g = !n; l < u; l++) r = !t(e[l], l), r !== g && a.push(e[l]);
                    return a
                },
                map: function(e, t, n) {
                    var r, a, l = 0,
                        u = [];
                    if ($t(e))
                        for (r = e.length; l < r; l++) a = t(e[l], l, n), a != null && u.push(a);
                    else
                        for (l in e) a = t(e[l], l, n), a != null && u.push(a);
                    return c(u)
                },
                guid: 1,
                support: X
            }), typeof Symbol == "function" && (o.fn[Symbol.iterator] = S[Symbol.iterator]), o.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(e, t) {
                D["[object " + t + "]"] = t.toLowerCase()
            });

            function $t(e) {
                var t = !!e && "length" in e && e.length,
                    n = Ue(e);
                return q(e) || he(e) ? !1 : n === "array" || t === 0 || typeof t == "number" && t > 0 && t - 1 in e
            }
            var je = function(e) {
                var t, n, r, a, l, u, g, d, w, k, E, b, C, P, B, _, se, re, ge, Z = "sizzle" + 1 * new Date,
                    F = e.document,
                    de = 0,
                    Q = 0,
                    ne = St(),
                    lt = St(),
                    bt = St(),
                    ye = St(),
                    Me = function(f, p) {
                        return f === p && (E = !0), 0
                    },
                    Ie = {}.hasOwnProperty,
                    pe = [],
                    Ne = pe.pop,
                    Te = pe.push,
                    Oe = pe.push,
                    Mi = pe.slice,
                    ze = function(f, p) {
                        for (var v = 0, x = f.length; v < x; v++)
                            if (f[v] === p) return v;
                        return -1
                    },
                    Ut = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
                    J = "[\\x20\\t\\r\\n\\f]",
                    We = "(?:\\\\[\\da-fA-F]{1,6}" + J + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",
                    Ii = "\\[" + J + "*(" + We + ")(?:" + J + "*([*^$|!~]?=)" + J + `*(?:'((?:\\\\.|[^\\\\'])*)'|"((?:\\\\.|[^\\\\"])*)"|(` + We + "))|)" + J + "*\\]",
                    Xt = ":(" + We + `)(?:\\((('((?:\\\\.|[^\\\\'])*)'|"((?:\\\\.|[^\\\\"])*)")|((?:\\\\.|[^\\\\()[\\]]|` + Ii + ")*)|.*)\\)|)",
                    Xn = new RegExp(J + "+", "g"),
                    Tt = new RegExp("^" + J + "+|((?:^|[^\\\\])(?:\\\\.)*)" + J + "+$", "g"),
                    Yn = new RegExp("^" + J + "*," + J + "*"),
                    zi = new RegExp("^" + J + "*([>+~]|" + J + ")" + J + "*"),
                    Vn = new RegExp(J + "|>"),
                    Gn = new RegExp(Xt),
                    Qn = new RegExp("^" + We + "$"),
                    kt = {
                        ID: new RegExp("^#(" + We + ")"),
                        CLASS: new RegExp("^\\.(" + We + ")"),
                        TAG: new RegExp("^(" + We + "|[*])"),
                        ATTR: new RegExp("^" + Ii),
                        PSEUDO: new RegExp("^" + Xt),
                        CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + J + "*(even|odd|(([+-]|)(\\d*)n|)" + J + "*(?:([+-]|)" + J + "*(\\d+)|))" + J + "*\\)|)", "i"),
                        bool: new RegExp("^(?:" + Ut + ")$", "i"),
                        needsContext: new RegExp("^" + J + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + J + "*((?:-\\d)?\\d*)" + J + "*\\)|)(?=[^-]|$)", "i")
                    },
                    Jn = /HTML$/i,
                    Kn = /^(?:input|select|textarea|button)$/i,
                    Zn = /^h\d$/i,
                    ut = /^[^{]+\{\s*\[native \w/,
                    er = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
                    Yt = /[+~]/,
                    De = new RegExp("\\\\[\\da-fA-F]{1,6}" + J + "?|\\\\([^\\r\\n\\f])", "g"),
                    Le = function(f, p) {
                        var v = "0x" + f.slice(1) - 65536;
                        return p || (v < 0 ? String.fromCharCode(v + 65536) : String.fromCharCode(v >> 10 | 55296, v & 1023 | 56320))
                    },
                    Wi = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
                    Ri = function(f, p) {
                        return p ? f === "\0" ? "\uFFFD" : f.slice(0, -1) + "\\" + f.charCodeAt(f.length - 1).toString(16) + " " : "\\" + f
                    },
                    Fi = function() {
                        b()
                    },
                    tr = xt(function(f) {
                        return f.disabled === !0 && f.nodeName.toLowerCase() === "fieldset"
                    }, {
                        dir: "parentNode",
                        next: "legend"
                    });
                try {
                    Oe.apply(pe = Mi.call(F.childNodes), F.childNodes), pe[F.childNodes.length].nodeType
                } catch {
                    Oe = {
                        apply: pe.length ? function(p, v) {
                            Te.apply(p, Mi.call(v))
                        } : function(p, v) {
                            for (var x = p.length, m = 0; p[x++] = v[m++];);
                            p.length = x - 1
                        }
                    }
                }

                function ee(f, p, v, x) {
                    var m, A, $, N, O, z, M, R = p && p.ownerDocument,
                        Y = p ? p.nodeType : 9;
                    if (v = v || [], typeof f != "string" || !f || Y !== 1 && Y !== 9 && Y !== 11) return v;
                    if (!x && (b(p), p = p || C, B)) {
                        if (Y !== 11 && (O = er.exec(f)))
                            if (m = O[1]) {
                                if (Y === 9)
                                    if ($ = p.getElementById(m)) {
                                        if ($.id === m) return v.push($), v
                                    } else return v;
                                else if (R && ($ = R.getElementById(m)) && ge(p, $) && $.id === m) return v.push($), v
                            } else {
                                if (O[2]) return Oe.apply(v, p.getElementsByTagName(f)), v;
                                if ((m = O[3]) && n.getElementsByClassName && p.getElementsByClassName) return Oe.apply(v, p.getElementsByClassName(m)), v
                            }
                        if (n.qsa && !ye[f + " "] && (!_ || !_.test(f)) && (Y !== 1 || p.nodeName.toLowerCase() !== "object")) {
                            if (M = f, R = p, Y === 1 && (Vn.test(f) || zi.test(f))) {
                                for (R = Yt.test(f) && Gt(p.parentNode) || p, (R !== p || !n.scope) && ((N = p.getAttribute("id")) ? N = N.replace(Wi, Ri) : p.setAttribute("id", N = Z)), z = u(f), A = z.length; A--;) z[A] = (N ? "#" + N : ":scope") + " " + Ct(z[A]);
                                M = z.join(",")
                            }
                            try {
                                return Oe.apply(v, R.querySelectorAll(M)), v
                            } catch {
                                ye(f, !0)
                            } finally {
                                N === Z && p.removeAttribute("id")
                            }
                        }
                    }
                    return d(f.replace(Tt, "$1"), p, v, x)
                }

                function St() {
                    var f = [];

                    function p(v, x) {
                        return f.push(v + " ") > r.cacheLength && delete p[f.shift()], p[v + " "] = x
                    }
                    return p
                }

                function Se(f) {
                    return f[Z] = !0, f
                }

                function Ce(f) {
                    var p = C.createElement("fieldset");
                    try {
                        return !!f(p)
                    } catch {
                        return !1
                    } finally {
                        p.parentNode && p.parentNode.removeChild(p), p = null
                    }
                }

                function Vt(f, p) {
                    for (var v = f.split("|"), x = v.length; x--;) r.attrHandle[v[x]] = p
                }

                function Bi(f, p) {
                    var v = p && f,
                        x = v && f.nodeType === 1 && p.nodeType === 1 && f.sourceIndex - p.sourceIndex;
                    if (x) return x;
                    if (v) {
                        for (; v = v.nextSibling;)
                            if (v === p) return -1
                    }
                    return f ? 1 : -1
                }

                function ir(f) {
                    return function(p) {
                        var v = p.nodeName.toLowerCase();
                        return v === "input" && p.type === f
                    }
                }

                function nr(f) {
                    return function(p) {
                        var v = p.nodeName.toLowerCase();
                        return (v === "input" || v === "button") && p.type === f
                    }
                }

                function Ui(f) {
                    return function(p) {
                        return "form" in p ? p.parentNode && p.disabled === !1 ? "label" in p ? "label" in p.parentNode ? p.parentNode.disabled === f : p.disabled === f : p.isDisabled === f || p.isDisabled !== !f && tr(p) === f : p.disabled === f : "label" in p ? p.disabled === f : !1
                    }
                }

                function Re(f) {
                    return Se(function(p) {
                        return p = +p, Se(function(v, x) {
                            for (var m, A = f([], v.length, p), $ = A.length; $--;) v[m = A[$]] && (v[m] = !(x[m] = v[m]))
                        })
                    })
                }

                function Gt(f) {
                    return f && typeof f.getElementsByTagName != "undefined" && f
                }
                n = ee.support = {}, l = ee.isXML = function(f) {
                    var p = f && f.namespaceURI,
                        v = f && (f.ownerDocument || f).documentElement;
                    return !Jn.test(p || v && v.nodeName || "HTML")
                }, b = ee.setDocument = function(f) {
                    var p, v, x = f ? f.ownerDocument || f : F;
                    return x == C || x.nodeType !== 9 || !x.documentElement || (C = x, P = C.documentElement, B = !l(C), F != C && (v = C.defaultView) && v.top !== v && (v.addEventListener ? v.addEventListener("unload", Fi, !1) : v.attachEvent && v.attachEvent("onunload", Fi)), n.scope = Ce(function(m) {
                        return P.appendChild(m).appendChild(C.createElement("div")), typeof m.querySelectorAll != "undefined" && !m.querySelectorAll(":scope fieldset div").length
                    }), n.attributes = Ce(function(m) {
                        return m.className = "i", !m.getAttribute("className")
                    }), n.getElementsByTagName = Ce(function(m) {
                        return m.appendChild(C.createComment("")), !m.getElementsByTagName("*").length
                    }), n.getElementsByClassName = ut.test(C.getElementsByClassName), n.getById = Ce(function(m) {
                        return P.appendChild(m).id = Z, !C.getElementsByName || !C.getElementsByName(Z).length
                    }), n.getById ? (r.filter.ID = function(m) {
                        var A = m.replace(De, Le);
                        return function($) {
                            return $.getAttribute("id") === A
                        }
                    }, r.find.ID = function(m, A) {
                        if (typeof A.getElementById != "undefined" && B) {
                            var $ = A.getElementById(m);
                            return $ ? [$] : []
                        }
                    }) : (r.filter.ID = function(m) {
                        var A = m.replace(De, Le);
                        return function($) {
                            var N = typeof $.getAttributeNode != "undefined" && $.getAttributeNode("id");
                            return N && N.value === A
                        }
                    }, r.find.ID = function(m, A) {
                        if (typeof A.getElementById != "undefined" && B) {
                            var $, N, O, z = A.getElementById(m);
                            if (z) {
                                if ($ = z.getAttributeNode("id"), $ && $.value === m) return [z];
                                for (O = A.getElementsByName(m), N = 0; z = O[N++];)
                                    if ($ = z.getAttributeNode("id"), $ && $.value === m) return [z]
                            }
                            return []
                        }
                    }), r.find.TAG = n.getElementsByTagName ? function(m, A) {
                        if (typeof A.getElementsByTagName != "undefined") return A.getElementsByTagName(m);
                        if (n.qsa) return A.querySelectorAll(m)
                    } : function(m, A) {
                        var $, N = [],
                            O = 0,
                            z = A.getElementsByTagName(m);
                        if (m === "*") {
                            for (; $ = z[O++];) $.nodeType === 1 && N.push($);
                            return N
                        }
                        return z
                    }, r.find.CLASS = n.getElementsByClassName && function(m, A) {
                        if (typeof A.getElementsByClassName != "undefined" && B) return A.getElementsByClassName(m)
                    }, se = [], _ = [], (n.qsa = ut.test(C.querySelectorAll)) && (Ce(function(m) {
                        var A;
                        P.appendChild(m).innerHTML = "<a id='" + Z + "'></a><select id='" + Z + "-\r\\' msallowcapture=''><option selected=''></option></select>", m.querySelectorAll("[msallowcapture^='']").length && _.push("[*^$]=" + J + `*(?:''|"")`), m.querySelectorAll("[selected]").length || _.push("\\[" + J + "*(?:value|" + Ut + ")"), m.querySelectorAll("[id~=" + Z + "-]").length || _.push("~="), A = C.createElement("input"), A.setAttribute("name", ""), m.appendChild(A), m.querySelectorAll("[name='']").length || _.push("\\[" + J + "*name" + J + "*=" + J + `*(?:''|"")`), m.querySelectorAll(":checked").length || _.push(":checked"), m.querySelectorAll("a#" + Z + "+*").length || _.push(".#.+[+~]"), m.querySelectorAll("\\\f"), _.push("[\\r\\n\\f]")
                    }), Ce(function(m) {
                        m.innerHTML = "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
                        var A = C.createElement("input");
                        A.setAttribute("type", "hidden"), m.appendChild(A).setAttribute("name", "D"), m.querySelectorAll("[name=d]").length && _.push("name" + J + "*[*^$|!~]?="), m.querySelectorAll(":enabled").length !== 2 && _.push(":enabled", ":disabled"), P.appendChild(m).disabled = !0, m.querySelectorAll(":disabled").length !== 2 && _.push(":enabled", ":disabled"), m.querySelectorAll("*,:x"), _.push(",.*:")
                    })), (n.matchesSelector = ut.test(re = P.matches || P.webkitMatchesSelector || P.mozMatchesSelector || P.oMatchesSelector || P.msMatchesSelector)) && Ce(function(m) {
                        n.disconnectedMatch = re.call(m, "*"), re.call(m, "[s!='']:x"), se.push("!=", Xt)
                    }), _ = _.length && new RegExp(_.join("|")), se = se.length && new RegExp(se.join("|")), p = ut.test(P.compareDocumentPosition), ge = p || ut.test(P.contains) ? function(m, A) {
                        var $ = m.nodeType === 9 ? m.documentElement : m,
                            N = A && A.parentNode;
                        return m === N || !!(N && N.nodeType === 1 && ($.contains ? $.contains(N) : m.compareDocumentPosition && m.compareDocumentPosition(N) & 16))
                    } : function(m, A) {
                        if (A) {
                            for (; A = A.parentNode;)
                                if (A === m) return !0
                        }
                        return !1
                    }, Me = p ? function(m, A) {
                        if (m === A) return E = !0, 0;
                        var $ = !m.compareDocumentPosition - !A.compareDocumentPosition;
                        return $ || ($ = (m.ownerDocument || m) == (A.ownerDocument || A) ? m.compareDocumentPosition(A) : 1, $ & 1 || !n.sortDetached && A.compareDocumentPosition(m) === $ ? m == C || m.ownerDocument == F && ge(F, m) ? -1 : A == C || A.ownerDocument == F && ge(F, A) ? 1 : k ? ze(k, m) - ze(k, A) : 0 : $ & 4 ? -1 : 1)
                    } : function(m, A) {
                        if (m === A) return E = !0, 0;
                        var $, N = 0,
                            O = m.parentNode,
                            z = A.parentNode,
                            M = [m],
                            R = [A];
                        if (!O || !z) return m == C ? -1 : A == C ? 1 : O ? -1 : z ? 1 : k ? ze(k, m) - ze(k, A) : 0;
                        if (O === z) return Bi(m, A);
                        for ($ = m; $ = $.parentNode;) M.unshift($);
                        for ($ = A; $ = $.parentNode;) R.unshift($);
                        for (; M[N] === R[N];) N++;
                        return N ? Bi(M[N], R[N]) : M[N] == F ? -1 : R[N] == F ? 1 : 0
                    }), C
                }, ee.matches = function(f, p) {
                    return ee(f, null, null, p)
                }, ee.matchesSelector = function(f, p) {
                    if (b(f), n.matchesSelector && B && !ye[p + " "] && (!se || !se.test(p)) && (!_ || !_.test(p))) try {
                        var v = re.call(f, p);
                        if (v || n.disconnectedMatch || f.document && f.document.nodeType !== 11) return v
                    } catch {
                        ye(p, !0)
                    }
                    return ee(p, C, null, [f]).length > 0
                }, ee.contains = function(f, p) {
                    return (f.ownerDocument || f) != C && b(f), ge(f, p)
                }, ee.attr = function(f, p) {
                    (f.ownerDocument || f) != C && b(f);
                    var v = r.attrHandle[p.toLowerCase()],
                        x = v && Ie.call(r.attrHandle, p.toLowerCase()) ? v(f, p, !B) : void 0;
                    return x !== void 0 ? x : n.attributes || !B ? f.getAttribute(p) : (x = f.getAttributeNode(p)) && x.specified ? x.value : null
                }, ee.escape = function(f) {
                    return (f + "").replace(Wi, Ri)
                }, ee.error = function(f) {
                    throw new Error("Syntax error, unrecognized expression: " + f)
                }, ee.uniqueSort = function(f) {
                    var p, v = [],
                        x = 0,
                        m = 0;
                    if (E = !n.detectDuplicates, k = !n.sortStable && f.slice(0), f.sort(Me), E) {
                        for (; p = f[m++];) p === f[m] && (x = v.push(m));
                        for (; x--;) f.splice(v[x], 1)
                    }
                    return k = null, f
                }, a = ee.getText = function(f) {
                    var p, v = "",
                        x = 0,
                        m = f.nodeType;
                    if (m) {
                        if (m === 1 || m === 9 || m === 11) {
                            if (typeof f.textContent == "string") return f.textContent;
                            for (f = f.firstChild; f; f = f.nextSibling) v += a(f)
                        } else if (m === 3 || m === 4) return f.nodeValue
                    } else
                        for (; p = f[x++];) v += a(p);
                    return v
                }, r = ee.selectors = {
                    cacheLength: 50,
                    createPseudo: Se,
                    match: kt,
                    attrHandle: {},
                    find: {},
                    relative: {
                        ">": {
                            dir: "parentNode",
                            first: !0
                        },
                        " ": {
                            dir: "parentNode"
                        },
                        "+": {
                            dir: "previousSibling",
                            first: !0
                        },
                        "~": {
                            dir: "previousSibling"
                        }
                    },
                    preFilter: {
                        ATTR: function(f) {
                            return f[1] = f[1].replace(De, Le), f[3] = (f[3] || f[4] || f[5] || "").replace(De, Le), f[2] === "~=" && (f[3] = " " + f[3] + " "), f.slice(0, 4)
                        },
                        CHILD: function(f) {
                            return f[1] = f[1].toLowerCase(), f[1].slice(0, 3) === "nth" ? (f[3] || ee.error(f[0]), f[4] = +(f[4] ? f[5] + (f[6] || 1) : 2 * (f[3] === "even" || f[3] === "odd")), f[5] = +(f[7] + f[8] || f[3] === "odd")) : f[3] && ee.error(f[0]), f
                        },
                        PSEUDO: function(f) {
                            var p, v = !f[6] && f[2];
                            return kt.CHILD.test(f[0]) ? null : (f[3] ? f[2] = f[4] || f[5] || "" : v && Gn.test(v) && (p = u(v, !0)) && (p = v.indexOf(")", v.length - p) - v.length) && (f[0] = f[0].slice(0, p), f[2] = v.slice(0, p)), f.slice(0, 3))
                        }
                    },
                    filter: {
                        TAG: function(f) {
                            var p = f.replace(De, Le).toLowerCase();
                            return f === "*" ? function() {
                                return !0
                            } : function(v) {
                                return v.nodeName && v.nodeName.toLowerCase() === p
                            }
                        },
                        CLASS: function(f) {
                            var p = ne[f + " "];
                            return p || (p = new RegExp("(^|" + J + ")" + f + "(" + J + "|$)")) && ne(f, function(v) {
                                return p.test(typeof v.className == "string" && v.className || typeof v.getAttribute != "undefined" && v.getAttribute("class") || "")
                            })
                        },
                        ATTR: function(f, p, v) {
                            return function(x) {
                                var m = ee.attr(x, f);
                                return m == null ? p === "!=" : p ? (m += "", p === "=" ? m === v : p === "!=" ? m !== v : p === "^=" ? v && m.indexOf(v) === 0 : p === "*=" ? v && m.indexOf(v) > -1 : p === "$=" ? v && m.slice(-v.length) === v : p === "~=" ? (" " + m.replace(Xn, " ") + " ").indexOf(v) > -1 : p === "|=" ? m === v || m.slice(0, v.length + 1) === v + "-" : !1) : !0
                            }
                        },
                        CHILD: function(f, p, v, x, m) {
                            var A = f.slice(0, 3) !== "nth",
                                $ = f.slice(-4) !== "last",
                                N = p === "of-type";
                            return x === 1 && m === 0 ? function(O) {
                                return !!O.parentNode
                            } : function(O, z, M) {
                                var R, Y, te, W, oe, le, ve = A !== $ ? "nextSibling" : "previousSibling",
                                    ie = O.parentNode,
                                    ft = N && O.nodeName.toLowerCase(),
                                    ct = !M && !N,
                                    me = !1;
                                if (ie) {
                                    if (A) {
                                        for (; ve;) {
                                            for (W = O; W = W[ve];)
                                                if (N ? W.nodeName.toLowerCase() === ft : W.nodeType === 1) return !1;
                                            le = ve = f === "only" && !le && "nextSibling"
                                        }
                                        return !0
                                    }
                                    if (le = [$ ? ie.firstChild : ie.lastChild], $ && ct) {
                                        for (W = ie, te = W[Z] || (W[Z] = {}), Y = te[W.uniqueID] || (te[W.uniqueID] = {}), R = Y[f] || [], oe = R[0] === de && R[1], me = oe && R[2], W = oe && ie.childNodes[oe]; W = ++oe && W && W[ve] || (me = oe = 0) || le.pop();)
                                            if (W.nodeType === 1 && ++me && W === O) {
                                                Y[f] = [de, oe, me];
                                                break
                                            }
                                    } else if (ct && (W = O, te = W[Z] || (W[Z] = {}), Y = te[W.uniqueID] || (te[W.uniqueID] = {}), R = Y[f] || [], oe = R[0] === de && R[1], me = oe), me === !1)
                                        for (;
                                            (W = ++oe && W && W[ve] || (me = oe = 0) || le.pop()) && !((N ? W.nodeName.toLowerCase() === ft : W.nodeType === 1) && ++me && (ct && (te = W[Z] || (W[Z] = {}), Y = te[W.uniqueID] || (te[W.uniqueID] = {}), Y[f] = [de, me]), W === O)););
                                    return me -= m, me === x || me % x === 0 && me / x >= 0
                                }
                            }
                        },
                        PSEUDO: function(f, p) {
                            var v, x = r.pseudos[f] || r.setFilters[f.toLowerCase()] || ee.error("unsupported pseudo: " + f);
                            return x[Z] ? x(p) : x.length > 1 ? (v = [f, f, "", p], r.setFilters.hasOwnProperty(f.toLowerCase()) ? Se(function(m, A) {
                                for (var $, N = x(m, p), O = N.length; O--;) $ = ze(m, N[O]), m[$] = !(A[$] = N[O])
                            }) : function(m) {
                                return x(m, 0, v)
                            }) : x
                        }
                    },
                    pseudos: {
                        not: Se(function(f) {
                            var p = [],
                                v = [],
                                x = g(f.replace(Tt, "$1"));
                            return x[Z] ? Se(function(m, A, $, N) {
                                for (var O, z = x(m, null, N, []), M = m.length; M--;)(O = z[M]) && (m[M] = !(A[M] = O))
                            }) : function(m, A, $) {
                                return p[0] = m, x(p, null, $, v), p[0] = null, !v.pop()
                            }
                        }),
                        has: Se(function(f) {
                            return function(p) {
                                return ee(f, p).length > 0
                            }
                        }),
                        contains: Se(function(f) {
                            return f = f.replace(De, Le),
                                function(p) {
                                    return (p.textContent || a(p)).indexOf(f) > -1
                                }
                        }),
                        lang: Se(function(f) {
                            return Qn.test(f || "") || ee.error("unsupported lang: " + f), f = f.replace(De, Le).toLowerCase(),
                                function(p) {
                                    var v;
                                    do
                                        if (v = B ? p.lang : p.getAttribute("xml:lang") || p.getAttribute("lang")) return v = v.toLowerCase(), v === f || v.indexOf(f + "-") === 0; while ((p = p.parentNode) && p.nodeType === 1);
                                    return !1
                                }
                        }),
                        target: function(f) {
                            var p = e.location && e.location.hash;
                            return p && p.slice(1) === f.id
                        },
                        root: function(f) {
                            return f === P
                        },
                        focus: function(f) {
                            return f === C.activeElement && (!C.hasFocus || C.hasFocus()) && !!(f.type || f.href || ~f.tabIndex)
                        },
                        enabled: Ui(!1),
                        disabled: Ui(!0),
                        checked: function(f) {
                            var p = f.nodeName.toLowerCase();
                            return p === "input" && !!f.checked || p === "option" && !!f.selected
                        },
                        selected: function(f) {
                            return f.parentNode && f.parentNode.selectedIndex, f.selected === !0
                        },
                        empty: function(f) {
                            for (f = f.firstChild; f; f = f.nextSibling)
                                if (f.nodeType < 6) return !1;
                            return !0
                        },
                        parent: function(f) {
                            return !r.pseudos.empty(f)
                        },
                        header: function(f) {
                            return Zn.test(f.nodeName)
                        },
                        input: function(f) {
                            return Kn.test(f.nodeName)
                        },
                        button: function(f) {
                            var p = f.nodeName.toLowerCase();
                            return p === "input" && f.type === "button" || p === "button"
                        },
                        text: function(f) {
                            var p;
                            return f.nodeName.toLowerCase() === "input" && f.type === "text" && ((p = f.getAttribute("type")) == null || p.toLowerCase() === "text")
                        },
                        first: Re(function() {
                            return [0]
                        }),
                        last: Re(function(f, p) {
                            return [p - 1]
                        }),
                        eq: Re(function(f, p, v) {
                            return [v < 0 ? v + p : v]
                        }),
                        even: Re(function(f, p) {
                            for (var v = 0; v < p; v += 2) f.push(v);
                            return f
                        }),
                        odd: Re(function(f, p) {
                            for (var v = 1; v < p; v += 2) f.push(v);
                            return f
                        }),
                        lt: Re(function(f, p, v) {
                            for (var x = v < 0 ? v + p : v > p ? p : v; --x >= 0;) f.push(x);
                            return f
                        }),
                        gt: Re(function(f, p, v) {
                            for (var x = v < 0 ? v + p : v; ++x < p;) f.push(x);
                            return f
                        })
                    }
                }, r.pseudos.nth = r.pseudos.eq;
                for (t in {
                        radio: !0,
                        checkbox: !0,
                        file: !0,
                        password: !0,
                        image: !0
                    }) r.pseudos[t] = ir(t);
                for (t in {
                        submit: !0,
                        reset: !0
                    }) r.pseudos[t] = nr(t);

                function Xi() {}
                Xi.prototype = r.filters = r.pseudos, r.setFilters = new Xi, u = ee.tokenize = function(f, p) {
                    var v, x, m, A, $, N, O, z = lt[f + " "];
                    if (z) return p ? 0 : z.slice(0);
                    for ($ = f, N = [], O = r.preFilter; $;) {
                        (!v || (x = Yn.exec($))) && (x && ($ = $.slice(x[0].length) || $), N.push(m = [])), v = !1, (x = zi.exec($)) && (v = x.shift(), m.push({
                            value: v,
                            type: x[0].replace(Tt, " ")
                        }), $ = $.slice(v.length));
                        for (A in r.filter)(x = kt[A].exec($)) && (!O[A] || (x = O[A](x))) && (v = x.shift(), m.push({
                            value: v,
                            type: A,
                            matches: x
                        }), $ = $.slice(v.length));
                        if (!v) break
                    }
                    return p ? $.length : $ ? ee.error(f) : lt(f, N).slice(0)
                };

                function Ct(f) {
                    for (var p = 0, v = f.length, x = ""; p < v; p++) x += f[p].value;
                    return x
                }

                function xt(f, p, v) {
                    var x = p.dir,
                        m = p.next,
                        A = m || x,
                        $ = v && A === "parentNode",
                        N = Q++;
                    return p.first ? function(O, z, M) {
                        for (; O = O[x];)
                            if (O.nodeType === 1 || $) return f(O, z, M);
                        return !1
                    } : function(O, z, M) {
                        var R, Y, te, W = [de, N];
                        if (M) {
                            for (; O = O[x];)
                                if ((O.nodeType === 1 || $) && f(O, z, M)) return !0
                        } else
                            for (; O = O[x];)
                                if (O.nodeType === 1 || $)
                                    if (te = O[Z] || (O[Z] = {}), Y = te[O.uniqueID] || (te[O.uniqueID] = {}), m && m === O.nodeName.toLowerCase()) O = O[x] || O;
                                    else {
                                        if ((R = Y[A]) && R[0] === de && R[1] === N) return W[2] = R[2];
                                        if (Y[A] = W, W[2] = f(O, z, M)) return !0
                                    } return !1
                    }
                }

                function Qt(f) {
                    return f.length > 1 ? function(p, v, x) {
                        for (var m = f.length; m--;)
                            if (!f[m](p, v, x)) return !1;
                        return !0
                    } : f[0]
                }

                function rr(f, p, v) {
                    for (var x = 0, m = p.length; x < m; x++) ee(f, p[x], v);
                    return v
                }

                function At(f, p, v, x, m) {
                    for (var A, $ = [], N = 0, O = f.length, z = p != null; N < O; N++)(A = f[N]) && (!v || v(A, x, m)) && ($.push(A), z && p.push(N));
                    return $
                }

                function Jt(f, p, v, x, m, A) {
                    return x && !x[Z] && (x = Jt(x)), m && !m[Z] && (m = Jt(m, A)), Se(function($, N, O, z) {
                        var M, R, Y, te = [],
                            W = [],
                            oe = N.length,
                            le = $ || rr(p || "*", O.nodeType ? [O] : O, []),
                            ve = f && ($ || !p) ? At(le, te, f, O, z) : le,
                            ie = v ? m || ($ ? f : oe || x) ? [] : N : ve;
                        if (v && v(ve, ie, O, z), x)
                            for (M = At(ie, W), x(M, [], O, z), R = M.length; R--;)(Y = M[R]) && (ie[W[R]] = !(ve[W[R]] = Y));
                        if ($) {
                            if (m || f) {
                                if (m) {
                                    for (M = [], R = ie.length; R--;)(Y = ie[R]) && M.push(ve[R] = Y);
                                    m(null, ie = [], M, z)
                                }
                                for (R = ie.length; R--;)(Y = ie[R]) && (M = m ? ze($, Y) : te[R]) > -1 && ($[M] = !(N[M] = Y))
                            }
                        } else ie = At(ie === N ? ie.splice(oe, ie.length) : ie), m ? m(null, N, ie, z) : Oe.apply(N, ie)
                    })
                }

                function Kt(f) {
                    for (var p, v, x, m = f.length, A = r.relative[f[0].type], $ = A || r.relative[" "], N = A ? 1 : 0, O = xt(function(R) {
                            return R === p
                        }, $, !0), z = xt(function(R) {
                            return ze(p, R) > -1
                        }, $, !0), M = [function(R, Y, te) {
                            var W = !A && (te || Y !== w) || ((p = Y).nodeType ? O(R, Y, te) : z(R, Y, te));
                            return p = null, W
                        }]; N < m; N++)
                        if (v = r.relative[f[N].type]) M = [xt(Qt(M), v)];
                        else {
                            if (v = r.filter[f[N].type].apply(null, f[N].matches), v[Z]) {
                                for (x = ++N; x < m && !r.relative[f[x].type]; x++);
                                return Jt(N > 1 && Qt(M), N > 1 && Ct(f.slice(0, N - 1).concat({
                                    value: f[N - 2].type === " " ? "*" : ""
                                })).replace(Tt, "$1"), v, N < x && Kt(f.slice(N, x)), x < m && Kt(f = f.slice(x)), x < m && Ct(f))
                            }
                            M.push(v)
                        }
                    return Qt(M)
                }

                function sr(f, p) {
                    var v = p.length > 0,
                        x = f.length > 0,
                        m = function(A, $, N, O, z) {
                            var M, R, Y, te = 0,
                                W = "0",
                                oe = A && [],
                                le = [],
                                ve = w,
                                ie = A || x && r.find.TAG("*", z),
                                ft = de += ve == null ? 1 : Math.random() || .1,
                                ct = ie.length;
                            for (z && (w = $ == C || $ || z); W !== ct && (M = ie[W]) != null; W++) {
                                if (x && M) {
                                    for (R = 0, !$ && M.ownerDocument != C && (b(M), N = !B); Y = f[R++];)
                                        if (Y(M, $ || C, N)) {
                                            O.push(M);
                                            break
                                        }
                                    z && (de = ft)
                                }
                                v && ((M = !Y && M) && te--, A && oe.push(M))
                            }
                            if (te += W, v && W !== te) {
                                for (R = 0; Y = p[R++];) Y(oe, le, $, N);
                                if (A) {
                                    if (te > 0)
                                        for (; W--;) oe[W] || le[W] || (le[W] = Ne.call(O));
                                    le = At(le)
                                }
                                Oe.apply(O, le), z && !A && le.length > 0 && te + p.length > 1 && ee.uniqueSort(O)
                            }
                            return z && (de = ft, w = ve), oe
                        };
                    return v ? Se(m) : m
                }
                return g = ee.compile = function(f, p) {
                    var v, x = [],
                        m = [],
                        A = bt[f + " "];
                    if (!A) {
                        for (p || (p = u(f)), v = p.length; v--;) A = Kt(p[v]), A[Z] ? x.push(A) : m.push(A);
                        A = bt(f, sr(m, x)), A.selector = f
                    }
                    return A
                }, d = ee.select = function(f, p, v, x) {
                    var m, A, $, N, O, z = typeof f == "function" && f,
                        M = !x && u(f = z.selector || f);
                    if (v = v || [], M.length === 1) {
                        if (A = M[0] = M[0].slice(0), A.length > 2 && ($ = A[0]).type === "ID" && p.nodeType === 9 && B && r.relative[A[1].type]) {
                            if (p = (r.find.ID($.matches[0].replace(De, Le), p) || [])[0], p) z && (p = p.parentNode);
                            else return v;
                            f = f.slice(A.shift().value.length)
                        }
                        for (m = kt.needsContext.test(f) ? 0 : A.length; m-- && ($ = A[m], !r.relative[N = $.type]);)
                            if ((O = r.find[N]) && (x = O($.matches[0].replace(De, Le), Yt.test(A[0].type) && Gt(p.parentNode) || p))) {
                                if (A.splice(m, 1), f = x.length && Ct(A), !f) return Oe.apply(v, x), v;
                                break
                            }
                    }
                    return (z || g(f, M))(x, p, !B, v, !p || Yt.test(f) && Gt(p.parentNode) || p), v
                }, n.sortStable = Z.split("").sort(Me).join("") === Z, n.detectDuplicates = !!E, b(), n.sortDetached = Ce(function(f) {
                    return f.compareDocumentPosition(C.createElement("fieldset")) & 1
                }), Ce(function(f) {
                    return f.innerHTML = "<a href='#'></a>", f.firstChild.getAttribute("href") === "#"
                }) || Vt("type|href|height|width", function(f, p, v) {
                    if (!v) return f.getAttribute(p, p.toLowerCase() === "type" ? 1 : 2)
                }), (!n.attributes || !Ce(function(f) {
                    return f.innerHTML = "<input/>", f.firstChild.setAttribute("value", ""), f.firstChild.getAttribute("value") === ""
                })) && Vt("value", function(f, p, v) {
                    if (!v && f.nodeName.toLowerCase() === "input") return f.defaultValue
                }), Ce(function(f) {
                    return f.getAttribute("disabled") == null
                }) || Vt(Ut, function(f, p, v) {
                    var x;
                    if (!v) return f[p] === !0 ? p.toLowerCase() : (x = f.getAttributeNode(p)) && x.specified ? x.value : null
                }), ee
            }(H);
            o.find = je, o.expr = je.selectors, o.expr[":"] = o.expr.pseudos, o.uniqueSort = o.unique = je.uniqueSort, o.text = je.getText, o.isXMLDoc = je.isXML, o.contains = je.contains, o.escapeSelector = je.escape;
            var Xe = function(e, t, n) {
                    for (var r = [], a = n !== void 0;
                        (e = e[t]) && e.nodeType !== 9;)
                        if (e.nodeType === 1) {
                            if (a && o(e).is(n)) break;
                            r.push(e)
                        }
                    return r
                },
                ei = function(e, t) {
                    for (var n = []; e; e = e.nextSibling) e.nodeType === 1 && e !== t && n.push(e);
                    return n
                },
                ti = o.expr.match.needsContext;

            function we(e, t) {
                return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase()
            }
            var ii = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;

            function Dt(e, t, n) {
                return q(t) ? o.grep(e, function(r, a) {
                    return !!t.call(r, a, r) !== n
                }) : t.nodeType ? o.grep(e, function(r) {
                    return r === t !== n
                }) : typeof t != "string" ? o.grep(e, function(r) {
                    return y.call(t, r) > -1 !== n
                }) : o.filter(t, e, n)
            }
            o.filter = function(e, t, n) {
                var r = t[0];
                return n && (e = ":not(" + e + ")"), t.length === 1 && r.nodeType === 1 ? o.find.matchesSelector(r, e) ? [r] : [] : o.find.matches(e, o.grep(t, function(a) {
                    return a.nodeType === 1
                }))
            }, o.fn.extend({
                find: function(e) {
                    var t, n, r = this.length,
                        a = this;
                    if (typeof e != "string") return this.pushStack(o(e).filter(function() {
                        for (t = 0; t < r; t++)
                            if (o.contains(a[t], this)) return !0
                    }));
                    for (n = this.pushStack([]), t = 0; t < r; t++) o.find(e, a[t], n);
                    return r > 1 ? o.uniqueSort(n) : n
                },
                filter: function(e) {
                    return this.pushStack(Dt(this, e || [], !1))
                },
                not: function(e) {
                    return this.pushStack(Dt(this, e || [], !0))
                },
                is: function(e) {
                    return !!Dt(this, typeof e == "string" && ti.test(e) ? o(e) : e || [], !1).length
                }
            });
            var ni, Vi = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,
                Gi = o.fn.init = function(e, t, n) {
                    var r, a;
                    if (!e) return this;
                    if (n = n || ni, typeof e == "string")
                        if (e[0] === "<" && e[e.length - 1] === ">" && e.length >= 3 ? r = [null, e, null] : r = Vi.exec(e), r && (r[1] || !t))
                            if (r[1]) {
                                if (t = t instanceof o ? t[0] : t, o.merge(this, o.parseHTML(r[1], t && t.nodeType ? t.ownerDocument || t : U, !0)), ii.test(r[1]) && o.isPlainObject(t))
                                    for (r in t) q(this[r]) ? this[r](t[r]) : this.attr(r, t[r]);
                                return this
                            } else return a = U.getElementById(r[2]), a && (this[0] = a, this.length = 1), this;
                    else return !t || t.jquery ? (t || n).find(e) : this.constructor(t).find(e);
                    else {
                        if (e.nodeType) return this[0] = e, this.length = 1, this;
                        if (q(e)) return n.ready !== void 0 ? n.ready(e) : e(o)
                    }
                    return o.makeArray(e, this)
                };
            Gi.prototype = o.fn, ni = o(U);
            var Qi = /^(?:parents|prev(?:Until|All))/,
                Ji = {
                    children: !0,
                    contents: !0,
                    next: !0,
                    prev: !0
                };
            o.fn.extend({
                has: function(e) {
                    var t = o(e, this),
                        n = t.length;
                    return this.filter(function() {
                        for (var r = 0; r < n; r++)
                            if (o.contains(this, t[r])) return !0
                    })
                },
                closest: function(e, t) {
                    var n, r = 0,
                        a = this.length,
                        l = [],
                        u = typeof e != "string" && o(e);
                    if (!ti.test(e)) {
                        for (; r < a; r++)
                            for (n = this[r]; n && n !== t; n = n.parentNode)
                                if (n.nodeType < 11 && (u ? u.index(n) > -1 : n.nodeType === 1 && o.find.matchesSelector(n, e))) {
                                    l.push(n);
                                    break
                                }
                    }
                    return this.pushStack(l.length > 1 ? o.uniqueSort(l) : l)
                },
                index: function(e) {
                    return e ? typeof e == "string" ? y.call(o(e), this[0]) : y.call(this, e.jquery ? e[0] : e) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1
                },
                add: function(e, t) {
                    return this.pushStack(o.uniqueSort(o.merge(this.get(), o(e, t))))
                },
                addBack: function(e) {
                    return this.add(e == null ? this.prevObject : this.prevObject.filter(e))
                }
            });

            function ri(e, t) {
                for (;
                    (e = e[t]) && e.nodeType !== 1;);
                return e
            }
            o.each({
                parent: function(e) {
                    var t = e.parentNode;
                    return t && t.nodeType !== 11 ? t : null
                },
                parents: function(e) {
                    return Xe(e, "parentNode")
                },
                parentsUntil: function(e, t, n) {
                    return Xe(e, "parentNode", n)
                },
                next: function(e) {
                    return ri(e, "nextSibling")
                },
                prev: function(e) {
                    return ri(e, "previousSibling")
                },
                nextAll: function(e) {
                    return Xe(e, "nextSibling")
                },
                prevAll: function(e) {
                    return Xe(e, "previousSibling")
                },
                nextUntil: function(e, t, n) {
                    return Xe(e, "nextSibling", n)
                },
                prevUntil: function(e, t, n) {
                    return Xe(e, "previousSibling", n)
                },
                siblings: function(e) {
                    return ei((e.parentNode || {}).firstChild, e)
                },
                children: function(e) {
                    return ei(e.firstChild)
                },
                contents: function(e) {
                    return e.contentDocument != null && i(e.contentDocument) ? e.contentDocument : (we(e, "template") && (e = e.content || e), o.merge([], e.childNodes))
                }
            }, function(e, t) {
                o.fn[e] = function(n, r) {
                    var a = o.map(this, t, n);
                    return e.slice(-5) !== "Until" && (r = n), r && typeof r == "string" && (a = o.filter(r, a)), this.length > 1 && (Ji[e] || o.uniqueSort(a), Qi.test(e) && a.reverse()), this.pushStack(a)
                }
            });
            var xe = /[^\x20\t\r\n\f]+/g;

            function Ki(e) {
                var t = {};
                return o.each(e.match(xe) || [], function(n, r) {
                    t[r] = !0
                }), t
            }
            o.Callbacks = function(e) {
                e = typeof e == "string" ? Ki(e) : o.extend({}, e);
                var t, n, r, a, l = [],
                    u = [],
                    g = -1,
                    d = function() {
                        for (a = a || e.once, r = t = !0; u.length; g = -1)
                            for (n = u.shift(); ++g < l.length;) l[g].apply(n[0], n[1]) === !1 && e.stopOnFalse && (g = l.length, n = !1);
                        e.memory || (n = !1), t = !1, a && (n ? l = [] : l = "")
                    },
                    w = {
                        add: function() {
                            return l && (n && !t && (g = l.length - 1, u.push(n)), function k(E) {
                                o.each(E, function(b, C) {
                                    q(C) ? (!e.unique || !w.has(C)) && l.push(C) : C && C.length && Ue(C) !== "string" && k(C)
                                })
                            }(arguments), n && !t && d()), this
                        },
                        remove: function() {
                            return o.each(arguments, function(k, E) {
                                for (var b;
                                    (b = o.inArray(E, l, b)) > -1;) l.splice(b, 1), b <= g && g--
                            }), this
                        },
                        has: function(k) {
                            return k ? o.inArray(k, l) > -1 : l.length > 0
                        },
                        empty: function() {
                            return l && (l = []), this
                        },
                        disable: function() {
                            return a = u = [], l = n = "", this
                        },
                        disabled: function() {
                            return !l
                        },
                        lock: function() {
                            return a = u = [], !n && !t && (l = n = ""), this
                        },
                        locked: function() {
                            return !!a
                        },
                        fireWith: function(k, E) {
                            return a || (E = E || [], E = [k, E.slice ? E.slice() : E], u.push(E), t || d()), this
                        },
                        fire: function() {
                            return w.fireWith(this, arguments), this
                        },
                        fired: function() {
                            return !!r
                        }
                    };
                return w
            };

            function Ye(e) {
                return e
            }

            function pt(e) {
                throw e
            }

            function si(e, t, n, r) {
                var a;
                try {
                    e && q(a = e.promise) ? a.call(e).done(t).fail(n) : e && q(a = e.then) ? a.call(e, t, n) : t.apply(void 0, [e].slice(r))
                } catch (l) {
                    n.apply(void 0, [l])
                }
            }
            o.extend({
                Deferred: function(e) {
                    var t = [
                            ["notify", "progress", o.Callbacks("memory"), o.Callbacks("memory"), 2],
                            ["resolve", "done", o.Callbacks("once memory"), o.Callbacks("once memory"), 0, "resolved"],
                            ["reject", "fail", o.Callbacks("once memory"), o.Callbacks("once memory"), 1, "rejected"]
                        ],
                        n = "pending",
                        r = {
                            state: function() {
                                return n
                            },
                            always: function() {
                                return a.done(arguments).fail(arguments), this
                            },
                            catch: function(l) {
                                return r.then(null, l)
                            },
                            pipe: function() {
                                var l = arguments;
                                return o.Deferred(function(u) {
                                    o.each(t, function(g, d) {
                                        var w = q(l[d[4]]) && l[d[4]];
                                        a[d[1]](function() {
                                            var k = w && w.apply(this, arguments);
                                            k && q(k.promise) ? k.promise().progress(u.notify).done(u.resolve).fail(u.reject) : u[d[0] + "With"](this, w ? [k] : arguments)
                                        })
                                    }), l = null
                                }).promise()
                            },
                            then: function(l, u, g) {
                                var d = 0;

                                function w(k, E, b, C) {
                                    return function() {
                                        var P = this,
                                            B = arguments,
                                            _ = function() {
                                                var re, ge;
                                                if (!(k < d)) {
                                                    if (re = b.apply(P, B), re === E.promise()) throw new TypeError("Thenable self-resolution");
                                                    ge = re && (typeof re == "object" || typeof re == "function") && re.then, q(ge) ? C ? ge.call(re, w(d, E, Ye, C), w(d, E, pt, C)) : (d++, ge.call(re, w(d, E, Ye, C), w(d, E, pt, C), w(d, E, Ye, E.notifyWith))) : (b !== Ye && (P = void 0, B = [re]), (C || E.resolveWith)(P, B))
                                                }
                                            },
                                            se = C ? _ : function() {
                                                try {
                                                    _()
                                                } catch (re) {
                                                    o.Deferred.exceptionHook && o.Deferred.exceptionHook(re, se.stackTrace), k + 1 >= d && (b !== pt && (P = void 0, B = [re]), E.rejectWith(P, B))
                                                }
                                            };
                                        k ? se() : (o.Deferred.getStackHook && (se.stackTrace = o.Deferred.getStackHook()), H.setTimeout(se))
                                    }
                                }
                                return o.Deferred(function(k) {
                                    t[0][3].add(w(0, k, q(g) ? g : Ye, k.notifyWith)), t[1][3].add(w(0, k, q(l) ? l : Ye)), t[2][3].add(w(0, k, q(u) ? u : pt))
                                }).promise()
                            },
                            promise: function(l) {
                                return l != null ? o.extend(l, r) : r
                            }
                        },
                        a = {};
                    return o.each(t, function(l, u) {
                        var g = u[2],
                            d = u[5];
                        r[u[1]] = g.add, d && g.add(function() {
                            n = d
                        }, t[3 - l][2].disable, t[3 - l][3].disable, t[0][2].lock, t[0][3].lock), g.add(u[3].fire), a[u[0]] = function() {
                            return a[u[0] + "With"](this === a ? void 0 : this, arguments), this
                        }, a[u[0] + "With"] = g.fireWith
                    }), r.promise(a), e && e.call(a, a), a
                },
                when: function(e) {
                    var t = arguments.length,
                        n = t,
                        r = Array(n),
                        a = s.call(arguments),
                        l = o.Deferred(),
                        u = function(g) {
                            return function(d) {
                                r[g] = this, a[g] = arguments.length > 1 ? s.call(arguments) : d, --t || l.resolveWith(r, a)
                            }
                        };
                    if (t <= 1 && (si(e, l.done(u(n)).resolve, l.reject, !t), l.state() === "pending" || q(a[n] && a[n].then))) return l.then();
                    for (; n--;) si(a[n], u(n), l.reject);
                    return l.promise()
                }
            });
            var Zi = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
            o.Deferred.exceptionHook = function(e, t) {
                H.console && H.console.warn && e && Zi.test(e.name) && H.console.warn("jQuery.Deferred exception: " + e.message, e.stack, t)
            }, o.readyException = function(e) {
                H.setTimeout(function() {
                    throw e
                })
            };
            var Lt = o.Deferred();
            o.fn.ready = function(e) {
                return Lt.then(e).catch(function(t) {
                    o.readyException(t)
                }), this
            }, o.extend({
                isReady: !1,
                readyWait: 1,
                ready: function(e) {
                    (e === !0 ? --o.readyWait : o.isReady) || (o.isReady = !0, !(e !== !0 && --o.readyWait > 0) && Lt.resolveWith(U, [o]))
                }
            }), o.ready.then = Lt.then;

            function ht() {
                U.removeEventListener("DOMContentLoaded", ht), H.removeEventListener("load", ht), o.ready()
            }
            U.readyState === "complete" || U.readyState !== "loading" && !U.documentElement.doScroll ? H.setTimeout(o.ready) : (U.addEventListener("DOMContentLoaded", ht), H.addEventListener("load", ht));
            var Ee = function(e, t, n, r, a, l, u) {
                    var g = 0,
                        d = e.length,
                        w = n == null;
                    if (Ue(n) === "object") {
                        a = !0;
                        for (g in n) Ee(e, t, g, n[g], !0, l, u)
                    } else if (r !== void 0 && (a = !0, q(r) || (u = !0), w && (u ? (t.call(e, r), t = null) : (w = t, t = function(k, E, b) {
                            return w.call(o(k), b)
                        })), t))
                        for (; g < d; g++) t(e[g], n, u ? r : r.call(e[g], g, t(e[g], n)));
                    return a ? e : w ? t.call(e) : d ? t(e[0], n) : l
                },
                en = /^-ms-/,
                tn = /-([a-z])/g;

            function nn(e, t) {
                return t.toUpperCase()
            }

            function Ae(e) {
                return e.replace(en, "ms-").replace(tn, nn)
            }
            var et = function(e) {
                return e.nodeType === 1 || e.nodeType === 9 || !+e.nodeType
            };

            function tt() {
                this.expando = o.expando + tt.uid++
            }
            tt.uid = 1, tt.prototype = {
                cache: function(e) {
                    var t = e[this.expando];
                    return t || (t = {}, et(e) && (e.nodeType ? e[this.expando] = t : Object.defineProperty(e, this.expando, {
                        value: t,
                        configurable: !0
                    }))), t
                },
                set: function(e, t, n) {
                    var r, a = this.cache(e);
                    if (typeof t == "string") a[Ae(t)] = n;
                    else
                        for (r in t) a[Ae(r)] = t[r];
                    return a
                },
                get: function(e, t) {
                    return t === void 0 ? this.cache(e) : e[this.expando] && e[this.expando][Ae(t)]
                },
                access: function(e, t, n) {
                    return t === void 0 || t && typeof t == "string" && n === void 0 ? this.get(e, t) : (this.set(e, t, n), n !== void 0 ? n : t)
                },
                remove: function(e, t) {
                    var n, r = e[this.expando];
                    if (r !== void 0) {
                        if (t !== void 0)
                            for (Array.isArray(t) ? t = t.map(Ae) : (t = Ae(t), t = t in r ? [t] : t.match(xe) || []), n = t.length; n--;) delete r[t[n]];
                        (t === void 0 || o.isEmptyObject(r)) && (e.nodeType ? e[this.expando] = void 0 : delete e[this.expando])
                    }
                },
                hasData: function(e) {
                    var t = e[this.expando];
                    return t !== void 0 && !o.isEmptyObject(t)
                }
            };
            var I = new tt,
                ue = new tt,
                rn = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
                sn = /[A-Z]/g;

            function on(e) {
                return e === "true" ? !0 : e === "false" ? !1 : e === "null" ? null : e === +e + "" ? +e : rn.test(e) ? JSON.parse(e) : e
            }

            function oi(e, t, n) {
                var r;
                if (n === void 0 && e.nodeType === 1)
                    if (r = "data-" + t.replace(sn, "-$&").toLowerCase(), n = e.getAttribute(r), typeof n == "string") {
                        try {
                            n = on(n)
                        } catch {}
                        ue.set(e, t, n)
                    } else n = void 0;
                return n
            }
            o.extend({
                hasData: function(e) {
                    return ue.hasData(e) || I.hasData(e)
                },
                data: function(e, t, n) {
                    return ue.access(e, t, n)
                },
                removeData: function(e, t) {
                    ue.remove(e, t)
                },
                _data: function(e, t, n) {
                    return I.access(e, t, n)
                },
                _removeData: function(e, t) {
                    I.remove(e, t)
                }
            }), o.fn.extend({
                data: function(e, t) {
                    var n, r, a, l = this[0],
                        u = l && l.attributes;
                    if (e === void 0) {
                        if (this.length && (a = ue.get(l), l.nodeType === 1 && !I.get(l, "hasDataAttrs"))) {
                            for (n = u.length; n--;) u[n] && (r = u[n].name, r.indexOf("data-") === 0 && (r = Ae(r.slice(5)), oi(l, r, a[r])));
                            I.set(l, "hasDataAttrs", !0)
                        }
                        return a
                    }
                    return typeof e == "object" ? this.each(function() {
                        ue.set(this, e)
                    }) : Ee(this, function(g) {
                        var d;
                        if (l && g === void 0) return d = ue.get(l, e), d !== void 0 || (d = oi(l, e), d !== void 0) ? d : void 0;
                        this.each(function() {
                            ue.set(this, e, g)
                        })
                    }, null, t, arguments.length > 1, null, !0)
                },
                removeData: function(e) {
                    return this.each(function() {
                        ue.remove(this, e)
                    })
                }
            }), o.extend({
                queue: function(e, t, n) {
                    var r;
                    if (e) return t = (t || "fx") + "queue", r = I.get(e, t), n && (!r || Array.isArray(n) ? r = I.access(e, t, o.makeArray(n)) : r.push(n)), r || []
                },
                dequeue: function(e, t) {
                    t = t || "fx";
                    var n = o.queue(e, t),
                        r = n.length,
                        a = n.shift(),
                        l = o._queueHooks(e, t),
                        u = function() {
                            o.dequeue(e, t)
                        };
                    a === "inprogress" && (a = n.shift(), r--), a && (t === "fx" && n.unshift("inprogress"), delete l.stop, a.call(e, u, l)), !r && l && l.empty.fire()
                },
                _queueHooks: function(e, t) {
                    var n = t + "queueHooks";
                    return I.get(e, n) || I.access(e, n, {
                        empty: o.Callbacks("once memory").add(function() {
                            I.remove(e, [t + "queue", n])
                        })
                    })
                }
            }), o.fn.extend({
                queue: function(e, t) {
                    var n = 2;
                    return typeof e != "string" && (t = e, e = "fx", n--), arguments.length < n ? o.queue(this[0], e) : t === void 0 ? this : this.each(function() {
                        var r = o.queue(this, e, t);
                        o._queueHooks(this, e), e === "fx" && r[0] !== "inprogress" && o.dequeue(this, e)
                    })
                },
                dequeue: function(e) {
                    return this.each(function() {
                        o.dequeue(this, e)
                    })
                },
                clearQueue: function(e) {
                    return this.queue(e || "fx", [])
                },
                promise: function(e, t) {
                    var n, r = 1,
                        a = o.Deferred(),
                        l = this,
                        u = this.length,
                        g = function() {
                            --r || a.resolveWith(l, [l])
                        };
                    for (typeof e != "string" && (t = e, e = void 0), e = e || "fx"; u--;) n = I.get(l[u], e + "queueHooks"), n && n.empty && (r++, n.empty.add(g));
                    return g(), a.promise(t)
                }
            });
            var ai = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
                it = new RegExp("^(?:([+-])=|)(" + ai + ")([a-z%]*)$", "i"),
                $e = ["Top", "Right", "Bottom", "Left"],
                Pe = U.documentElement,
                Ve = function(e) {
                    return o.contains(e.ownerDocument, e)
                },
                an = {
                    composed: !0
                };
            Pe.getRootNode && (Ve = function(e) {
                return o.contains(e.ownerDocument, e) || e.getRootNode(an) === e.ownerDocument
            });
            var gt = function(e, t) {
                return e = t || e, e.style.display === "none" || e.style.display === "" && Ve(e) && o.css(e, "display") === "none"
            };

            function li(e, t, n, r) {
                var a, l, u = 20,
                    g = r ? function() {
                        return r.cur()
                    } : function() {
                        return o.css(e, t, "")
                    },
                    d = g(),
                    w = n && n[3] || (o.cssNumber[t] ? "" : "px"),
                    k = e.nodeType && (o.cssNumber[t] || w !== "px" && +d) && it.exec(o.css(e, t));
                if (k && k[3] !== w) {
                    for (d = d / 2, w = w || k[3], k = +d || 1; u--;) o.style(e, t, k + w), (1 - l) * (1 - (l = g() / d || .5)) <= 0 && (u = 0), k = k / l;
                    k = k * 2, o.style(e, t, k + w), n = n || []
                }
                return n && (k = +k || +d || 0, a = n[1] ? k + (n[1] + 1) * n[2] : +n[2], r && (r.unit = w, r.start = k, r.end = a)), a
            }
            var ui = {};

            function ln(e) {
                var t, n = e.ownerDocument,
                    r = e.nodeName,
                    a = ui[r];
                return a || (t = n.body.appendChild(n.createElement(r)), a = o.css(t, "display"), t.parentNode.removeChild(t), a === "none" && (a = "block"), ui[r] = a, a)
            }

            function Ge(e, t) {
                for (var n, r, a = [], l = 0, u = e.length; l < u; l++) r = e[l], r.style && (n = r.style.display, t ? (n === "none" && (a[l] = I.get(r, "display") || null, a[l] || (r.style.display = "")), r.style.display === "" && gt(r) && (a[l] = ln(r))) : n !== "none" && (a[l] = "none", I.set(r, "display", n)));
                for (l = 0; l < u; l++) a[l] != null && (e[l].style.display = a[l]);
                return e
            }
            o.fn.extend({
                show: function() {
                    return Ge(this, !0)
                },
                hide: function() {
                    return Ge(this)
                },
                toggle: function(e) {
                    return typeof e == "boolean" ? e ? this.show() : this.hide() : this.each(function() {
                        gt(this) ? o(this).show() : o(this).hide()
                    })
                }
            });
            var nt = /^(?:checkbox|radio)$/i,
                fi = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i,
                ci = /^$|^module$|\/(?:java|ecma)script/i;
            (function() {
                var e = U.createDocumentFragment(),
                    t = e.appendChild(U.createElement("div")),
                    n = U.createElement("input");
                n.setAttribute("type", "radio"), n.setAttribute("checked", "checked"), n.setAttribute("name", "t"), t.appendChild(n), X.checkClone = t.cloneNode(!0).cloneNode(!0).lastChild.checked, t.innerHTML = "<textarea>x</textarea>", X.noCloneChecked = !!t.cloneNode(!0).lastChild.defaultValue, t.innerHTML = "<option></option>", X.option = !!t.lastChild
            })();
            var be = {
                thead: [1, "<table>", "</table>"],
                col: [2, "<table><colgroup>", "</colgroup></table>"],
                tr: [2, "<table><tbody>", "</tbody></table>"],
                td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
                _default: [0, "", ""]
            };
            be.tbody = be.tfoot = be.colgroup = be.caption = be.thead, be.th = be.td, X.option || (be.optgroup = be.option = [1, "<select multiple='multiple'>", "</select>"]);

            function fe(e, t) {
                var n;
                return typeof e.getElementsByTagName != "undefined" ? n = e.getElementsByTagName(t || "*") : typeof e.querySelectorAll != "undefined" ? n = e.querySelectorAll(t || "*") : n = [], t === void 0 || t && we(e, t) ? o.merge([e], n) : n
            }

            function Nt(e, t) {
                for (var n = 0, r = e.length; n < r; n++) I.set(e[n], "globalEval", !t || I.get(t[n], "globalEval"))
            }
            var un = /<|&#?\w+;/;

            function di(e, t, n, r, a) {
                for (var l, u, g, d, w, k, E = t.createDocumentFragment(), b = [], C = 0, P = e.length; C < P; C++)
                    if (l = e[C], l || l === 0)
                        if (Ue(l) === "object") o.merge(b, l.nodeType ? [l] : l);
                        else if (!un.test(l)) b.push(t.createTextNode(l));
                else {
                    for (u = u || E.appendChild(t.createElement("div")), g = (fi.exec(l) || ["", ""])[1].toLowerCase(), d = be[g] || be._default, u.innerHTML = d[1] + o.htmlPrefilter(l) + d[2], k = d[0]; k--;) u = u.lastChild;
                    o.merge(b, u.childNodes), u = E.firstChild, u.textContent = ""
                }
                for (E.textContent = "", C = 0; l = b[C++];) {
                    if (r && o.inArray(l, r) > -1) {
                        a && a.push(l);
                        continue
                    }
                    if (w = Ve(l), u = fe(E.appendChild(l), "script"), w && Nt(u), n)
                        for (k = 0; l = u[k++];) ci.test(l.type || "") && n.push(l)
                }
                return E
            }
            var pi = /^([^.]*)(?:\.(.+)|)/;

            function Qe() {
                return !0
            }

            function Je() {
                return !1
            }

            function fn(e, t) {
                return e === cn() == (t === "focus")
            }

            function cn() {
                try {
                    return U.activeElement
                } catch {}
            }

            function Ot(e, t, n, r, a, l) {
                var u, g;
                if (typeof t == "object") {
                    typeof n != "string" && (r = r || n, n = void 0);
                    for (g in t) Ot(e, g, n, r, t[g], l);
                    return e
                }
                if (r == null && a == null ? (a = n, r = n = void 0) : a == null && (typeof n == "string" ? (a = r, r = void 0) : (a = r, r = n, n = void 0)), a === !1) a = Je;
                else if (!a) return e;
                return l === 1 && (u = a, a = function(d) {
                    return o().off(d), u.apply(this, arguments)
                }, a.guid = u.guid || (u.guid = o.guid++)), e.each(function() {
                    o.event.add(this, t, a, r, n)
                })
            }
            o.event = {
                global: {},
                add: function(e, t, n, r, a) {
                    var l, u, g, d, w, k, E, b, C, P, B, _ = I.get(e);
                    if (!!et(e))
                        for (n.handler && (l = n, n = l.handler, a = l.selector), a && o.find.matchesSelector(Pe, a), n.guid || (n.guid = o.guid++), (d = _.events) || (d = _.events = Object.create(null)), (u = _.handle) || (u = _.handle = function(se) {
                                return typeof o != "undefined" && o.event.triggered !== se.type ? o.event.dispatch.apply(e, arguments) : void 0
                            }), t = (t || "").match(xe) || [""], w = t.length; w--;) g = pi.exec(t[w]) || [], C = B = g[1], P = (g[2] || "").split(".").sort(), C && (E = o.event.special[C] || {}, C = (a ? E.delegateType : E.bindType) || C, E = o.event.special[C] || {}, k = o.extend({
                            type: C,
                            origType: B,
                            data: r,
                            handler: n,
                            guid: n.guid,
                            selector: a,
                            needsContext: a && o.expr.match.needsContext.test(a),
                            namespace: P.join(".")
                        }, l), (b = d[C]) || (b = d[C] = [], b.delegateCount = 0, (!E.setup || E.setup.call(e, r, P, u) === !1) && e.addEventListener && e.addEventListener(C, u)), E.add && (E.add.call(e, k), k.handler.guid || (k.handler.guid = n.guid)), a ? b.splice(b.delegateCount++, 0, k) : b.push(k), o.event.global[C] = !0)
                },
                remove: function(e, t, n, r, a) {
                    var l, u, g, d, w, k, E, b, C, P, B, _ = I.hasData(e) && I.get(e);
                    if (!(!_ || !(d = _.events))) {
                        for (t = (t || "").match(xe) || [""], w = t.length; w--;) {
                            if (g = pi.exec(t[w]) || [], C = B = g[1], P = (g[2] || "").split(".").sort(), !C) {
                                for (C in d) o.event.remove(e, C + t[w], n, r, !0);
                                continue
                            }
                            for (E = o.event.special[C] || {}, C = (r ? E.delegateType : E.bindType) || C, b = d[C] || [], g = g[2] && new RegExp("(^|\\.)" + P.join("\\.(?:.*\\.|)") + "(\\.|$)"), u = l = b.length; l--;) k = b[l], (a || B === k.origType) && (!n || n.guid === k.guid) && (!g || g.test(k.namespace)) && (!r || r === k.selector || r === "**" && k.selector) && (b.splice(l, 1), k.selector && b.delegateCount--, E.remove && E.remove.call(e, k));
                            u && !b.length && ((!E.teardown || E.teardown.call(e, P, _.handle) === !1) && o.removeEvent(e, C, _.handle), delete d[C])
                        }
                        o.isEmptyObject(d) && I.remove(e, "handle events")
                    }
                },
                dispatch: function(e) {
                    var t, n, r, a, l, u, g = new Array(arguments.length),
                        d = o.event.fix(e),
                        w = (I.get(this, "events") || Object.create(null))[d.type] || [],
                        k = o.event.special[d.type] || {};
                    for (g[0] = d, t = 1; t < arguments.length; t++) g[t] = arguments[t];
                    if (d.delegateTarget = this, !(k.preDispatch && k.preDispatch.call(this, d) === !1)) {
                        for (u = o.event.handlers.call(this, d, w), t = 0;
                            (a = u[t++]) && !d.isPropagationStopped();)
                            for (d.currentTarget = a.elem, n = 0;
                                (l = a.handlers[n++]) && !d.isImmediatePropagationStopped();)(!d.rnamespace || l.namespace === !1 || d.rnamespace.test(l.namespace)) && (d.handleObj = l, d.data = l.data, r = ((o.event.special[l.origType] || {}).handle || l.handler).apply(a.elem, g), r !== void 0 && (d.result = r) === !1 && (d.preventDefault(), d.stopPropagation()));
                        return k.postDispatch && k.postDispatch.call(this, d), d.result
                    }
                },
                handlers: function(e, t) {
                    var n, r, a, l, u, g = [],
                        d = t.delegateCount,
                        w = e.target;
                    if (d && w.nodeType && !(e.type === "click" && e.button >= 1)) {
                        for (; w !== this; w = w.parentNode || this)
                            if (w.nodeType === 1 && !(e.type === "click" && w.disabled === !0)) {
                                for (l = [], u = {}, n = 0; n < d; n++) r = t[n], a = r.selector + " ", u[a] === void 0 && (u[a] = r.needsContext ? o(a, this).index(w) > -1 : o.find(a, this, null, [w]).length), u[a] && l.push(r);
                                l.length && g.push({
                                    elem: w,
                                    handlers: l
                                })
                            }
                    }
                    return w = this, d < t.length && g.push({
                        elem: w,
                        handlers: t.slice(d)
                    }), g
                },
                addProp: function(e, t) {
                    Object.defineProperty(o.Event.prototype, e, {
                        enumerable: !0,
                        configurable: !0,
                        get: q(t) ? function() {
                            if (this.originalEvent) return t(this.originalEvent)
                        } : function() {
                            if (this.originalEvent) return this.originalEvent[e]
                        },
                        set: function(n) {
                            Object.defineProperty(this, e, {
                                enumerable: !0,
                                configurable: !0,
                                writable: !0,
                                value: n
                            })
                        }
                    })
                },
                fix: function(e) {
                    return e[o.expando] ? e : new o.Event(e)
                },
                special: {
                    load: {
                        noBubble: !0
                    },
                    click: {
                        setup: function(e) {
                            var t = this || e;
                            return nt.test(t.type) && t.click && we(t, "input") && yt(t, "click", Qe), !1
                        },
                        trigger: function(e) {
                            var t = this || e;
                            return nt.test(t.type) && t.click && we(t, "input") && yt(t, "click"), !0
                        },
                        _default: function(e) {
                            var t = e.target;
                            return nt.test(t.type) && t.click && we(t, "input") && I.get(t, "click") || we(t, "a")
                        }
                    },
                    beforeunload: {
                        postDispatch: function(e) {
                            e.result !== void 0 && e.originalEvent && (e.originalEvent.returnValue = e.result)
                        }
                    }
                }
            };

            function yt(e, t, n) {
                if (!n) {
                    I.get(e, t) === void 0 && o.event.add(e, t, Qe);
                    return
                }
                I.set(e, t, !1), o.event.add(e, t, {
                    namespace: !1,
                    handler: function(r) {
                        var a, l, u = I.get(this, t);
                        if (r.isTrigger & 1 && this[t]) {
                            if (u.length)(o.event.special[t] || {}).delegateType && r.stopPropagation();
                            else if (u = s.call(arguments), I.set(this, t, u), a = n(this, t), this[t](), l = I.get(this, t), u !== l || a ? I.set(this, t, !1) : l = {}, u !== l) return r.stopImmediatePropagation(), r.preventDefault(), l && l.value
                        } else u.length && (I.set(this, t, {
                            value: o.event.trigger(o.extend(u[0], o.Event.prototype), u.slice(1), this)
                        }), r.stopImmediatePropagation())
                    }
                })
            }
            o.removeEvent = function(e, t, n) {
                e.removeEventListener && e.removeEventListener(t, n)
            }, o.Event = function(e, t) {
                if (!(this instanceof o.Event)) return new o.Event(e, t);
                e && e.type ? (this.originalEvent = e, this.type = e.type, this.isDefaultPrevented = e.defaultPrevented || e.defaultPrevented === void 0 && e.returnValue === !1 ? Qe : Je, this.target = e.target && e.target.nodeType === 3 ? e.target.parentNode : e.target, this.currentTarget = e.currentTarget, this.relatedTarget = e.relatedTarget) : this.type = e, t && o.extend(this, t), this.timeStamp = e && e.timeStamp || Date.now(), this[o.expando] = !0
            }, o.Event.prototype = {
                constructor: o.Event,
                isDefaultPrevented: Je,
                isPropagationStopped: Je,
                isImmediatePropagationStopped: Je,
                isSimulated: !1,
                preventDefault: function() {
                    var e = this.originalEvent;
                    this.isDefaultPrevented = Qe, e && !this.isSimulated && e.preventDefault()
                },
                stopPropagation: function() {
                    var e = this.originalEvent;
                    this.isPropagationStopped = Qe, e && !this.isSimulated && e.stopPropagation()
                },
                stopImmediatePropagation: function() {
                    var e = this.originalEvent;
                    this.isImmediatePropagationStopped = Qe, e && !this.isSimulated && e.stopImmediatePropagation(), this.stopPropagation()
                }
            }, o.each({
                altKey: !0,
                bubbles: !0,
                cancelable: !0,
                changedTouches: !0,
                ctrlKey: !0,
                detail: !0,
                eventPhase: !0,
                metaKey: !0,
                pageX: !0,
                pageY: !0,
                shiftKey: !0,
                view: !0,
                char: !0,
                code: !0,
                charCode: !0,
                key: !0,
                keyCode: !0,
                button: !0,
                buttons: !0,
                clientX: !0,
                clientY: !0,
                offsetX: !0,
                offsetY: !0,
                pointerId: !0,
                pointerType: !0,
                screenX: !0,
                screenY: !0,
                targetTouches: !0,
                toElement: !0,
                touches: !0,
                which: !0
            }, o.event.addProp), o.each({
                focus: "focusin",
                blur: "focusout"
            }, function(e, t) {
                o.event.special[e] = {
                    setup: function() {
                        return yt(this, e, fn), !1
                    },
                    trigger: function() {
                        return yt(this, e), !0
                    },
                    _default: function(n) {
                        return I.get(n.target, e)
                    },
                    delegateType: t
                }
            }), o.each({
                mouseenter: "mouseover",
                mouseleave: "mouseout",
                pointerenter: "pointerover",
                pointerleave: "pointerout"
            }, function(e, t) {
                o.event.special[e] = {
                    delegateType: t,
                    bindType: t,
                    handle: function(n) {
                        var r, a = this,
                            l = n.relatedTarget,
                            u = n.handleObj;
                        return (!l || l !== a && !o.contains(a, l)) && (n.type = u.origType, r = u.handler.apply(this, arguments), n.type = t), r
                    }
                }
            }), o.fn.extend({
                on: function(e, t, n, r) {
                    return Ot(this, e, t, n, r)
                },
                one: function(e, t, n, r) {
                    return Ot(this, e, t, n, r, 1)
                },
                off: function(e, t, n) {
                    var r, a;
                    if (e && e.preventDefault && e.handleObj) return r = e.handleObj, o(e.delegateTarget).off(r.namespace ? r.origType + "." + r.namespace : r.origType, r.selector, r.handler), this;
                    if (typeof e == "object") {
                        for (a in e) this.off(a, t, e[a]);
                        return this
                    }
                    return (t === !1 || typeof t == "function") && (n = t, t = void 0), n === !1 && (n = Je), this.each(function() {
                        o.event.remove(this, e, n, t)
                    })
                }
            });
            var dn = /<script|<style|<link/i,
                pn = /checked\s*(?:[^=]|=\s*.checked.)/i,
                hn = /^\s*<!\[CDATA\[|\]\]>\s*$/g;

            function hi(e, t) {
                return we(e, "table") && we(t.nodeType !== 11 ? t : t.firstChild, "tr") && o(e).children("tbody")[0] || e
            }

            function gn(e) {
                return e.type = (e.getAttribute("type") !== null) + "/" + e.type, e
            }

            function yn(e) {
                return (e.type || "").slice(0, 5) === "true/" ? e.type = e.type.slice(5) : e.removeAttribute("type"), e
            }

            function gi(e, t) {
                var n, r, a, l, u, g, d;
                if (t.nodeType === 1) {
                    if (I.hasData(e) && (l = I.get(e), d = l.events, d)) {
                        I.remove(t, "handle events");
                        for (a in d)
                            for (n = 0, r = d[a].length; n < r; n++) o.event.add(t, a, d[a][n])
                    }
                    ue.hasData(e) && (u = ue.access(e), g = o.extend({}, u), ue.set(t, g))
                }
            }

            function vn(e, t) {
                var n = t.nodeName.toLowerCase();
                n === "input" && nt.test(e.type) ? t.checked = e.checked : (n === "input" || n === "textarea") && (t.defaultValue = e.defaultValue)
            }

            function Ke(e, t, n, r) {
                t = c(t);
                var a, l, u, g, d, w, k = 0,
                    E = e.length,
                    b = E - 1,
                    C = t[0],
                    P = q(C);
                if (P || E > 1 && typeof C == "string" && !X.checkClone && pn.test(C)) return e.each(function(B) {
                    var _ = e.eq(B);
                    P && (t[0] = C.call(this, B, _.html())), Ke(_, t, n, r)
                });
                if (E && (a = di(t, e[0].ownerDocument, !1, e, r), l = a.firstChild, a.childNodes.length === 1 && (a = l), l || r)) {
                    for (u = o.map(fe(a, "script"), gn), g = u.length; k < E; k++) d = a, k !== b && (d = o.clone(d, !0, !0), g && o.merge(u, fe(d, "script"))), n.call(e[k], d, k);
                    if (g)
                        for (w = u[u.length - 1].ownerDocument, o.map(u, yn), k = 0; k < g; k++) d = u[k], ci.test(d.type || "") && !I.access(d, "globalEval") && o.contains(w, d) && (d.src && (d.type || "").toLowerCase() !== "module" ? o._evalUrl && !d.noModule && o._evalUrl(d.src, {
                            nonce: d.nonce || d.getAttribute("nonce")
                        }, w) : Be(d.textContent.replace(hn, ""), d, w))
                }
                return e
            }

            function yi(e, t, n) {
                for (var r, a = t ? o.filter(t, e) : e, l = 0;
                    (r = a[l]) != null; l++) !n && r.nodeType === 1 && o.cleanData(fe(r)), r.parentNode && (n && Ve(r) && Nt(fe(r, "script")), r.parentNode.removeChild(r));
                return e
            }
            o.extend({
                htmlPrefilter: function(e) {
                    return e
                },
                clone: function(e, t, n) {
                    var r, a, l, u, g = e.cloneNode(!0),
                        d = Ve(e);
                    if (!X.noCloneChecked && (e.nodeType === 1 || e.nodeType === 11) && !o.isXMLDoc(e))
                        for (u = fe(g), l = fe(e), r = 0, a = l.length; r < a; r++) vn(l[r], u[r]);
                    if (t)
                        if (n)
                            for (l = l || fe(e), u = u || fe(g), r = 0, a = l.length; r < a; r++) gi(l[r], u[r]);
                        else gi(e, g);
                    return u = fe(g, "script"), u.length > 0 && Nt(u, !d && fe(e, "script")), g
                },
                cleanData: function(e) {
                    for (var t, n, r, a = o.event.special, l = 0;
                        (n = e[l]) !== void 0; l++)
                        if (et(n)) {
                            if (t = n[I.expando]) {
                                if (t.events)
                                    for (r in t.events) a[r] ? o.event.remove(n, r) : o.removeEvent(n, r, t.handle);
                                n[I.expando] = void 0
                            }
                            n[ue.expando] && (n[ue.expando] = void 0)
                        }
                }
            }), o.fn.extend({
                detach: function(e) {
                    return yi(this, e, !0)
                },
                remove: function(e) {
                    return yi(this, e)
                },
                text: function(e) {
                    return Ee(this, function(t) {
                        return t === void 0 ? o.text(this) : this.empty().each(function() {
                            (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) && (this.textContent = t)
                        })
                    }, null, e, arguments.length)
                },
                append: function() {
                    return Ke(this, arguments, function(e) {
                        if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                            var t = hi(this, e);
                            t.appendChild(e)
                        }
                    })
                },
                prepend: function() {
                    return Ke(this, arguments, function(e) {
                        if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                            var t = hi(this, e);
                            t.insertBefore(e, t.firstChild)
                        }
                    })
                },
                before: function() {
                    return Ke(this, arguments, function(e) {
                        this.parentNode && this.parentNode.insertBefore(e, this)
                    })
                },
                after: function() {
                    return Ke(this, arguments, function(e) {
                        this.parentNode && this.parentNode.insertBefore(e, this.nextSibling)
                    })
                },
                empty: function() {
                    for (var e, t = 0;
                        (e = this[t]) != null; t++) e.nodeType === 1 && (o.cleanData(fe(e, !1)), e.textContent = "");
                    return this
                },
                clone: function(e, t) {
                    return e = e == null ? !1 : e, t = t == null ? e : t, this.map(function() {
                        return o.clone(this, e, t)
                    })
                },
                html: function(e) {
                    return Ee(this, function(t) {
                        var n = this[0] || {},
                            r = 0,
                            a = this.length;
                        if (t === void 0 && n.nodeType === 1) return n.innerHTML;
                        if (typeof t == "string" && !dn.test(t) && !be[(fi.exec(t) || ["", ""])[1].toLowerCase()]) {
                            t = o.htmlPrefilter(t);
                            try {
                                for (; r < a; r++) n = this[r] || {}, n.nodeType === 1 && (o.cleanData(fe(n, !1)), n.innerHTML = t);
                                n = 0
                            } catch {}
                        }
                        n && this.empty().append(t)
                    }, null, e, arguments.length)
                },
                replaceWith: function() {
                    var e = [];
                    return Ke(this, arguments, function(t) {
                        var n = this.parentNode;
                        o.inArray(this, e) < 0 && (o.cleanData(fe(this)), n && n.replaceChild(t, this))
                    }, e)
                }
            }), o.each({
                appendTo: "append",
                prependTo: "prepend",
                insertBefore: "before",
                insertAfter: "after",
                replaceAll: "replaceWith"
            }, function(e, t) {
                o.fn[e] = function(n) {
                    for (var r, a = [], l = o(n), u = l.length - 1, g = 0; g <= u; g++) r = g === u ? this : this.clone(!0), o(l[g])[t](r), h.apply(a, r.get());
                    return this.pushStack(a)
                }
            });
            var Ht = new RegExp("^(" + ai + ")(?!px)[a-z%]+$", "i"),
                jt = /^--/,
                vt = function(e) {
                    var t = e.ownerDocument.defaultView;
                    return (!t || !t.opener) && (t = H), t.getComputedStyle(e)
                },
                vi = function(e, t, n) {
                    var r, a, l = {};
                    for (a in t) l[a] = e.style[a], e.style[a] = t[a];
                    r = n.call(e);
                    for (a in t) e.style[a] = l[a];
                    return r
                },
                mn = new RegExp($e.join("|"), "i"),
                mi = "[\\x20\\t\\r\\n\\f]",
                wn = new RegExp("^" + mi + "+|((?:^|[^\\\\])(?:\\\\.)*)" + mi + "+$", "g");
            (function() {
                function e() {
                    if (!!w) {
                        d.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0", w.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%", Pe.appendChild(d).appendChild(w);
                        var k = H.getComputedStyle(w);
                        n = k.top !== "1%", g = t(k.marginLeft) === 12, w.style.right = "60%", l = t(k.right) === 36, r = t(k.width) === 36, w.style.position = "absolute", a = t(w.offsetWidth / 3) === 12, Pe.removeChild(d), w = null
                    }
                }

                function t(k) {
                    return Math.round(parseFloat(k))
                }
                var n, r, a, l, u, g, d = U.createElement("div"),
                    w = U.createElement("div");
                !w.style || (w.style.backgroundClip = "content-box", w.cloneNode(!0).style.backgroundClip = "", X.clearCloneStyle = w.style.backgroundClip === "content-box", o.extend(X, {
                    boxSizingReliable: function() {
                        return e(), r
                    },
                    pixelBoxStyles: function() {
                        return e(), l
                    },
                    pixelPosition: function() {
                        return e(), n
                    },
                    reliableMarginLeft: function() {
                        return e(), g
                    },
                    scrollboxSize: function() {
                        return e(), a
                    },
                    reliableTrDimensions: function() {
                        var k, E, b, C;
                        return u == null && (k = U.createElement("table"), E = U.createElement("tr"), b = U.createElement("div"), k.style.cssText = "position:absolute;left:-11111px;border-collapse:separate", E.style.cssText = "border:1px solid", E.style.height = "1px", b.style.height = "9px", b.style.display = "block", Pe.appendChild(k).appendChild(E).appendChild(b), C = H.getComputedStyle(E), u = parseInt(C.height, 10) + parseInt(C.borderTopWidth, 10) + parseInt(C.borderBottomWidth, 10) === E.offsetHeight, Pe.removeChild(k)), u
                    }
                }))
            })();

            function rt(e, t, n) {
                var r, a, l, u, g = jt.test(t),
                    d = e.style;
                return n = n || vt(e), n && (u = n.getPropertyValue(t) || n[t], g && (u = u.replace(wn, "$1")), u === "" && !Ve(e) && (u = o.style(e, t)), !X.pixelBoxStyles() && Ht.test(u) && mn.test(t) && (r = d.width, a = d.minWidth, l = d.maxWidth, d.minWidth = d.maxWidth = d.width = u, u = n.width, d.width = r, d.minWidth = a, d.maxWidth = l)), u !== void 0 ? u + "" : u
            }

            function wi(e, t) {
                return {
                    get: function() {
                        if (e()) {
                            delete this.get;
                            return
                        }
                        return (this.get = t).apply(this, arguments)
                    }
                }
            }
            var bi = ["Webkit", "Moz", "ms"],
                Ti = U.createElement("div").style,
                ki = {};

            function bn(e) {
                for (var t = e[0].toUpperCase() + e.slice(1), n = bi.length; n--;)
                    if (e = bi[n] + t, e in Ti) return e
            }

            function Pt(e) {
                var t = o.cssProps[e] || ki[e];
                return t || (e in Ti ? e : ki[e] = bn(e) || e)
            }
            var Tn = /^(none|table(?!-c[ea]).+)/,
                kn = {
                    position: "absolute",
                    visibility: "hidden",
                    display: "block"
                },
                Si = {
                    letterSpacing: "0",
                    fontWeight: "400"
                };

            function Ci(e, t, n) {
                var r = it.exec(t);
                return r ? Math.max(0, r[2] - (n || 0)) + (r[3] || "px") : t
            }

            function _t(e, t, n, r, a, l) {
                var u = t === "width" ? 1 : 0,
                    g = 0,
                    d = 0;
                if (n === (r ? "border" : "content")) return 0;
                for (; u < 4; u += 2) n === "margin" && (d += o.css(e, n + $e[u], !0, a)), r ? (n === "content" && (d -= o.css(e, "padding" + $e[u], !0, a)), n !== "margin" && (d -= o.css(e, "border" + $e[u] + "Width", !0, a))) : (d += o.css(e, "padding" + $e[u], !0, a), n !== "padding" ? d += o.css(e, "border" + $e[u] + "Width", !0, a) : g += o.css(e, "border" + $e[u] + "Width", !0, a));
                return !r && l >= 0 && (d += Math.max(0, Math.ceil(e["offset" + t[0].toUpperCase() + t.slice(1)] - l - d - g - .5)) || 0), d
            }

            function xi(e, t, n) {
                var r = vt(e),
                    a = !X.boxSizingReliable() || n,
                    l = a && o.css(e, "boxSizing", !1, r) === "border-box",
                    u = l,
                    g = rt(e, t, r),
                    d = "offset" + t[0].toUpperCase() + t.slice(1);
                if (Ht.test(g)) {
                    if (!n) return g;
                    g = "auto"
                }
                return (!X.boxSizingReliable() && l || !X.reliableTrDimensions() && we(e, "tr") || g === "auto" || !parseFloat(g) && o.css(e, "display", !1, r) === "inline") && e.getClientRects().length && (l = o.css(e, "boxSizing", !1, r) === "border-box", u = d in e, u && (g = e[d])), g = parseFloat(g) || 0, g + _t(e, t, n || (l ? "border" : "content"), u, r, g) + "px"
            }
            o.extend({
                cssHooks: {
                    opacity: {
                        get: function(e, t) {
                            if (t) {
                                var n = rt(e, "opacity");
                                return n === "" ? "1" : n
                            }
                        }
                    }
                },
                cssNumber: {
                    animationIterationCount: !0,
                    columnCount: !0,
                    fillOpacity: !0,
                    flexGrow: !0,
                    flexShrink: !0,
                    fontWeight: !0,
                    gridArea: !0,
                    gridColumn: !0,
                    gridColumnEnd: !0,
                    gridColumnStart: !0,
                    gridRow: !0,
                    gridRowEnd: !0,
                    gridRowStart: !0,
                    lineHeight: !0,
                    opacity: !0,
                    order: !0,
                    orphans: !0,
                    widows: !0,
                    zIndex: !0,
                    zoom: !0
                },
                cssProps: {},
                style: function(e, t, n, r) {
                    if (!(!e || e.nodeType === 3 || e.nodeType === 8 || !e.style)) {
                        var a, l, u, g = Ae(t),
                            d = jt.test(t),
                            w = e.style;
                        if (d || (t = Pt(g)), u = o.cssHooks[t] || o.cssHooks[g], n !== void 0) {
                            if (l = typeof n, l === "string" && (a = it.exec(n)) && a[1] && (n = li(e, t, a), l = "number"), n == null || n !== n) return;
                            l === "number" && !d && (n += a && a[3] || (o.cssNumber[g] ? "" : "px")), !X.clearCloneStyle && n === "" && t.indexOf("background") === 0 && (w[t] = "inherit"), (!u || !("set" in u) || (n = u.set(e, n, r)) !== void 0) && (d ? w.setProperty(t, n) : w[t] = n)
                        } else return u && "get" in u && (a = u.get(e, !1, r)) !== void 0 ? a : w[t]
                    }
                },
                css: function(e, t, n, r) {
                    var a, l, u, g = Ae(t),
                        d = jt.test(t);
                    return d || (t = Pt(g)), u = o.cssHooks[t] || o.cssHooks[g], u && "get" in u && (a = u.get(e, !0, n)), a === void 0 && (a = rt(e, t, r)), a === "normal" && t in Si && (a = Si[t]), n === "" || n ? (l = parseFloat(a), n === !0 || isFinite(l) ? l || 0 : a) : a
                }
            }), o.each(["height", "width"], function(e, t) {
                o.cssHooks[t] = {
                    get: function(n, r, a) {
                        if (r) return Tn.test(o.css(n, "display")) && (!n.getClientRects().length || !n.getBoundingClientRect().width) ? vi(n, kn, function() {
                            return xi(n, t, a)
                        }) : xi(n, t, a)
                    },
                    set: function(n, r, a) {
                        var l, u = vt(n),
                            g = !X.scrollboxSize() && u.position === "absolute",
                            d = g || a,
                            w = d && o.css(n, "boxSizing", !1, u) === "border-box",
                            k = a ? _t(n, t, a, w, u) : 0;
                        return w && g && (k -= Math.ceil(n["offset" + t[0].toUpperCase() + t.slice(1)] - parseFloat(u[t]) - _t(n, t, "border", !1, u) - .5)), k && (l = it.exec(r)) && (l[3] || "px") !== "px" && (n.style[t] = r, r = o.css(n, t)), Ci(n, r, k)
                    }
                }
            }), o.cssHooks.marginLeft = wi(X.reliableMarginLeft, function(e, t) {
                if (t) return (parseFloat(rt(e, "marginLeft")) || e.getBoundingClientRect().left - vi(e, {
                    marginLeft: 0
                }, function() {
                    return e.getBoundingClientRect().left
                })) + "px"
            }), o.each({
                margin: "",
                padding: "",
                border: "Width"
            }, function(e, t) {
                o.cssHooks[e + t] = {
                    expand: function(n) {
                        for (var r = 0, a = {}, l = typeof n == "string" ? n.split(" ") : [n]; r < 4; r++) a[e + $e[r] + t] = l[r] || l[r - 2] || l[0];
                        return a
                    }
                }, e !== "margin" && (o.cssHooks[e + t].set = Ci)
            }), o.fn.extend({
                css: function(e, t) {
                    return Ee(this, function(n, r, a) {
                        var l, u, g = {},
                            d = 0;
                        if (Array.isArray(r)) {
                            for (l = vt(n), u = r.length; d < u; d++) g[r[d]] = o.css(n, r[d], !1, l);
                            return g
                        }
                        return a !== void 0 ? o.style(n, r, a) : o.css(n, r)
                    }, e, t, arguments.length > 1)
                }
            });

            function ce(e, t, n, r, a) {
                return new ce.prototype.init(e, t, n, r, a)
            }
            o.Tween = ce, ce.prototype = {
                constructor: ce,
                init: function(e, t, n, r, a, l) {
                    this.elem = e, this.prop = n, this.easing = a || o.easing._default, this.options = t, this.start = this.now = this.cur(), this.end = r, this.unit = l || (o.cssNumber[n] ? "" : "px")
                },
                cur: function() {
                    var e = ce.propHooks[this.prop];
                    return e && e.get ? e.get(this) : ce.propHooks._default.get(this)
                },
                run: function(e) {
                    var t, n = ce.propHooks[this.prop];
                    return this.options.duration ? this.pos = t = o.easing[this.easing](e, this.options.duration * e, 0, 1, this.options.duration) : this.pos = t = e, this.now = (this.end - this.start) * t + this.start, this.options.step && this.options.step.call(this.elem, this.now, this), n && n.set ? n.set(this) : ce.propHooks._default.set(this), this
                }
            }, ce.prototype.init.prototype = ce.prototype, ce.propHooks = {
                _default: {
                    get: function(e) {
                        var t;
                        return e.elem.nodeType !== 1 || e.elem[e.prop] != null && e.elem.style[e.prop] == null ? e.elem[e.prop] : (t = o.css(e.elem, e.prop, ""), !t || t === "auto" ? 0 : t)
                    },
                    set: function(e) {
                        o.fx.step[e.prop] ? o.fx.step[e.prop](e) : e.elem.nodeType === 1 && (o.cssHooks[e.prop] || e.elem.style[Pt(e.prop)] != null) ? o.style(e.elem, e.prop, e.now + e.unit) : e.elem[e.prop] = e.now
                    }
                }
            }, ce.propHooks.scrollTop = ce.propHooks.scrollLeft = {
                set: function(e) {
                    e.elem.nodeType && e.elem.parentNode && (e.elem[e.prop] = e.now)
                }
            }, o.easing = {
                linear: function(e) {
                    return e
                },
                swing: function(e) {
                    return .5 - Math.cos(e * Math.PI) / 2
                },
                _default: "swing"
            }, o.fx = ce.prototype.init, o.fx.step = {};
            var Ze, mt, Sn = /^(?:toggle|show|hide)$/,
                Cn = /queueHooks$/;

            function qt() {
                mt && (U.hidden === !1 && H.requestAnimationFrame ? H.requestAnimationFrame(qt) : H.setTimeout(qt, o.fx.interval), o.fx.tick())
            }

            function Ai() {
                return H.setTimeout(function() {
                    Ze = void 0
                }), Ze = Date.now()
            }

            function wt(e, t) {
                var n, r = 0,
                    a = {
                        height: e
                    };
                for (t = t ? 1 : 0; r < 4; r += 2 - t) n = $e[r], a["margin" + n] = a["padding" + n] = e;
                return t && (a.opacity = a.width = e), a
            }

            function Ei(e, t, n) {
                for (var r, a = (ke.tweeners[t] || []).concat(ke.tweeners["*"]), l = 0, u = a.length; l < u; l++)
                    if (r = a[l].call(n, t, e)) return r
            }

            function xn(e, t, n) {
                var r, a, l, u, g, d, w, k, E = "width" in t || "height" in t,
                    b = this,
                    C = {},
                    P = e.style,
                    B = e.nodeType && gt(e),
                    _ = I.get(e, "fxshow");
                n.queue || (u = o._queueHooks(e, "fx"), u.unqueued == null && (u.unqueued = 0, g = u.empty.fire, u.empty.fire = function() {
                    u.unqueued || g()
                }), u.unqueued++, b.always(function() {
                    b.always(function() {
                        u.unqueued--, o.queue(e, "fx").length || u.empty.fire()
                    })
                }));
                for (r in t)
                    if (a = t[r], Sn.test(a)) {
                        if (delete t[r], l = l || a === "toggle", a === (B ? "hide" : "show"))
                            if (a === "show" && _ && _[r] !== void 0) B = !0;
                            else continue;
                        C[r] = _ && _[r] || o.style(e, r)
                    }
                if (d = !o.isEmptyObject(t), !(!d && o.isEmptyObject(C))) {
                    E && e.nodeType === 1 && (n.overflow = [P.overflow, P.overflowX, P.overflowY], w = _ && _.display, w == null && (w = I.get(e, "display")), k = o.css(e, "display"), k === "none" && (w ? k = w : (Ge([e], !0), w = e.style.display || w, k = o.css(e, "display"), Ge([e]))), (k === "inline" || k === "inline-block" && w != null) && o.css(e, "float") === "none" && (d || (b.done(function() {
                        P.display = w
                    }), w == null && (k = P.display, w = k === "none" ? "" : k)), P.display = "inline-block")), n.overflow && (P.overflow = "hidden", b.always(function() {
                        P.overflow = n.overflow[0], P.overflowX = n.overflow[1], P.overflowY = n.overflow[2]
                    })), d = !1;
                    for (r in C) d || (_ ? "hidden" in _ && (B = _.hidden) : _ = I.access(e, "fxshow", {
                        display: w
                    }), l && (_.hidden = !B), B && Ge([e], !0), b.done(function() {
                        B || Ge([e]), I.remove(e, "fxshow");
                        for (r in C) o.style(e, r, C[r])
                    })), d = Ei(B ? _[r] : 0, r, b), r in _ || (_[r] = d.start, B && (d.end = d.start, d.start = 0))
                }
            }

            function An(e, t) {
                var n, r, a, l, u;
                for (n in e)
                    if (r = Ae(n), a = t[r], l = e[n], Array.isArray(l) && (a = l[1], l = e[n] = l[0]), n !== r && (e[r] = l, delete e[n]), u = o.cssHooks[r], u && "expand" in u) {
                        l = u.expand(l), delete e[r];
                        for (n in l) n in e || (e[n] = l[n], t[n] = a)
                    } else t[r] = a
            }

            function ke(e, t, n) {
                var r, a, l = 0,
                    u = ke.prefilters.length,
                    g = o.Deferred().always(function() {
                        delete d.elem
                    }),
                    d = function() {
                        if (a) return !1;
                        for (var E = Ze || Ai(), b = Math.max(0, w.startTime + w.duration - E), C = b / w.duration || 0, P = 1 - C, B = 0, _ = w.tweens.length; B < _; B++) w.tweens[B].run(P);
                        return g.notifyWith(e, [w, P, b]), P < 1 && _ ? b : (_ || g.notifyWith(e, [w, 1, 0]), g.resolveWith(e, [w]), !1)
                    },
                    w = g.promise({
                        elem: e,
                        props: o.extend({}, t),
                        opts: o.extend(!0, {
                            specialEasing: {},
                            easing: o.easing._default
                        }, n),
                        originalProperties: t,
                        originalOptions: n,
                        startTime: Ze || Ai(),
                        duration: n.duration,
                        tweens: [],
                        createTween: function(E, b) {
                            var C = o.Tween(e, w.opts, E, b, w.opts.specialEasing[E] || w.opts.easing);
                            return w.tweens.push(C), C
                        },
                        stop: function(E) {
                            var b = 0,
                                C = E ? w.tweens.length : 0;
                            if (a) return this;
                            for (a = !0; b < C; b++) w.tweens[b].run(1);
                            return E ? (g.notifyWith(e, [w, 1, 0]), g.resolveWith(e, [w, E])) : g.rejectWith(e, [w, E]), this
                        }
                    }),
                    k = w.props;
                for (An(k, w.opts.specialEasing); l < u; l++)
                    if (r = ke.prefilters[l].call(w, e, k, w.opts), r) return q(r.stop) && (o._queueHooks(w.elem, w.opts.queue).stop = r.stop.bind(r)), r;
                return o.map(k, Ei, w), q(w.opts.start) && w.opts.start.call(e, w), w.progress(w.opts.progress).done(w.opts.done, w.opts.complete).fail(w.opts.fail).always(w.opts.always), o.fx.timer(o.extend(d, {
                    elem: e,
                    anim: w,
                    queue: w.opts.queue
                })), w
            }
            o.Animation = o.extend(ke, {
                    tweeners: {
                        "*": [function(e, t) {
                            var n = this.createTween(e, t);
                            return li(n.elem, e, it.exec(t), n), n
                        }]
                    },
                    tweener: function(e, t) {
                        q(e) ? (t = e, e = ["*"]) : e = e.match(xe);
                        for (var n, r = 0, a = e.length; r < a; r++) n = e[r], ke.tweeners[n] = ke.tweeners[n] || [], ke.tweeners[n].unshift(t)
                    },
                    prefilters: [xn],
                    prefilter: function(e, t) {
                        t ? ke.prefilters.unshift(e) : ke.prefilters.push(e)
                    }
                }), o.speed = function(e, t, n) {
                    var r = e && typeof e == "object" ? o.extend({}, e) : {
                        complete: n || !n && t || q(e) && e,
                        duration: e,
                        easing: n && t || t && !q(t) && t
                    };
                    return o.fx.off ? r.duration = 0 : typeof r.duration != "number" && (r.duration in o.fx.speeds ? r.duration = o.fx.speeds[r.duration] : r.duration = o.fx.speeds._default), (r.queue == null || r.queue === !0) && (r.queue = "fx"), r.old = r.complete, r.complete = function() {
                        q(r.old) && r.old.call(this), r.queue && o.dequeue(this, r.queue)
                    }, r
                }, o.fn.extend({
                    fadeTo: function(e, t, n, r) {
                        return this.filter(gt).css("opacity", 0).show().end().animate({
                            opacity: t
                        }, e, n, r)
                    },
                    animate: function(e, t, n, r) {
                        var a = o.isEmptyObject(e),
                            l = o.speed(t, n, r),
                            u = function() {
                                var g = ke(this, o.extend({}, e), l);
                                (a || I.get(this, "finish")) && g.stop(!0)
                            };
                        return u.finish = u, a || l.queue === !1 ? this.each(u) : this.queue(l.queue, u)
                    },
                    stop: function(e, t, n) {
                        var r = function(a) {
                            var l = a.stop;
                            delete a.stop, l(n)
                        };
                        return typeof e != "string" && (n = t, t = e, e = void 0), t && this.queue(e || "fx", []), this.each(function() {
                            var a = !0,
                                l = e != null && e + "queueHooks",
                                u = o.timers,
                                g = I.get(this);
                            if (l) g[l] && g[l].stop && r(g[l]);
                            else
                                for (l in g) g[l] && g[l].stop && Cn.test(l) && r(g[l]);
                            for (l = u.length; l--;) u[l].elem === this && (e == null || u[l].queue === e) && (u[l].anim.stop(n), a = !1, u.splice(l, 1));
                            (a || !n) && o.dequeue(this, e)
                        })
                    },
                    finish: function(e) {
                        return e !== !1 && (e = e || "fx"), this.each(function() {
                            var t, n = I.get(this),
                                r = n[e + "queue"],
                                a = n[e + "queueHooks"],
                                l = o.timers,
                                u = r ? r.length : 0;
                            for (n.finish = !0, o.queue(this, e, []), a && a.stop && a.stop.call(this, !0), t = l.length; t--;) l[t].elem === this && l[t].queue === e && (l[t].anim.stop(!0), l.splice(t, 1));
                            for (t = 0; t < u; t++) r[t] && r[t].finish && r[t].finish.call(this);
                            delete n.finish
                        })
                    }
                }), o.each(["toggle", "show", "hide"], function(e, t) {
                    var n = o.fn[t];
                    o.fn[t] = function(r, a, l) {
                        return r == null || typeof r == "boolean" ? n.apply(this, arguments) : this.animate(wt(t, !0), r, a, l)
                    }
                }), o.each({
                    slideDown: wt("show"),
                    slideUp: wt("hide"),
                    slideToggle: wt("toggle"),
                    fadeIn: {
                        opacity: "show"
                    },
                    fadeOut: {
                        opacity: "hide"
                    },
                    fadeToggle: {
                        opacity: "toggle"
                    }
                }, function(e, t) {
                    o.fn[e] = function(n, r, a) {
                        return this.animate(t, n, r, a)
                    }
                }), o.timers = [], o.fx.tick = function() {
                    var e, t = 0,
                        n = o.timers;
                    for (Ze = Date.now(); t < n.length; t++) e = n[t], !e() && n[t] === e && n.splice(t--, 1);
                    n.length || o.fx.stop(), Ze = void 0
                }, o.fx.timer = function(e) {
                    o.timers.push(e), o.fx.start()
                }, o.fx.interval = 13, o.fx.start = function() {
                    mt || (mt = !0, qt())
                }, o.fx.stop = function() {
                    mt = null
                }, o.fx.speeds = {
                    slow: 600,
                    fast: 200,
                    _default: 400
                }, o.fn.delay = function(e, t) {
                    return e = o.fx && o.fx.speeds[e] || e, t = t || "fx", this.queue(t, function(n, r) {
                        var a = H.setTimeout(n, e);
                        r.stop = function() {
                            H.clearTimeout(a)
                        }
                    })
                },
                function() {
                    var e = U.createElement("input"),
                        t = U.createElement("select"),
                        n = t.appendChild(U.createElement("option"));
                    e.type = "checkbox", X.checkOn = e.value !== "", X.optSelected = n.selected, e = U.createElement("input"), e.value = "t", e.type = "radio", X.radioValue = e.value === "t"
                }();
            var $i, st = o.expr.attrHandle;
            o.fn.extend({
                attr: function(e, t) {
                    return Ee(this, o.attr, e, t, arguments.length > 1)
                },
                removeAttr: function(e) {
                    return this.each(function() {
                        o.removeAttr(this, e)
                    })
                }
            }), o.extend({
                attr: function(e, t, n) {
                    var r, a, l = e.nodeType;
                    if (!(l === 3 || l === 8 || l === 2)) {
                        if (typeof e.getAttribute == "undefined") return o.prop(e, t, n);
                        if ((l !== 1 || !o.isXMLDoc(e)) && (a = o.attrHooks[t.toLowerCase()] || (o.expr.match.bool.test(t) ? $i : void 0)), n !== void 0) {
                            if (n === null) {
                                o.removeAttr(e, t);
                                return
                            }
                            return a && "set" in a && (r = a.set(e, n, t)) !== void 0 ? r : (e.setAttribute(t, n + ""), n)
                        }
                        return a && "get" in a && (r = a.get(e, t)) !== null ? r : (r = o.find.attr(e, t), r == null ? void 0 : r)
                    }
                },
                attrHooks: {
                    type: {
                        set: function(e, t) {
                            if (!X.radioValue && t === "radio" && we(e, "input")) {
                                var n = e.value;
                                return e.setAttribute("type", t), n && (e.value = n), t
                            }
                        }
                    }
                },
                removeAttr: function(e, t) {
                    var n, r = 0,
                        a = t && t.match(xe);
                    if (a && e.nodeType === 1)
                        for (; n = a[r++];) e.removeAttribute(n)
                }
            }), $i = {
                set: function(e, t, n) {
                    return t === !1 ? o.removeAttr(e, n) : e.setAttribute(n, n), n
                }
            }, o.each(o.expr.match.bool.source.match(/\w+/g), function(e, t) {
                var n = st[t] || o.find.attr;
                st[t] = function(r, a, l) {
                    var u, g, d = a.toLowerCase();
                    return l || (g = st[d], st[d] = u, u = n(r, a, l) != null ? d : null, st[d] = g), u
                }
            });
            var En = /^(?:input|select|textarea|button)$/i,
                $n = /^(?:a|area)$/i;
            o.fn.extend({
                prop: function(e, t) {
                    return Ee(this, o.prop, e, t, arguments.length > 1)
                },
                removeProp: function(e) {
                    return this.each(function() {
                        delete this[o.propFix[e] || e]
                    })
                }
            }), o.extend({
                prop: function(e, t, n) {
                    var r, a, l = e.nodeType;
                    if (!(l === 3 || l === 8 || l === 2)) return (l !== 1 || !o.isXMLDoc(e)) && (t = o.propFix[t] || t, a = o.propHooks[t]), n !== void 0 ? a && "set" in a && (r = a.set(e, n, t)) !== void 0 ? r : e[t] = n : a && "get" in a && (r = a.get(e, t)) !== null ? r : e[t]
                },
                propHooks: {
                    tabIndex: {
                        get: function(e) {
                            var t = o.find.attr(e, "tabindex");
                            return t ? parseInt(t, 10) : En.test(e.nodeName) || $n.test(e.nodeName) && e.href ? 0 : -1
                        }
                    }
                },
                propFix: {
                    for: "htmlFor",
                    class: "className"
                }
            }), X.optSelected || (o.propHooks.selected = {
                get: function(e) {
                    var t = e.parentNode;
                    return t && t.parentNode && t.parentNode.selectedIndex, null
                },
                set: function(e) {
                    var t = e.parentNode;
                    t && (t.selectedIndex, t.parentNode && t.parentNode.selectedIndex)
                }
            }), o.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function() {
                o.propFix[this.toLowerCase()] = this
            });

            function _e(e) {
                var t = e.match(xe) || [];
                return t.join(" ")
            }

            function qe(e) {
                return e.getAttribute && e.getAttribute("class") || ""
            }

            function Mt(e) {
                return Array.isArray(e) ? e : typeof e == "string" ? e.match(xe) || [] : []
            }
            o.fn.extend({
                addClass: function(e) {
                    var t, n, r, a, l, u;
                    return q(e) ? this.each(function(g) {
                        o(this).addClass(e.call(this, g, qe(this)))
                    }) : (t = Mt(e), t.length ? this.each(function() {
                        if (r = qe(this), n = this.nodeType === 1 && " " + _e(r) + " ", n) {
                            for (l = 0; l < t.length; l++) a = t[l], n.indexOf(" " + a + " ") < 0 && (n += a + " ");
                            u = _e(n), r !== u && this.setAttribute("class", u)
                        }
                    }) : this)
                },
                removeClass: function(e) {
                    var t, n, r, a, l, u;
                    return q(e) ? this.each(function(g) {
                        o(this).removeClass(e.call(this, g, qe(this)))
                    }) : arguments.length ? (t = Mt(e), t.length ? this.each(function() {
                        if (r = qe(this), n = this.nodeType === 1 && " " + _e(r) + " ", n) {
                            for (l = 0; l < t.length; l++)
                                for (a = t[l]; n.indexOf(" " + a + " ") > -1;) n = n.replace(" " + a + " ", " ");
                            u = _e(n), r !== u && this.setAttribute("class", u)
                        }
                    }) : this) : this.attr("class", "")
                },
                toggleClass: function(e, t) {
                    var n, r, a, l, u = typeof e,
                        g = u === "string" || Array.isArray(e);
                    return q(e) ? this.each(function(d) {
                        o(this).toggleClass(e.call(this, d, qe(this), t), t)
                    }) : typeof t == "boolean" && g ? t ? this.addClass(e) : this.removeClass(e) : (n = Mt(e), this.each(function() {
                        if (g)
                            for (l = o(this), a = 0; a < n.length; a++) r = n[a], l.hasClass(r) ? l.removeClass(r) : l.addClass(r);
                        else(e === void 0 || u === "boolean") && (r = qe(this), r && I.set(this, "__className__", r), this.setAttribute && this.setAttribute("class", r || e === !1 ? "" : I.get(this, "__className__") || ""))
                    }))
                },
                hasClass: function(e) {
                    var t, n, r = 0;
                    for (t = " " + e + " "; n = this[r++];)
                        if (n.nodeType === 1 && (" " + _e(qe(n)) + " ").indexOf(t) > -1) return !0;
                    return !1
                }
            });
            var Dn = /\r/g;
            o.fn.extend({
                val: function(e) {
                    var t, n, r, a = this[0];
                    return arguments.length ? (r = q(e), this.each(function(l) {
                        var u;
                        this.nodeType === 1 && (r ? u = e.call(this, l, o(this).val()) : u = e, u == null ? u = "" : typeof u == "number" ? u += "" : Array.isArray(u) && (u = o.map(u, function(g) {
                            return g == null ? "" : g + ""
                        })), t = o.valHooks[this.type] || o.valHooks[this.nodeName.toLowerCase()], (!t || !("set" in t) || t.set(this, u, "value") === void 0) && (this.value = u))
                    })) : a ? (t = o.valHooks[a.type] || o.valHooks[a.nodeName.toLowerCase()], t && "get" in t && (n = t.get(a, "value")) !== void 0 ? n : (n = a.value, typeof n == "string" ? n.replace(Dn, "") : n == null ? "" : n)) : void 0
                }
            }), o.extend({
                valHooks: {
                    option: {
                        get: function(e) {
                            var t = o.find.attr(e, "value");
                            return t != null ? t : _e(o.text(e))
                        }
                    },
                    select: {
                        get: function(e) {
                            var t, n, r, a = e.options,
                                l = e.selectedIndex,
                                u = e.type === "select-one",
                                g = u ? null : [],
                                d = u ? l + 1 : a.length;
                            for (l < 0 ? r = d : r = u ? l : 0; r < d; r++)
                                if (n = a[r], (n.selected || r === l) && !n.disabled && (!n.parentNode.disabled || !we(n.parentNode, "optgroup"))) {
                                    if (t = o(n).val(), u) return t;
                                    g.push(t)
                                }
                            return g
                        },
                        set: function(e, t) {
                            for (var n, r, a = e.options, l = o.makeArray(t), u = a.length; u--;) r = a[u], (r.selected = o.inArray(o.valHooks.option.get(r), l) > -1) && (n = !0);
                            return n || (e.selectedIndex = -1), l
                        }
                    }
                }
            }), o.each(["radio", "checkbox"], function() {
                o.valHooks[this] = {
                    set: function(e, t) {
                        if (Array.isArray(t)) return e.checked = o.inArray(o(e).val(), t) > -1
                    }
                }, X.checkOn || (o.valHooks[this].get = function(e) {
                    return e.getAttribute("value") === null ? "on" : e.value
                })
            }), X.focusin = "onfocusin" in H;
            var Di = /^(?:focusinfocus|focusoutblur)$/,
                Li = function(e) {
                    e.stopPropagation()
                };
            o.extend(o.event, {
                trigger: function(e, t, n, r) {
                    var a, l, u, g, d, w, k, E, b = [n || U],
                        C = G.call(e, "type") ? e.type : e,
                        P = G.call(e, "namespace") ? e.namespace.split(".") : [];
                    if (l = E = u = n = n || U, !(n.nodeType === 3 || n.nodeType === 8) && !Di.test(C + o.event.triggered) && (C.indexOf(".") > -1 && (P = C.split("."), C = P.shift(), P.sort()), d = C.indexOf(":") < 0 && "on" + C, e = e[o.expando] ? e : new o.Event(C, typeof e == "object" && e), e.isTrigger = r ? 2 : 3, e.namespace = P.join("."), e.rnamespace = e.namespace ? new RegExp("(^|\\.)" + P.join("\\.(?:.*\\.|)") + "(\\.|$)") : null, e.result = void 0, e.target || (e.target = n), t = t == null ? [e] : o.makeArray(t, [e]), k = o.event.special[C] || {}, !(!r && k.trigger && k.trigger.apply(n, t) === !1))) {
                        if (!r && !k.noBubble && !he(n)) {
                            for (g = k.delegateType || C, Di.test(g + C) || (l = l.parentNode); l; l = l.parentNode) b.push(l), u = l;
                            u === (n.ownerDocument || U) && b.push(u.defaultView || u.parentWindow || H)
                        }
                        for (a = 0;
                            (l = b[a++]) && !e.isPropagationStopped();) E = l, e.type = a > 1 ? g : k.bindType || C, w = (I.get(l, "events") || Object.create(null))[e.type] && I.get(l, "handle"), w && w.apply(l, t), w = d && l[d], w && w.apply && et(l) && (e.result = w.apply(l, t), e.result === !1 && e.preventDefault());
                        return e.type = C, !r && !e.isDefaultPrevented() && (!k._default || k._default.apply(b.pop(), t) === !1) && et(n) && d && q(n[C]) && !he(n) && (u = n[d], u && (n[d] = null), o.event.triggered = C, e.isPropagationStopped() && E.addEventListener(C, Li), n[C](), e.isPropagationStopped() && E.removeEventListener(C, Li), o.event.triggered = void 0, u && (n[d] = u)), e.result
                    }
                },
                simulate: function(e, t, n) {
                    var r = o.extend(new o.Event, n, {
                        type: e,
                        isSimulated: !0
                    });
                    o.event.trigger(r, null, t)
                }
            }), o.fn.extend({
                trigger: function(e, t) {
                    return this.each(function() {
                        o.event.trigger(e, t, this)
                    })
                },
                triggerHandler: function(e, t) {
                    var n = this[0];
                    if (n) return o.event.trigger(e, t, n, !0)
                }
            }), X.focusin || o.each({
                focus: "focusin",
                blur: "focusout"
            }, function(e, t) {
                var n = function(r) {
                    o.event.simulate(t, r.target, o.event.fix(r))
                };
                o.event.special[t] = {
                    setup: function() {
                        var r = this.ownerDocument || this.document || this,
                            a = I.access(r, t);
                        a || r.addEventListener(e, n, !0), I.access(r, t, (a || 0) + 1)
                    },
                    teardown: function() {
                        var r = this.ownerDocument || this.document || this,
                            a = I.access(r, t) - 1;
                        a ? I.access(r, t, a) : (r.removeEventListener(e, n, !0), I.remove(r, t))
                    }
                }
            });
            var ot = H.location,
                Ni = {
                    guid: Date.now()
                },
                It = /\?/;
            o.parseXML = function(e) {
                var t, n;
                if (!e || typeof e != "string") return null;
                try {
                    t = new H.DOMParser().parseFromString(e, "text/xml")
                } catch {}
                return n = t && t.getElementsByTagName("parsererror")[0], (!t || n) && o.error("Invalid XML: " + (n ? o.map(n.childNodes, function(r) {
                    return r.textContent
                }).join(`
`) : e)), t
            };
            var Ln = /\[\]$/,
                Oi = /\r?\n/g,
                Nn = /^(?:submit|button|image|reset|file)$/i,
                On = /^(?:input|select|textarea|keygen)/i;

            function zt(e, t, n, r) {
                var a;
                if (Array.isArray(t)) o.each(t, function(l, u) {
                    n || Ln.test(e) ? r(e, u) : zt(e + "[" + (typeof u == "object" && u != null ? l : "") + "]", u, n, r)
                });
                else if (!n && Ue(t) === "object")
                    for (a in t) zt(e + "[" + a + "]", t[a], n, r);
                else r(e, t)
            }
            o.param = function(e, t) {
                var n, r = [],
                    a = function(l, u) {
                        var g = q(u) ? u() : u;
                        r[r.length] = encodeURIComponent(l) + "=" + encodeURIComponent(g == null ? "" : g)
                    };
                if (e == null) return "";
                if (Array.isArray(e) || e.jquery && !o.isPlainObject(e)) o.each(e, function() {
                    a(this.name, this.value)
                });
                else
                    for (n in e) zt(n, e[n], t, a);
                return r.join("&")
            }, o.fn.extend({
                serialize: function() {
                    return o.param(this.serializeArray())
                },
                serializeArray: function() {
                    return this.map(function() {
                        var e = o.prop(this, "elements");
                        return e ? o.makeArray(e) : this
                    }).filter(function() {
                        var e = this.type;
                        return this.name && !o(this).is(":disabled") && On.test(this.nodeName) && !Nn.test(e) && (this.checked || !nt.test(e))
                    }).map(function(e, t) {
                        var n = o(this).val();
                        return n == null ? null : Array.isArray(n) ? o.map(n, function(r) {
                            return {
                                name: t.name,
                                value: r.replace(Oi, `\r
`)
                            }
                        }) : {
                            name: t.name,
                            value: n.replace(Oi, `\r
`)
                        }
                    }).get()
                }
            });
            var Hn = /%20/g,
                jn = /#.*$/,
                Pn = /([?&])_=[^&]*/,
                _n = /^(.*?):[ \t]*([^\r\n]*)$/mg,
                qn = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
                Mn = /^(?:GET|HEAD)$/,
                In = /^\/\//,
                Hi = {},
                Wt = {},
                ji = "*/".concat("*"),
                Rt = U.createElement("a");
            Rt.href = ot.href;

            function Pi(e) {
                return function(t, n) {
                    typeof t != "string" && (n = t, t = "*");
                    var r, a = 0,
                        l = t.toLowerCase().match(xe) || [];
                    if (q(n))
                        for (; r = l[a++];) r[0] === "+" ? (r = r.slice(1) || "*", (e[r] = e[r] || []).unshift(n)) : (e[r] = e[r] || []).push(n)
                }
            }

            function _i(e, t, n, r) {
                var a = {},
                    l = e === Wt;

                function u(g) {
                    var d;
                    return a[g] = !0, o.each(e[g] || [], function(w, k) {
                        var E = k(t, n, r);
                        if (typeof E == "string" && !l && !a[E]) return t.dataTypes.unshift(E), u(E), !1;
                        if (l) return !(d = E)
                    }), d
                }
                return u(t.dataTypes[0]) || !a["*"] && u("*")
            }

            function Ft(e, t) {
                var n, r, a = o.ajaxSettings.flatOptions || {};
                for (n in t) t[n] !== void 0 && ((a[n] ? e : r || (r = {}))[n] = t[n]);
                return r && o.extend(!0, e, r), e
            }

            function zn(e, t, n) {
                for (var r, a, l, u, g = e.contents, d = e.dataTypes; d[0] === "*";) d.shift(), r === void 0 && (r = e.mimeType || t.getResponseHeader("Content-Type"));
                if (r) {
                    for (a in g)
                        if (g[a] && g[a].test(r)) {
                            d.unshift(a);
                            break
                        }
                }
                if (d[0] in n) l = d[0];
                else {
                    for (a in n) {
                        if (!d[0] || e.converters[a + " " + d[0]]) {
                            l = a;
                            break
                        }
                        u || (u = a)
                    }
                    l = l || u
                }
                if (l) return l !== d[0] && d.unshift(l), n[l]
            }

            function Wn(e, t, n, r) {
                var a, l, u, g, d, w = {},
                    k = e.dataTypes.slice();
                if (k[1])
                    for (u in e.converters) w[u.toLowerCase()] = e.converters[u];
                for (l = k.shift(); l;)
                    if (e.responseFields[l] && (n[e.responseFields[l]] = t), !d && r && e.dataFilter && (t = e.dataFilter(t, e.dataType)), d = l, l = k.shift(), l) {
                        if (l === "*") l = d;
                        else if (d !== "*" && d !== l) {
                            if (u = w[d + " " + l] || w["* " + l], !u) {
                                for (a in w)
                                    if (g = a.split(" "), g[1] === l && (u = w[d + " " + g[0]] || w["* " + g[0]], u)) {
                                        u === !0 ? u = w[a] : w[a] !== !0 && (l = g[0], k.unshift(g[1]));
                                        break
                                    }
                            }
                            if (u !== !0)
                                if (u && e.throws) t = u(t);
                                else try {
                                    t = u(t)
                                } catch (E) {
                                    return {
                                        state: "parsererror",
                                        error: u ? E : "No conversion from " + d + " to " + l
                                    }
                                }
                        }
                    }
                return {
                    state: "success",
                    data: t
                }
            }
            o.extend({
                active: 0,
                lastModified: {},
                etag: {},
                ajaxSettings: {
                    url: ot.href,
                    type: "GET",
                    isLocal: qn.test(ot.protocol),
                    global: !0,
                    processData: !0,
                    async: !0,
                    contentType: "application/x-www-form-urlencoded; charset=UTF-8",
                    accepts: {
                        "*": ji,
                        text: "text/plain",
                        html: "text/html",
                        xml: "application/xml, text/xml",
                        json: "application/json, text/javascript"
                    },
                    contents: {
                        xml: /\bxml\b/,
                        html: /\bhtml/,
                        json: /\bjson\b/
                    },
                    responseFields: {
                        xml: "responseXML",
                        text: "responseText",
                        json: "responseJSON"
                    },
                    converters: {
                        "* text": String,
                        "text html": !0,
                        "text json": JSON.parse,
                        "text xml": o.parseXML
                    },
                    flatOptions: {
                        url: !0,
                        context: !0
                    }
                },
                ajaxSetup: function(e, t) {
                    return t ? Ft(Ft(e, o.ajaxSettings), t) : Ft(o.ajaxSettings, e)
                },
                ajaxPrefilter: Pi(Hi),
                ajaxTransport: Pi(Wt),
                ajax: function(e, t) {
                    typeof e == "object" && (t = e, e = void 0), t = t || {};
                    var n, r, a, l, u, g, d, w, k, E, b = o.ajaxSetup({}, t),
                        C = b.context || b,
                        P = b.context && (C.nodeType || C.jquery) ? o(C) : o.event,
                        B = o.Deferred(),
                        _ = o.Callbacks("once memory"),
                        se = b.statusCode || {},
                        re = {},
                        ge = {},
                        Z = "canceled",
                        F = {
                            readyState: 0,
                            getResponseHeader: function(Q) {
                                var ne;
                                if (d) {
                                    if (!l)
                                        for (l = {}; ne = _n.exec(a);) l[ne[1].toLowerCase() + " "] = (l[ne[1].toLowerCase() + " "] || []).concat(ne[2]);
                                    ne = l[Q.toLowerCase() + " "]
                                }
                                return ne == null ? null : ne.join(", ")
                            },
                            getAllResponseHeaders: function() {
                                return d ? a : null
                            },
                            setRequestHeader: function(Q, ne) {
                                return d == null && (Q = ge[Q.toLowerCase()] = ge[Q.toLowerCase()] || Q, re[Q] = ne), this
                            },
                            overrideMimeType: function(Q) {
                                return d == null && (b.mimeType = Q), this
                            },
                            statusCode: function(Q) {
                                var ne;
                                if (Q)
                                    if (d) F.always(Q[F.status]);
                                    else
                                        for (ne in Q) se[ne] = [se[ne], Q[ne]];
                                return this
                            },
                            abort: function(Q) {
                                var ne = Q || Z;
                                return n && n.abort(ne), de(0, ne), this
                            }
                        };
                    if (B.promise(F), b.url = ((e || b.url || ot.href) + "").replace(In, ot.protocol + "//"), b.type = t.method || t.type || b.method || b.type, b.dataTypes = (b.dataType || "*").toLowerCase().match(xe) || [""], b.crossDomain == null) {
                        g = U.createElement("a");
                        try {
                            g.href = b.url, g.href = g.href, b.crossDomain = Rt.protocol + "//" + Rt.host != g.protocol + "//" + g.host
                        } catch {
                            b.crossDomain = !0
                        }
                    }
                    if (b.data && b.processData && typeof b.data != "string" && (b.data = o.param(b.data, b.traditional)), _i(Hi, b, t, F), d) return F;
                    w = o.event && b.global, w && o.active++ === 0 && o.event.trigger("ajaxStart"), b.type = b.type.toUpperCase(), b.hasContent = !Mn.test(b.type), r = b.url.replace(jn, ""), b.hasContent ? b.data && b.processData && (b.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && (b.data = b.data.replace(Hn, "+")) : (E = b.url.slice(r.length), b.data && (b.processData || typeof b.data == "string") && (r += (It.test(r) ? "&" : "?") + b.data, delete b.data), b.cache === !1 && (r = r.replace(Pn, "$1"), E = (It.test(r) ? "&" : "?") + "_=" + Ni.guid++ + E), b.url = r + E), b.ifModified && (o.lastModified[r] && F.setRequestHeader("If-Modified-Since", o.lastModified[r]), o.etag[r] && F.setRequestHeader("If-None-Match", o.etag[r])), (b.data && b.hasContent && b.contentType !== !1 || t.contentType) && F.setRequestHeader("Content-Type", b.contentType), F.setRequestHeader("Accept", b.dataTypes[0] && b.accepts[b.dataTypes[0]] ? b.accepts[b.dataTypes[0]] + (b.dataTypes[0] !== "*" ? ", " + ji + "; q=0.01" : "") : b.accepts["*"]);
                    for (k in b.headers) F.setRequestHeader(k, b.headers[k]);
                    if (b.beforeSend && (b.beforeSend.call(C, F, b) === !1 || d)) return F.abort();
                    if (Z = "abort", _.add(b.complete), F.done(b.success), F.fail(b.error), n = _i(Wt, b, t, F), !n) de(-1, "No Transport");
                    else {
                        if (F.readyState = 1, w && P.trigger("ajaxSend", [F, b]), d) return F;
                        b.async && b.timeout > 0 && (u = H.setTimeout(function() {
                            F.abort("timeout")
                        }, b.timeout));
                        try {
                            d = !1, n.send(re, de)
                        } catch (Q) {
                            if (d) throw Q;
                            de(-1, Q)
                        }
                    }

                    function de(Q, ne, lt, bt) {
                        var ye, Me, Ie, pe, Ne, Te = ne;
                        d || (d = !0, u && H.clearTimeout(u), n = void 0, a = bt || "", F.readyState = Q > 0 ? 4 : 0, ye = Q >= 200 && Q < 300 || Q === 304, lt && (pe = zn(b, F, lt)), !ye && o.inArray("script", b.dataTypes) > -1 && o.inArray("json", b.dataTypes) < 0 && (b.converters["text script"] = function() {}), pe = Wn(b, pe, F, ye), ye ? (b.ifModified && (Ne = F.getResponseHeader("Last-Modified"), Ne && (o.lastModified[r] = Ne), Ne = F.getResponseHeader("etag"), Ne && (o.etag[r] = Ne)), Q === 204 || b.type === "HEAD" ? Te = "nocontent" : Q === 304 ? Te = "notmodified" : (Te = pe.state, Me = pe.data, Ie = pe.error, ye = !Ie)) : (Ie = Te, (Q || !Te) && (Te = "error", Q < 0 && (Q = 0))), F.status = Q, F.statusText = (ne || Te) + "", ye ? B.resolveWith(C, [Me, Te, F]) : B.rejectWith(C, [F, Te, Ie]), F.statusCode(se), se = void 0, w && P.trigger(ye ? "ajaxSuccess" : "ajaxError", [F, b, ye ? Me : Ie]), _.fireWith(C, [F, Te]), w && (P.trigger("ajaxComplete", [F, b]), --o.active || o.event.trigger("ajaxStop")))
                    }
                    return F
                },
                getJSON: function(e, t, n) {
                    return o.get(e, t, n, "json")
                },
                getScript: function(e, t) {
                    return o.get(e, void 0, t, "script")
                }
            }), o.each(["get", "post"], function(e, t) {
                o[t] = function(n, r, a, l) {
                    return q(r) && (l = l || a, a = r, r = void 0), o.ajax(o.extend({
                        url: n,
                        type: t,
                        dataType: l,
                        data: r,
                        success: a
                    }, o.isPlainObject(n) && n))
                }
            }), o.ajaxPrefilter(function(e) {
                var t;
                for (t in e.headers) t.toLowerCase() === "content-type" && (e.contentType = e.headers[t] || "")
            }), o._evalUrl = function(e, t, n) {
                return o.ajax({
                    url: e,
                    type: "GET",
                    dataType: "script",
                    cache: !0,
                    async: !1,
                    global: !1,
                    converters: {
                        "text script": function() {}
                    },
                    dataFilter: function(r) {
                        o.globalEval(r, t, n)
                    }
                })
            }, o.fn.extend({
                wrapAll: function(e) {
                    var t;
                    return this[0] && (q(e) && (e = e.call(this[0])), t = o(e, this[0].ownerDocument).eq(0).clone(!0), this[0].parentNode && t.insertBefore(this[0]), t.map(function() {
                        for (var n = this; n.firstElementChild;) n = n.firstElementChild;
                        return n
                    }).append(this)), this
                },
                wrapInner: function(e) {
                    return q(e) ? this.each(function(t) {
                        o(this).wrapInner(e.call(this, t))
                    }) : this.each(function() {
                        var t = o(this),
                            n = t.contents();
                        n.length ? n.wrapAll(e) : t.append(e)
                    })
                },
                wrap: function(e) {
                    var t = q(e);
                    return this.each(function(n) {
                        o(this).wrapAll(t ? e.call(this, n) : e)
                    })
                },
                unwrap: function(e) {
                    return this.parent(e).not("body").each(function() {
                        o(this).replaceWith(this.childNodes)
                    }), this
                }
            }), o.expr.pseudos.hidden = function(e) {
                return !o.expr.pseudos.visible(e)
            }, o.expr.pseudos.visible = function(e) {
                return !!(e.offsetWidth || e.offsetHeight || e.getClientRects().length)
            }, o.ajaxSettings.xhr = function() {
                try {
                    return new H.XMLHttpRequest
                } catch {}
            };
            var Rn = {
                    0: 200,
                    1223: 204
                },
                at = o.ajaxSettings.xhr();
            X.cors = !!at && "withCredentials" in at, X.ajax = at = !!at, o.ajaxTransport(function(e) {
                var t, n;
                if (X.cors || at && !e.crossDomain) return {
                    send: function(r, a) {
                        var l, u = e.xhr();
                        if (u.open(e.type, e.url, e.async, e.username, e.password), e.xhrFields)
                            for (l in e.xhrFields) u[l] = e.xhrFields[l];
                        e.mimeType && u.overrideMimeType && u.overrideMimeType(e.mimeType), !e.crossDomain && !r["X-Requested-With"] && (r["X-Requested-With"] = "XMLHttpRequest");
                        for (l in r) u.setRequestHeader(l, r[l]);
                        t = function(g) {
                            return function() {
                                t && (t = n = u.onload = u.onerror = u.onabort = u.ontimeout = u.onreadystatechange = null, g === "abort" ? u.abort() : g === "error" ? typeof u.status != "number" ? a(0, "error") : a(u.status, u.statusText) : a(Rn[u.status] || u.status, u.statusText, (u.responseType || "text") !== "text" || typeof u.responseText != "string" ? {
                                    binary: u.response
                                } : {
                                    text: u.responseText
                                }, u.getAllResponseHeaders()))
                            }
                        }, u.onload = t(), n = u.onerror = u.ontimeout = t("error"), u.onabort !== void 0 ? u.onabort = n : u.onreadystatechange = function() {
                            u.readyState === 4 && H.setTimeout(function() {
                                t && n()
                            })
                        }, t = t("abort");
                        try {
                            u.send(e.hasContent && e.data || null)
                        } catch (g) {
                            if (t) throw g
                        }
                    },
                    abort: function() {
                        t && t()
                    }
                }
            }), o.ajaxPrefilter(function(e) {
                e.crossDomain && (e.contents.script = !1)
            }), o.ajaxSetup({
                accepts: {
                    script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
                },
                contents: {
                    script: /\b(?:java|ecma)script\b/
                },
                converters: {
                    "text script": function(e) {
                        return o.globalEval(e), e
                    }
                }
            }), o.ajaxPrefilter("script", function(e) {
                e.cache === void 0 && (e.cache = !1), e.crossDomain && (e.type = "GET")
            }), o.ajaxTransport("script", function(e) {
                if (e.crossDomain || e.scriptAttrs) {
                    var t, n;
                    return {
                        send: function(r, a) {
                            t = o("<script>").attr(e.scriptAttrs || {}).prop({
                                charset: e.scriptCharset,
                                src: e.url
                            }).on("load error", n = function(l) {
                                t.remove(), n = null, l && a(l.type === "error" ? 404 : 200, l.type)
                            }), U.head.appendChild(t[0])
                        },
                        abort: function() {
                            n && n()
                        }
                    }
                }
            });
            var qi = [],
                Bt = /(=)\?(?=&|$)|\?\?/;
            o.ajaxSetup({
                jsonp: "callback",
                jsonpCallback: function() {
                    var e = qi.pop() || o.expando + "_" + Ni.guid++;
                    return this[e] = !0, e
                }
            }), o.ajaxPrefilter("json jsonp", function(e, t, n) {
                var r, a, l, u = e.jsonp !== !1 && (Bt.test(e.url) ? "url" : typeof e.data == "string" && (e.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && Bt.test(e.data) && "data");
                if (u || e.dataTypes[0] === "jsonp") return r = e.jsonpCallback = q(e.jsonpCallback) ? e.jsonpCallback() : e.jsonpCallback, u ? e[u] = e[u].replace(Bt, "$1" + r) : e.jsonp !== !1 && (e.url += (It.test(e.url) ? "&" : "?") + e.jsonp + "=" + r), e.converters["script json"] = function() {
                    return l || o.error(r + " was not called"), l[0]
                }, e.dataTypes[0] = "json", a = H[r], H[r] = function() {
                    l = arguments
                }, n.always(function() {
                    a === void 0 ? o(H).removeProp(r) : H[r] = a, e[r] && (e.jsonpCallback = t.jsonpCallback, qi.push(r)), l && q(a) && a(l[0]), l = a = void 0
                }), "script"
            }), X.createHTMLDocument = function() {
                var e = U.implementation.createHTMLDocument("").body;
                return e.innerHTML = "<form></form><form></form>", e.childNodes.length === 2
            }(), o.parseHTML = function(e, t, n) {
                if (typeof e != "string") return [];
                typeof t == "boolean" && (n = t, t = !1);
                var r, a, l;
                return t || (X.createHTMLDocument ? (t = U.implementation.createHTMLDocument(""), r = t.createElement("base"), r.href = U.location.href, t.head.appendChild(r)) : t = U), a = ii.exec(e), l = !n && [], a ? [t.createElement(a[1])] : (a = di([e], t, l), l && l.length && o(l).remove(), o.merge([], a.childNodes))
            }, o.fn.load = function(e, t, n) {
                var r, a, l, u = this,
                    g = e.indexOf(" ");
                return g > -1 && (r = _e(e.slice(g)), e = e.slice(0, g)), q(t) ? (n = t, t = void 0) : t && typeof t == "object" && (a = "POST"), u.length > 0 && o.ajax({
                    url: e,
                    type: a || "GET",
                    dataType: "html",
                    data: t
                }).done(function(d) {
                    l = arguments, u.html(r ? o("<div>").append(o.parseHTML(d)).find(r) : d)
                }).always(n && function(d, w) {
                    u.each(function() {
                        n.apply(this, l || [d.responseText, w, d])
                    })
                }), this
            }, o.expr.pseudos.animated = function(e) {
                return o.grep(o.timers, function(t) {
                    return e === t.elem
                }).length
            }, o.offset = {
                setOffset: function(e, t, n) {
                    var r, a, l, u, g, d, w, k = o.css(e, "position"),
                        E = o(e),
                        b = {};
                    k === "static" && (e.style.position = "relative"), g = E.offset(), l = o.css(e, "top"), d = o.css(e, "left"), w = (k === "absolute" || k === "fixed") && (l + d).indexOf("auto") > -1, w ? (r = E.position(), u = r.top, a = r.left) : (u = parseFloat(l) || 0, a = parseFloat(d) || 0), q(t) && (t = t.call(e, n, o.extend({}, g))), t.top != null && (b.top = t.top - g.top + u), t.left != null && (b.left = t.left - g.left + a), "using" in t ? t.using.call(e, b) : E.css(b)
                }
            }, o.fn.extend({
                offset: function(e) {
                    if (arguments.length) return e === void 0 ? this : this.each(function(a) {
                        o.offset.setOffset(this, e, a)
                    });
                    var t, n, r = this[0];
                    if (!!r) return r.getClientRects().length ? (t = r.getBoundingClientRect(), n = r.ownerDocument.defaultView, {
                        top: t.top + n.pageYOffset,
                        left: t.left + n.pageXOffset
                    }) : {
                        top: 0,
                        left: 0
                    }
                },
                position: function() {
                    if (!!this[0]) {
                        var e, t, n, r = this[0],
                            a = {
                                top: 0,
                                left: 0
                            };
                        if (o.css(r, "position") === "fixed") t = r.getBoundingClientRect();
                        else {
                            for (t = this.offset(), n = r.ownerDocument, e = r.offsetParent || n.documentElement; e && (e === n.body || e === n.documentElement) && o.css(e, "position") === "static";) e = e.parentNode;
                            e && e !== r && e.nodeType === 1 && (a = o(e).offset(), a.top += o.css(e, "borderTopWidth", !0), a.left += o.css(e, "borderLeftWidth", !0))
                        }
                        return {
                            top: t.top - a.top - o.css(r, "marginTop", !0),
                            left: t.left - a.left - o.css(r, "marginLeft", !0)
                        }
                    }
                },
                offsetParent: function() {
                    return this.map(function() {
                        for (var e = this.offsetParent; e && o.css(e, "position") === "static";) e = e.offsetParent;
                        return e || Pe
                    })
                }
            }), o.each({
                scrollLeft: "pageXOffset",
                scrollTop: "pageYOffset"
            }, function(e, t) {
                var n = t === "pageYOffset";
                o.fn[e] = function(r) {
                    return Ee(this, function(a, l, u) {
                        var g;
                        if (he(a) ? g = a : a.nodeType === 9 && (g = a.defaultView), u === void 0) return g ? g[t] : a[l];
                        g ? g.scrollTo(n ? g.pageXOffset : u, n ? u : g.pageYOffset) : a[l] = u
                    }, e, r, arguments.length)
                }
            }), o.each(["top", "left"], function(e, t) {
                o.cssHooks[t] = wi(X.pixelPosition, function(n, r) {
                    if (r) return r = rt(n, t), Ht.test(r) ? o(n).position()[t] + "px" : r
                })
            }), o.each({
                Height: "height",
                Width: "width"
            }, function(e, t) {
                o.each({
                    padding: "inner" + e,
                    content: t,
                    "": "outer" + e
                }, function(n, r) {
                    o.fn[r] = function(a, l) {
                        var u = arguments.length && (n || typeof a != "boolean"),
                            g = n || (a === !0 || l === !0 ? "margin" : "border");
                        return Ee(this, function(d, w, k) {
                            var E;
                            return he(d) ? r.indexOf("outer") === 0 ? d["inner" + e] : d.document.documentElement["client" + e] : d.nodeType === 9 ? (E = d.documentElement, Math.max(d.body["scroll" + e], E["scroll" + e], d.body["offset" + e], E["offset" + e], E["client" + e])) : k === void 0 ? o.css(d, w, g) : o.style(d, w, k, g)
                        }, t, u ? a : void 0, u)
                    }
                })
            }), o.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function(e, t) {
                o.fn[t] = function(n) {
                    return this.on(t, n)
                }
            }), o.fn.extend({
                bind: function(e, t, n) {
                    return this.on(e, null, t, n)
                },
                unbind: function(e, t) {
                    return this.off(e, null, t)
                },
                delegate: function(e, t, n, r) {
                    return this.on(t, e, n, r)
                },
                undelegate: function(e, t, n) {
                    return arguments.length === 1 ? this.off(e, "**") : this.off(t, e || "**", n)
                },
                hover: function(e, t) {
                    return this.mouseenter(e).mouseleave(t || e)
                }
            }), o.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(e, t) {
                o.fn[t] = function(n, r) {
                    return arguments.length > 0 ? this.on(t, null, n, r) : this.trigger(t)
                }
            });
            var Fn = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
            o.proxy = function(e, t) {
                var n, r, a;
                if (typeof t == "string" && (n = e[t], t = e, e = n), !!q(e)) return r = s.call(arguments, 2), a = function() {
                    return e.apply(t || this, r.concat(s.call(arguments)))
                }, a.guid = e.guid = e.guid || o.guid++, a
            }, o.holdReady = function(e) {
                e ? o.readyWait++ : o.ready(!0)
            }, o.isArray = Array.isArray, o.parseJSON = JSON.parse, o.nodeName = we, o.isFunction = q, o.isWindow = he, o.camelCase = Ae, o.type = Ue, o.now = Date.now, o.isNumeric = function(e) {
                var t = o.type(e);
                return (t === "number" || t === "string") && !isNaN(e - parseFloat(e))
            }, o.trim = function(e) {
                return e == null ? "" : (e + "").replace(Fn, "$1")
            };
            var Bn = H.jQuery,
                Un = H.$;
            return o.noConflict = function(e) {
                return H.$ === o && (H.$ = Un), e && H.jQuery === o && (H.jQuery = Bn), o
            }, typeof T == "undefined" && (H.jQuery = H.$ = o), o
        })
    })(Et);
    var V = Et.exports,
        Yi = {
            exports: {}
        };
    (function(K, H) {
        (function(T) {
            K.exports = T(Et.exports)
        })(function(T) {
            var S = window.Slick || {};
            S = function() {
                var i = 0;

                function s(c, h) {
                    var y = this,
                        D;
                    y.defaults = {
                        accessibility: !0,
                        adaptiveHeight: !1,
                        appendArrows: T(c),
                        appendDots: T(c),
                        arrows: !0,
                        asNavFor: null,
                        prevArrow: '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
                        nextArrow: '<button class="slick-next" aria-label="Next" type="button">Next</button>',
                        autoplay: !1,
                        autoplaySpeed: 3e3,
                        centerMode: !1,
                        centerPadding: "50px",
                        cssEase: "ease",
                        customPaging: function(j, G) {
                            return T('<button type="button" />').text(G + 1)
                        },
                        dots: !1,
                        dotsClass: "slick-dots",
                        draggable: !0,
                        easing: "linear",
                        edgeFriction: .35,
                        fade: !1,
                        focusOnSelect: !1,
                        focusOnChange: !1,
                        infinite: !0,
                        initialSlide: 0,
                        lazyLoad: "ondemand",
                        mobileFirst: !1,
                        pauseOnHover: !0,
                        pauseOnFocus: !0,
                        pauseOnDotsHover: !1,
                        respondTo: "window",
                        responsive: null,
                        rows: 1,
                        rtl: !1,
                        slide: "",
                        slidesPerRow: 1,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        speed: 500,
                        swipe: !0,
                        swipeToSlide: !1,
                        touchMove: !0,
                        touchThreshold: 5,
                        useCSS: !0,
                        useTransform: !0,
                        variableWidth: !1,
                        vertical: !1,
                        verticalSwiping: !1,
                        waitForAnimate: !0,
                        zIndex: 1e3
                    }, y.initials = {
                        animating: !1,
                        dragging: !1,
                        autoPlayTimer: null,
                        currentDirection: 0,
                        currentLeft: null,
                        currentSlide: 0,
                        direction: 1,
                        $dots: null,
                        listWidth: null,
                        listHeight: null,
                        loadIndex: 0,
                        $nextArrow: null,
                        $prevArrow: null,
                        scrolling: !1,
                        slideCount: null,
                        slideWidth: null,
                        $slideTrack: null,
                        $slides: null,
                        sliding: !1,
                        slideOffset: 0,
                        swipeLeft: null,
                        swiping: !1,
                        $list: null,
                        touchObject: {},
                        transformsEnabled: !1,
                        unslicked: !1
                    }, T.extend(y, y.initials), y.activeBreakpoint = null, y.animType = null, y.animProp = null, y.breakpoints = [], y.breakpointSettings = [], y.cssTransitions = !1, y.focussed = !1, y.interrupted = !1, y.hidden = "hidden", y.paused = !0, y.positionProp = null, y.respondTo = null, y.rowCount = 1, y.shouldClick = !0, y.$slider = T(c), y.$slidesCache = null, y.transformType = null, y.transitionType = null, y.visibilityChange = "visibilitychange", y.windowWidth = 0, y.windowTimer = null, D = T(c).data("slick") || {}, y.options = T.extend({}, y.defaults, h, D), y.currentSlide = y.options.initialSlide, y.originalSettings = y.options, typeof document.mozHidden != "undefined" ? (y.hidden = "mozHidden", y.visibilityChange = "mozvisibilitychange") : typeof document.webkitHidden != "undefined" && (y.hidden = "webkitHidden", y.visibilityChange = "webkitvisibilitychange"), y.autoPlay = T.proxy(y.autoPlay, y), y.autoPlayClear = T.proxy(y.autoPlayClear, y), y.autoPlayIterator = T.proxy(y.autoPlayIterator, y), y.changeSlide = T.proxy(y.changeSlide, y), y.clickHandler = T.proxy(y.clickHandler, y), y.selectHandler = T.proxy(y.selectHandler, y), y.setPosition = T.proxy(y.setPosition, y), y.swipeHandler = T.proxy(y.swipeHandler, y), y.dragHandler = T.proxy(y.dragHandler, y), y.keyHandler = T.proxy(y.keyHandler, y), y.instanceUid = i++, y.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/, y.registerBreakpoints(), y.init(!0)
                }
                return s
            }(), S.prototype.activateADA = function() {
                var i = this;
                i.$slideTrack.find(".slick-active").attr({
                    "aria-hidden": "false"
                }).find("a, input, button, select").attr({
                    tabindex: "0"
                })
            }, S.prototype.addSlide = S.prototype.slickAdd = function(i, s, c) {
                var h = this;
                if (typeof s == "boolean") c = s, s = null;
                else if (s < 0 || s >= h.slideCount) return !1;
                h.unload(), typeof s == "number" ? s === 0 && h.$slides.length === 0 ? T(i).appendTo(h.$slideTrack) : c ? T(i).insertBefore(h.$slides.eq(s)) : T(i).insertAfter(h.$slides.eq(s)) : c === !0 ? T(i).prependTo(h.$slideTrack) : T(i).appendTo(h.$slideTrack), h.$slides = h.$slideTrack.children(this.options.slide), h.$slideTrack.children(this.options.slide).detach(), h.$slideTrack.append(h.$slides), h.$slides.each(function(y, D) {
                    T(D).attr("data-slick-index", y)
                }), h.$slidesCache = h.$slides, h.reinit()
            }, S.prototype.animateHeight = function() {
                var i = this;
                if (i.options.slidesToShow === 1 && i.options.adaptiveHeight === !0 && i.options.vertical === !1) {
                    var s = i.$slides.eq(i.currentSlide).outerHeight(!0);
                    i.$list.animate({
                        height: s
                    }, i.options.speed)
                }
            }, S.prototype.animateSlide = function(i, s) {
                var c = {},
                    h = this;
                h.animateHeight(), h.options.rtl === !0 && h.options.vertical === !1 && (i = -i), h.transformsEnabled === !1 ? h.options.vertical === !1 ? h.$slideTrack.animate({
                    left: i
                }, h.options.speed, h.options.easing, s) : h.$slideTrack.animate({
                    top: i
                }, h.options.speed, h.options.easing, s) : h.cssTransitions === !1 ? (h.options.rtl === !0 && (h.currentLeft = -h.currentLeft), T({
                    animStart: h.currentLeft
                }).animate({
                    animStart: i
                }, {
                    duration: h.options.speed,
                    easing: h.options.easing,
                    step: function(y) {
                        y = Math.ceil(y), h.options.vertical === !1 ? (c[h.animType] = "translate(" + y + "px, 0px)", h.$slideTrack.css(c)) : (c[h.animType] = "translate(0px," + y + "px)", h.$slideTrack.css(c))
                    },
                    complete: function() {
                        s && s.call()
                    }
                })) : (h.applyTransition(), i = Math.ceil(i), h.options.vertical === !1 ? c[h.animType] = "translate3d(" + i + "px, 0px, 0px)" : c[h.animType] = "translate3d(0px," + i + "px, 0px)", h.$slideTrack.css(c), s && setTimeout(function() {
                    h.disableTransition(), s.call()
                }, h.options.speed))
            }, S.prototype.getNavTarget = function() {
                var i = this,
                    s = i.options.asNavFor;
                return s && s !== null && (s = T(s).not(i.$slider)), s
            }, S.prototype.asNavFor = function(i) {
                var s = this,
                    c = s.getNavTarget();
                c !== null && typeof c == "object" && c.each(function() {
                    var h = T(this).slick("getSlick");
                    h.unslicked || h.slideHandler(i, !0)
                })
            }, S.prototype.applyTransition = function(i) {
                var s = this,
                    c = {};
                s.options.fade === !1 ? c[s.transitionType] = s.transformType + " " + s.options.speed + "ms " + s.options.cssEase : c[s.transitionType] = "opacity " + s.options.speed + "ms " + s.options.cssEase, s.options.fade === !1 ? s.$slideTrack.css(c) : s.$slides.eq(i).css(c)
            }, S.prototype.autoPlay = function() {
                var i = this;
                i.autoPlayClear(), i.slideCount > i.options.slidesToShow && (i.autoPlayTimer = setInterval(i.autoPlayIterator, i.options.autoplaySpeed))
            }, S.prototype.autoPlayClear = function() {
                var i = this;
                i.autoPlayTimer && clearInterval(i.autoPlayTimer)
            }, S.prototype.autoPlayIterator = function() {
                var i = this,
                    s = i.currentSlide + i.options.slidesToScroll;
                !i.paused && !i.interrupted && !i.focussed && (i.options.infinite === !1 && (i.direction === 1 && i.currentSlide + 1 === i.slideCount - 1 ? i.direction = 0 : i.direction === 0 && (s = i.currentSlide - i.options.slidesToScroll, i.currentSlide - 1 === 0 && (i.direction = 1))), i.slideHandler(s))
            }, S.prototype.buildArrows = function() {
                var i = this;
                i.options.arrows === !0 && (i.$prevArrow = T(i.options.prevArrow).addClass("slick-arrow"), i.$nextArrow = T(i.options.nextArrow).addClass("slick-arrow"), i.slideCount > i.options.slidesToShow ? (i.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"), i.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"), i.htmlExpr.test(i.options.prevArrow) && i.$prevArrow.prependTo(i.options.appendArrows), i.htmlExpr.test(i.options.nextArrow) && i.$nextArrow.appendTo(i.options.appendArrows), i.options.infinite !== !0 && i.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true")) : i.$prevArrow.add(i.$nextArrow).addClass("slick-hidden").attr({
                    "aria-disabled": "true",
                    tabindex: "-1"
                }))
            }, S.prototype.buildDots = function() {
                var i = this,
                    s, c;
                if (i.options.dots === !0 && i.slideCount > i.options.slidesToShow) {
                    for (i.$slider.addClass("slick-dotted"), c = T("<ul />").addClass(i.options.dotsClass), s = 0; s <= i.getDotCount(); s += 1) c.append(T("<li />").append(i.options.customPaging.call(this, i, s)));
                    i.$dots = c.appendTo(i.options.appendDots), i.$dots.find("li").first().addClass("slick-active")
                }
            }, S.prototype.buildOut = function() {
                var i = this;
                i.$slides = i.$slider.children(i.options.slide + ":not(.slick-cloned)").addClass("slick-slide"), i.slideCount = i.$slides.length, i.$slides.each(function(s, c) {
                    T(c).attr("data-slick-index", s).data("originalStyling", T(c).attr("style") || "")
                }), i.$slider.addClass("slick-slider"), i.$slideTrack = i.slideCount === 0 ? T('<div class="slick-track"/>').appendTo(i.$slider) : i.$slides.wrapAll('<div class="slick-track"/>').parent(), i.$list = i.$slideTrack.wrap('<div class="slick-list"/>').parent(), i.$slideTrack.css("opacity", 0), (i.options.centerMode === !0 || i.options.swipeToSlide === !0) && (i.options.slidesToScroll = 1), T("img[data-lazy]", i.$slider).not("[src]").addClass("slick-loading"), i.setupInfinite(), i.buildArrows(), i.buildDots(), i.updateDots(), i.setSlideClasses(typeof i.currentSlide == "number" ? i.currentSlide : 0), i.options.draggable === !0 && i.$list.addClass("draggable")
            }, S.prototype.buildRows = function() {
                var i = this,
                    s, c, h, y, D, j, G;
                if (y = document.createDocumentFragment(), j = i.$slider.children(), i.options.rows > 0) {
                    for (G = i.options.slidesPerRow * i.options.rows, D = Math.ceil(j.length / G), s = 0; s < D; s++) {
                        var L = document.createElement("div");
                        for (c = 0; c < i.options.rows; c++) {
                            var ae = document.createElement("div");
                            for (h = 0; h < i.options.slidesPerRow; h++) {
                                var X = s * G + (c * i.options.slidesPerRow + h);
                                j.get(X) && ae.appendChild(j.get(X))
                            }
                            L.appendChild(ae)
                        }
                        y.appendChild(L)
                    }
                    i.$slider.empty().append(y), i.$slider.children().children().children().css({
                        width: 100 / i.options.slidesPerRow + "%",
                        display: "inline-block"
                    })
                }
            }, S.prototype.checkResponsive = function(i, s) {
                var c = this,
                    h, y, D, j = !1,
                    G = c.$slider.width(),
                    L = window.innerWidth || T(window).width();
                if (c.respondTo === "window" ? D = L : c.respondTo === "slider" ? D = G : c.respondTo === "min" && (D = Math.min(L, G)), c.options.responsive && c.options.responsive.length && c.options.responsive !== null) {
                    y = null;
                    for (h in c.breakpoints) c.breakpoints.hasOwnProperty(h) && (c.originalSettings.mobileFirst === !1 ? D < c.breakpoints[h] && (y = c.breakpoints[h]) : D > c.breakpoints[h] && (y = c.breakpoints[h]));
                    y !== null ? c.activeBreakpoint !== null ? (y !== c.activeBreakpoint || s) && (c.activeBreakpoint = y, c.breakpointSettings[y] === "unslick" ? c.unslick(y) : (c.options = T.extend({}, c.originalSettings, c.breakpointSettings[y]), i === !0 && (c.currentSlide = c.options.initialSlide), c.refresh(i)), j = y) : (c.activeBreakpoint = y, c.breakpointSettings[y] === "unslick" ? c.unslick(y) : (c.options = T.extend({}, c.originalSettings, c.breakpointSettings[y]), i === !0 && (c.currentSlide = c.options.initialSlide), c.refresh(i)), j = y) : c.activeBreakpoint !== null && (c.activeBreakpoint = null, c.options = c.originalSettings, i === !0 && (c.currentSlide = c.options.initialSlide), c.refresh(i), j = y), !i && j !== !1 && c.$slider.trigger("breakpoint", [c, j])
                }
            }, S.prototype.changeSlide = function(i, s) {
                var c = this,
                    h = T(i.currentTarget),
                    y, D, j;
                switch (h.is("a") && i.preventDefault(), h.is("li") || (h = h.closest("li")), j = c.slideCount % c.options.slidesToScroll !== 0, y = j ? 0 : (c.slideCount - c.currentSlide) % c.options.slidesToScroll, i.data.message) {
                    case "previous":
                        D = y === 0 ? c.options.slidesToScroll : c.options.slidesToShow - y, c.slideCount > c.options.slidesToShow && c.slideHandler(c.currentSlide - D, !1, s);
                        break;
                    case "next":
                        D = y === 0 ? c.options.slidesToScroll : y, c.slideCount > c.options.slidesToShow && c.slideHandler(c.currentSlide + D, !1, s);
                        break;
                    case "index":
                        var G = i.data.index === 0 ? 0 : i.data.index || h.index() * c.options.slidesToScroll;
                        c.slideHandler(c.checkNavigable(G), !1, s), h.children().trigger("focus");
                        break;
                    default:
                        return
                }
            }, S.prototype.checkNavigable = function(i) {
                var s = this,
                    c, h;
                if (c = s.getNavigableIndexes(), h = 0, i > c[c.length - 1]) i = c[c.length - 1];
                else
                    for (var y in c) {
                        if (i < c[y]) {
                            i = h;
                            break
                        }
                        h = c[y]
                    }
                return i
            }, S.prototype.cleanUpEvents = function() {
                var i = this;
                i.options.dots && i.$dots !== null && (T("li", i.$dots).off("click.slick", i.changeSlide).off("mouseenter.slick", T.proxy(i.interrupt, i, !0)).off("mouseleave.slick", T.proxy(i.interrupt, i, !1)), i.options.accessibility === !0 && i.$dots.off("keydown.slick", i.keyHandler)), i.$slider.off("focus.slick blur.slick"), i.options.arrows === !0 && i.slideCount > i.options.slidesToShow && (i.$prevArrow && i.$prevArrow.off("click.slick", i.changeSlide), i.$nextArrow && i.$nextArrow.off("click.slick", i.changeSlide), i.options.accessibility === !0 && (i.$prevArrow && i.$prevArrow.off("keydown.slick", i.keyHandler), i.$nextArrow && i.$nextArrow.off("keydown.slick", i.keyHandler))), i.$list.off("touchstart.slick mousedown.slick", i.swipeHandler), i.$list.off("touchmove.slick mousemove.slick", i.swipeHandler), i.$list.off("touchend.slick mouseup.slick", i.swipeHandler), i.$list.off("touchcancel.slick mouseleave.slick", i.swipeHandler), i.$list.off("click.slick", i.clickHandler), T(document).off(i.visibilityChange, i.visibility), i.cleanUpSlideEvents(), i.options.accessibility === !0 && i.$list.off("keydown.slick", i.keyHandler), i.options.focusOnSelect === !0 && T(i.$slideTrack).children().off("click.slick", i.selectHandler), T(window).off("orientationchange.slick.slick-" + i.instanceUid, i.orientationChange), T(window).off("resize.slick.slick-" + i.instanceUid, i.resize), T("[draggable!=true]", i.$slideTrack).off("dragstart", i.preventDefault), T(window).off("load.slick.slick-" + i.instanceUid, i.setPosition)
            }, S.prototype.cleanUpSlideEvents = function() {
                var i = this;
                i.$list.off("mouseenter.slick", T.proxy(i.interrupt, i, !0)), i.$list.off("mouseleave.slick", T.proxy(i.interrupt, i, !1))
            }, S.prototype.cleanUpRows = function() {
                var i = this,
                    s;
                i.options.rows > 0 && (s = i.$slides.children().children(), s.removeAttr("style"), i.$slider.empty().append(s))
            }, S.prototype.clickHandler = function(i) {
                var s = this;
                s.shouldClick === !1 && (i.stopImmediatePropagation(), i.stopPropagation(), i.preventDefault())
            }, S.prototype.destroy = function(i) {
                var s = this;
                s.autoPlayClear(), s.touchObject = {}, s.cleanUpEvents(), T(".slick-cloned", s.$slider).detach(), s.$dots && s.$dots.remove(), s.$prevArrow && s.$prevArrow.length && (s.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""), s.htmlExpr.test(s.options.prevArrow) && s.$prevArrow.remove()), s.$nextArrow && s.$nextArrow.length && (s.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""), s.htmlExpr.test(s.options.nextArrow) && s.$nextArrow.remove()), s.$slides && (s.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function() {
                    T(this).attr("style", T(this).data("originalStyling"))
                }), s.$slideTrack.children(this.options.slide).detach(), s.$slideTrack.detach(), s.$list.detach(), s.$slider.append(s.$slides)), s.cleanUpRows(), s.$slider.removeClass("slick-slider"), s.$slider.removeClass("slick-initialized"), s.$slider.removeClass("slick-dotted"), s.unslicked = !0, i || s.$slider.trigger("destroy", [s])
            }, S.prototype.disableTransition = function(i) {
                var s = this,
                    c = {};
                c[s.transitionType] = "", s.options.fade === !1 ? s.$slideTrack.css(c) : s.$slides.eq(i).css(c)
            }, S.prototype.fadeSlide = function(i, s) {
                var c = this;
                c.cssTransitions === !1 ? (c.$slides.eq(i).css({
                    zIndex: c.options.zIndex
                }), c.$slides.eq(i).animate({
                    opacity: 1
                }, c.options.speed, c.options.easing, s)) : (c.applyTransition(i), c.$slides.eq(i).css({
                    opacity: 1,
                    zIndex: c.options.zIndex
                }), s && setTimeout(function() {
                    c.disableTransition(i), s.call()
                }, c.options.speed))
            }, S.prototype.fadeSlideOut = function(i) {
                var s = this;
                s.cssTransitions === !1 ? s.$slides.eq(i).animate({
                    opacity: 0,
                    zIndex: s.options.zIndex - 2
                }, s.options.speed, s.options.easing) : (s.applyTransition(i), s.$slides.eq(i).css({
                    opacity: 0,
                    zIndex: s.options.zIndex - 2
                }))
            }, S.prototype.filterSlides = S.prototype.slickFilter = function(i) {
                var s = this;
                i !== null && (s.$slidesCache = s.$slides, s.unload(), s.$slideTrack.children(this.options.slide).detach(), s.$slidesCache.filter(i).appendTo(s.$slideTrack), s.reinit())
            }, S.prototype.focusHandler = function() {
                var i = this;
                i.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick", "*", function(s) {
                    s.stopImmediatePropagation();
                    var c = T(this);
                    setTimeout(function() {
                        i.options.pauseOnFocus && (i.focussed = c.is(":focus"), i.autoPlay())
                    }, 0)
                })
            }, S.prototype.getCurrent = S.prototype.slickCurrentSlide = function() {
                var i = this;
                return i.currentSlide
            }, S.prototype.getDotCount = function() {
                var i = this,
                    s = 0,
                    c = 0,
                    h = 0;
                if (i.options.infinite === !0)
                    if (i.slideCount <= i.options.slidesToShow) ++h;
                    else
                        for (; s < i.slideCount;) ++h, s = c + i.options.slidesToScroll, c += i.options.slidesToScroll <= i.options.slidesToShow ? i.options.slidesToScroll : i.options.slidesToShow;
                else if (i.options.centerMode === !0) h = i.slideCount;
                else if (!i.options.asNavFor) h = 1 + Math.ceil((i.slideCount - i.options.slidesToShow) / i.options.slidesToScroll);
                else
                    for (; s < i.slideCount;) ++h, s = c + i.options.slidesToScroll, c += i.options.slidesToScroll <= i.options.slidesToShow ? i.options.slidesToScroll : i.options.slidesToShow;
                return h - 1
            }, S.prototype.getLeft = function(i) {
                var s = this,
                    c, h, y = 0,
                    D, j;
                return s.slideOffset = 0, h = s.$slides.first().outerHeight(!0), s.options.infinite === !0 ? (s.slideCount > s.options.slidesToShow && (s.slideOffset = s.slideWidth * s.options.slidesToShow * -1, j = -1, s.options.vertical === !0 && s.options.centerMode === !0 && (s.options.slidesToShow === 2 ? j = -1.5 : s.options.slidesToShow === 1 && (j = -2)), y = h * s.options.slidesToShow * j), s.slideCount % s.options.slidesToScroll !== 0 && i + s.options.slidesToScroll > s.slideCount && s.slideCount > s.options.slidesToShow && (i > s.slideCount ? (s.slideOffset = (s.options.slidesToShow - (i - s.slideCount)) * s.slideWidth * -1, y = (s.options.slidesToShow - (i - s.slideCount)) * h * -1) : (s.slideOffset = s.slideCount % s.options.slidesToScroll * s.slideWidth * -1, y = s.slideCount % s.options.slidesToScroll * h * -1))) : i + s.options.slidesToShow > s.slideCount && (s.slideOffset = (i + s.options.slidesToShow - s.slideCount) * s.slideWidth, y = (i + s.options.slidesToShow - s.slideCount) * h), s.slideCount <= s.options.slidesToShow && (s.slideOffset = 0, y = 0), s.options.centerMode === !0 && s.slideCount <= s.options.slidesToShow ? s.slideOffset = s.slideWidth * Math.floor(s.options.slidesToShow) / 2 - s.slideWidth * s.slideCount / 2 : s.options.centerMode === !0 && s.options.infinite === !0 ? s.slideOffset += s.slideWidth * Math.floor(s.options.slidesToShow / 2) - s.slideWidth : s.options.centerMode === !0 && (s.slideOffset = 0, s.slideOffset += s.slideWidth * Math.floor(s.options.slidesToShow / 2)), s.options.vertical === !1 ? c = i * s.slideWidth * -1 + s.slideOffset : c = i * h * -1 + y, s.options.variableWidth === !0 && (s.slideCount <= s.options.slidesToShow || s.options.infinite === !1 ? D = s.$slideTrack.children(".slick-slide").eq(i) : D = s.$slideTrack.children(".slick-slide").eq(i + s.options.slidesToShow), s.options.rtl === !0 ? D[0] ? c = (s.$slideTrack.width() - D[0].offsetLeft - D.width()) * -1 : c = 0 : c = D[0] ? D[0].offsetLeft * -1 : 0, s.options.centerMode === !0 && (s.slideCount <= s.options.slidesToShow || s.options.infinite === !1 ? D = s.$slideTrack.children(".slick-slide").eq(i) : D = s.$slideTrack.children(".slick-slide").eq(i + s.options.slidesToShow + 1), s.options.rtl === !0 ? D[0] ? c = (s.$slideTrack.width() - D[0].offsetLeft - D.width()) * -1 : c = 0 : c = D[0] ? D[0].offsetLeft * -1 : 0, c += (s.$list.width() - D.outerWidth()) / 2)), c
            }, S.prototype.getOption = S.prototype.slickGetOption = function(i) {
                var s = this;
                return s.options[i]
            }, S.prototype.getNavigableIndexes = function() {
                var i = this,
                    s = 0,
                    c = 0,
                    h = [],
                    y;
                for (i.options.infinite === !1 ? y = i.slideCount : (s = i.options.slidesToScroll * -1, c = i.options.slidesToScroll * -1, y = i.slideCount * 2); s < y;) h.push(s), s = c + i.options.slidesToScroll, c += i.options.slidesToScroll <= i.options.slidesToShow ? i.options.slidesToScroll : i.options.slidesToShow;
                return h
            }, S.prototype.getSlick = function() {
                return this
            }, S.prototype.getSlideCount = function() {
                var i = this,
                    s, c, h;
                return h = i.options.centerMode === !0 ? i.slideWidth * Math.floor(i.options.slidesToShow / 2) : 0, i.options.swipeToSlide === !0 ? (i.$slideTrack.find(".slick-slide").each(function(y, D) {
                    if (D.offsetLeft - h + T(D).outerWidth() / 2 > i.swipeLeft * -1) return c = D, !1
                }), s = Math.abs(T(c).attr("data-slick-index") - i.currentSlide) || 1, s) : i.options.slidesToScroll
            }, S.prototype.goTo = S.prototype.slickGoTo = function(i, s) {
                var c = this;
                c.changeSlide({
                    data: {
                        message: "index",
                        index: parseInt(i)
                    }
                }, s)
            }, S.prototype.init = function(i) {
                var s = this;
                T(s.$slider).hasClass("slick-initialized") || (T(s.$slider).addClass("slick-initialized"), s.buildRows(), s.buildOut(), s.setProps(), s.startLoad(), s.loadSlider(), s.initializeEvents(), s.updateArrows(), s.updateDots(), s.checkResponsive(!0), s.focusHandler()), i && s.$slider.trigger("init", [s]), s.options.accessibility === !0 && s.initADA(), s.options.autoplay && (s.paused = !1, s.autoPlay())
            }, S.prototype.initADA = function() {
                var i = this,
                    s = Math.ceil(i.slideCount / i.options.slidesToShow),
                    c = i.getNavigableIndexes().filter(function(D) {
                        return D >= 0 && D < i.slideCount
                    });
                i.$slides.add(i.$slideTrack.find(".slick-cloned")).attr({
                    "aria-hidden": "true",
                    tabindex: "-1"
                }).find("a, input, button, select").attr({
                    tabindex: "-1"
                }), i.$dots !== null && (i.$slides.not(i.$slideTrack.find(".slick-cloned")).each(function(D) {
                    var j = c.indexOf(D);
                    if (T(this).attr({
                            role: "tabpanel",
                            id: "slick-slide" + i.instanceUid + D,
                            tabindex: -1
                        }), j !== -1) {
                        var G = "slick-slide-control" + i.instanceUid + j;
                        T("#" + G).length && T(this).attr({
                            "aria-describedby": G
                        })
                    }
                }), i.$dots.attr("role", "tablist").find("li").each(function(D) {
                    var j = c[D];
                    T(this).attr({
                        role: "presentation"
                    }), T(this).find("button").first().attr({
                        role: "tab",
                        id: "slick-slide-control" + i.instanceUid + D,
                        "aria-controls": "slick-slide" + i.instanceUid + j,
                        "aria-label": D + 1 + " of " + s,
                        "aria-selected": null,
                        tabindex: "-1"
                    })
                }).eq(i.currentSlide).find("button").attr({
                    "aria-selected": "true",
                    tabindex: "0"
                }).end());
                for (var h = i.currentSlide, y = h + i.options.slidesToShow; h < y; h++) i.options.focusOnChange ? i.$slides.eq(h).attr({
                    tabindex: "0"
                }) : i.$slides.eq(h).removeAttr("tabindex");
                i.activateADA()
            }, S.prototype.initArrowEvents = function() {
                var i = this;
                i.options.arrows === !0 && i.slideCount > i.options.slidesToShow && (i.$prevArrow.off("click.slick").on("click.slick", {
                    message: "previous"
                }, i.changeSlide), i.$nextArrow.off("click.slick").on("click.slick", {
                    message: "next"
                }, i.changeSlide), i.options.accessibility === !0 && (i.$prevArrow.on("keydown.slick", i.keyHandler), i.$nextArrow.on("keydown.slick", i.keyHandler)))
            }, S.prototype.initDotEvents = function() {
                var i = this;
                i.options.dots === !0 && i.slideCount > i.options.slidesToShow && (T("li", i.$dots).on("click.slick", {
                    message: "index"
                }, i.changeSlide), i.options.accessibility === !0 && i.$dots.on("keydown.slick", i.keyHandler)), i.options.dots === !0 && i.options.pauseOnDotsHover === !0 && i.slideCount > i.options.slidesToShow && T("li", i.$dots).on("mouseenter.slick", T.proxy(i.interrupt, i, !0)).on("mouseleave.slick", T.proxy(i.interrupt, i, !1))
            }, S.prototype.initSlideEvents = function() {
                var i = this;
                i.options.pauseOnHover && (i.$list.on("mouseenter.slick", T.proxy(i.interrupt, i, !0)), i.$list.on("mouseleave.slick", T.proxy(i.interrupt, i, !1)))
            }, S.prototype.initializeEvents = function() {
                var i = this;
                i.initArrowEvents(), i.initDotEvents(), i.initSlideEvents(), i.$list.on("touchstart.slick mousedown.slick", {
                    action: "start"
                }, i.swipeHandler), i.$list.on("touchmove.slick mousemove.slick", {
                    action: "move"
                }, i.swipeHandler), i.$list.on("touchend.slick mouseup.slick", {
                    action: "end"
                }, i.swipeHandler), i.$list.on("touchcancel.slick mouseleave.slick", {
                    action: "end"
                }, i.swipeHandler), i.$list.on("click.slick", i.clickHandler), T(document).on(i.visibilityChange, T.proxy(i.visibility, i)), i.options.accessibility === !0 && i.$list.on("keydown.slick", i.keyHandler), i.options.focusOnSelect === !0 && T(i.$slideTrack).children().on("click.slick", i.selectHandler), T(window).on("orientationchange.slick.slick-" + i.instanceUid, T.proxy(i.orientationChange, i)), T(window).on("resize.slick.slick-" + i.instanceUid, T.proxy(i.resize, i)), T("[draggable!=true]", i.$slideTrack).on("dragstart", i.preventDefault), T(window).on("load.slick.slick-" + i.instanceUid, i.setPosition), T(i.setPosition)
            }, S.prototype.initUI = function() {
                var i = this;
                i.options.arrows === !0 && i.slideCount > i.options.slidesToShow && (i.$prevArrow.show(), i.$nextArrow.show()), i.options.dots === !0 && i.slideCount > i.options.slidesToShow && i.$dots.show()
            }, S.prototype.keyHandler = function(i) {
                var s = this;
                i.target.tagName.match("TEXTAREA|INPUT|SELECT") || (i.keyCode === 37 && s.options.accessibility === !0 ? s.changeSlide({
                    data: {
                        message: s.options.rtl === !0 ? "next" : "previous"
                    }
                }) : i.keyCode === 39 && s.options.accessibility === !0 && s.changeSlide({
                    data: {
                        message: s.options.rtl === !0 ? "previous" : "next"
                    }
                }))
            }, S.prototype.lazyLoad = function() {
                var i = this,
                    s, c, h, y;

                function D(X) {
                    T("img[data-lazy]", X).each(function() {
                        var q = T(this),
                            he = T(this).attr("data-lazy"),
                            U = T(this).attr("data-srcset"),
                            Fe = T(this).attr("data-sizes") || i.$slider.attr("data-sizes"),
                            Be = document.createElement("img");
                        Be.onload = function() {
                            q.animate({
                                opacity: 0
                            }, 100, function() {
                                U && (q.attr("srcset", U), Fe && q.attr("sizes", Fe)), q.attr("src", he).animate({
                                    opacity: 1
                                }, 200, function() {
                                    q.removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading")
                                }), i.$slider.trigger("lazyLoaded", [i, q, he])
                            })
                        }, Be.onerror = function() {
                            q.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"), i.$slider.trigger("lazyLoadError", [i, q, he])
                        }, Be.src = he
                    })
                }
                if (i.options.centerMode === !0 ? i.options.infinite === !0 ? (h = i.currentSlide + (i.options.slidesToShow / 2 + 1), y = h + i.options.slidesToShow + 2) : (h = Math.max(0, i.currentSlide - (i.options.slidesToShow / 2 + 1)), y = 2 + (i.options.slidesToShow / 2 + 1) + i.currentSlide) : (h = i.options.infinite ? i.options.slidesToShow + i.currentSlide : i.currentSlide, y = Math.ceil(h + i.options.slidesToShow), i.options.fade === !0 && (h > 0 && h--, y <= i.slideCount && y++)), s = i.$slider.find(".slick-slide").slice(h, y), i.options.lazyLoad === "anticipated")
                    for (var j = h - 1, G = y, L = i.$slider.find(".slick-slide"), ae = 0; ae < i.options.slidesToScroll; ae++) j < 0 && (j = i.slideCount - 1), s = s.add(L.eq(j)), s = s.add(L.eq(G)), j--, G++;
                D(s), i.slideCount <= i.options.slidesToShow ? (c = i.$slider.find(".slick-slide"), D(c)) : i.currentSlide >= i.slideCount - i.options.slidesToShow ? (c = i.$slider.find(".slick-cloned").slice(0, i.options.slidesToShow), D(c)) : i.currentSlide === 0 && (c = i.$slider.find(".slick-cloned").slice(i.options.slidesToShow * -1), D(c))
            }, S.prototype.loadSlider = function() {
                var i = this;
                i.setPosition(), i.$slideTrack.css({
                    opacity: 1
                }), i.$slider.removeClass("slick-loading"), i.initUI(), i.options.lazyLoad === "progressive" && i.progressiveLazyLoad()
            }, S.prototype.next = S.prototype.slickNext = function() {
                var i = this;
                i.changeSlide({
                    data: {
                        message: "next"
                    }
                })
            }, S.prototype.orientationChange = function() {
                var i = this;
                i.checkResponsive(), i.setPosition()
            }, S.prototype.pause = S.prototype.slickPause = function() {
                var i = this;
                i.autoPlayClear(), i.paused = !0
            }, S.prototype.play = S.prototype.slickPlay = function() {
                var i = this;
                i.autoPlay(), i.options.autoplay = !0, i.paused = !1, i.focussed = !1, i.interrupted = !1
            }, S.prototype.postSlide = function(i) {
                var s = this;
                if (!s.unslicked && (s.$slider.trigger("afterChange", [s, i]), s.animating = !1, s.slideCount > s.options.slidesToShow && s.setPosition(), s.swipeLeft = null, s.options.autoplay && s.autoPlay(), s.options.accessibility === !0 && (s.initADA(), s.options.focusOnChange))) {
                    var c = T(s.$slides.get(s.currentSlide));
                    c.attr("tabindex", 0).focus()
                }
            }, S.prototype.prev = S.prototype.slickPrev = function() {
                var i = this;
                i.changeSlide({
                    data: {
                        message: "previous"
                    }
                })
            }, S.prototype.preventDefault = function(i) {
                i.preventDefault()
            }, S.prototype.progressiveLazyLoad = function(i) {
                i = i || 1;
                var s = this,
                    c = T("img[data-lazy]", s.$slider),
                    h, y, D, j, G;
                c.length ? (h = c.first(), y = h.attr("data-lazy"), D = h.attr("data-srcset"), j = h.attr("data-sizes") || s.$slider.attr("data-sizes"), G = document.createElement("img"), G.onload = function() {
                    D && (h.attr("srcset", D), j && h.attr("sizes", j)), h.attr("src", y).removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading"), s.options.adaptiveHeight === !0 && s.setPosition(), s.$slider.trigger("lazyLoaded", [s, h, y]), s.progressiveLazyLoad()
                }, G.onerror = function() {
                    i < 3 ? setTimeout(function() {
                        s.progressiveLazyLoad(i + 1)
                    }, 500) : (h.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"), s.$slider.trigger("lazyLoadError", [s, h, y]), s.progressiveLazyLoad())
                }, G.src = y) : s.$slider.trigger("allImagesLoaded", [s])
            }, S.prototype.refresh = function(i) {
                var s = this,
                    c, h;
                h = s.slideCount - s.options.slidesToShow, !s.options.infinite && s.currentSlide > h && (s.currentSlide = h), s.slideCount <= s.options.slidesToShow && (s.currentSlide = 0), c = s.currentSlide, s.destroy(!0), T.extend(s, s.initials, {
                    currentSlide: c
                }), s.init(), i || s.changeSlide({
                    data: {
                        message: "index",
                        index: c
                    }
                }, !1)
            }, S.prototype.registerBreakpoints = function() {
                var i = this,
                    s, c, h, y = i.options.responsive || null;
                if (T.type(y) === "array" && y.length) {
                    i.respondTo = i.options.respondTo || "window";
                    for (s in y)
                        if (h = i.breakpoints.length - 1, y.hasOwnProperty(s)) {
                            for (c = y[s].breakpoint; h >= 0;) i.breakpoints[h] && i.breakpoints[h] === c && i.breakpoints.splice(h, 1), h--;
                            i.breakpoints.push(c), i.breakpointSettings[c] = y[s].settings
                        }
                    i.breakpoints.sort(function(D, j) {
                        return i.options.mobileFirst ? D - j : j - D
                    })
                }
            }, S.prototype.reinit = function() {
                var i = this;
                i.$slides = i.$slideTrack.children(i.options.slide).addClass("slick-slide"), i.slideCount = i.$slides.length, i.currentSlide >= i.slideCount && i.currentSlide !== 0 && (i.currentSlide = i.currentSlide - i.options.slidesToScroll), i.slideCount <= i.options.slidesToShow && (i.currentSlide = 0), i.registerBreakpoints(), i.setProps(), i.setupInfinite(), i.buildArrows(), i.updateArrows(), i.initArrowEvents(), i.buildDots(), i.updateDots(), i.initDotEvents(), i.cleanUpSlideEvents(), i.initSlideEvents(), i.checkResponsive(!1, !0), i.options.focusOnSelect === !0 && T(i.$slideTrack).children().on("click.slick", i.selectHandler), i.setSlideClasses(typeof i.currentSlide == "number" ? i.currentSlide : 0), i.setPosition(), i.focusHandler(), i.paused = !i.options.autoplay, i.autoPlay(), i.$slider.trigger("reInit", [i])
            }, S.prototype.resize = function() {
                var i = this;
                T(window).width() !== i.windowWidth && (clearTimeout(i.windowDelay), i.windowDelay = window.setTimeout(function() {
                    i.windowWidth = T(window).width(), i.checkResponsive(), i.unslicked || i.setPosition()
                }, 50))
            }, S.prototype.removeSlide = S.prototype.slickRemove = function(i, s, c) {
                var h = this;
                if (typeof i == "boolean" ? (s = i, i = s === !0 ? 0 : h.slideCount - 1) : i = s === !0 ? --i : i, h.slideCount < 1 || i < 0 || i > h.slideCount - 1) return !1;
                h.unload(), c === !0 ? h.$slideTrack.children().remove() : h.$slideTrack.children(this.options.slide).eq(i).remove(), h.$slides = h.$slideTrack.children(this.options.slide), h.$slideTrack.children(this.options.slide).detach(), h.$slideTrack.append(h.$slides), h.$slidesCache = h.$slides, h.reinit()
            }, S.prototype.setCSS = function(i) {
                var s = this,
                    c = {},
                    h, y;
                s.options.rtl === !0 && (i = -i), h = s.positionProp == "left" ? Math.ceil(i) + "px" : "0px", y = s.positionProp == "top" ? Math.ceil(i) + "px" : "0px", c[s.positionProp] = i, s.transformsEnabled === !1 ? s.$slideTrack.css(c) : (c = {}, s.cssTransitions === !1 ? (c[s.animType] = "translate(" + h + ", " + y + ")", s.$slideTrack.css(c)) : (c[s.animType] = "translate3d(" + h + ", " + y + ", 0px)", s.$slideTrack.css(c)))
            }, S.prototype.setDimensions = function() {
                var i = this;
                i.options.vertical === !1 ? i.options.centerMode === !0 && i.$list.css({
                    padding: "0px " + i.options.centerPadding
                }) : (i.$list.height(i.$slides.first().outerHeight(!0) * i.options.slidesToShow), i.options.centerMode === !0 && i.$list.css({
                    padding: i.options.centerPadding + " 0px"
                })), i.listWidth = i.$list.width(), i.listHeight = i.$list.height(), i.options.vertical === !1 && i.options.variableWidth === !1 ? (i.slideWidth = Math.ceil(i.listWidth / i.options.slidesToShow), i.$slideTrack.width(Math.ceil(i.slideWidth * i.$slideTrack.children(".slick-slide").length))) : i.options.variableWidth === !0 ? i.$slideTrack.width(5e3 * i.slideCount) : (i.slideWidth = Math.ceil(i.listWidth), i.$slideTrack.height(Math.ceil(i.$slides.first().outerHeight(!0) * i.$slideTrack.children(".slick-slide").length)));
                var s = i.$slides.first().outerWidth(!0) - i.$slides.first().width();
                i.options.variableWidth === !1 && i.$slideTrack.children(".slick-slide").width(i.slideWidth - s)
            }, S.prototype.setFade = function() {
                var i = this,
                    s;
                i.$slides.each(function(c, h) {
                    s = i.slideWidth * c * -1, i.options.rtl === !0 ? T(h).css({
                        position: "relative",
                        right: s,
                        top: 0,
                        zIndex: i.options.zIndex - 2,
                        opacity: 0
                    }) : T(h).css({
                        position: "relative",
                        left: s,
                        top: 0,
                        zIndex: i.options.zIndex - 2,
                        opacity: 0
                    })
                }), i.$slides.eq(i.currentSlide).css({
                    zIndex: i.options.zIndex - 1,
                    opacity: 1
                })
            }, S.prototype.setHeight = function() {
                var i = this;
                if (i.options.slidesToShow === 1 && i.options.adaptiveHeight === !0 && i.options.vertical === !1) {
                    var s = i.$slides.eq(i.currentSlide).outerHeight(!0);
                    i.$list.css("height", s)
                }
            }, S.prototype.setOption = S.prototype.slickSetOption = function() {
                var i = this,
                    s, c, h, y, D = !1,
                    j;
                if (T.type(arguments[0]) === "object" ? (h = arguments[0], D = arguments[1], j = "multiple") : T.type(arguments[0]) === "string" && (h = arguments[0], y = arguments[1], D = arguments[2], arguments[0] === "responsive" && T.type(arguments[1]) === "array" ? j = "responsive" : typeof arguments[1] != "undefined" && (j = "single")), j === "single") i.options[h] = y;
                else if (j === "multiple") T.each(h, function(G, L) {
                    i.options[G] = L
                });
                else if (j === "responsive")
                    for (c in y)
                        if (T.type(i.options.responsive) !== "array") i.options.responsive = [y[c]];
                        else {
                            for (s = i.options.responsive.length - 1; s >= 0;) i.options.responsive[s].breakpoint === y[c].breakpoint && i.options.responsive.splice(s, 1), s--;
                            i.options.responsive.push(y[c])
                        }
                D && (i.unload(), i.reinit())
            }, S.prototype.setPosition = function() {
                var i = this;
                i.setDimensions(), i.setHeight(), i.options.fade === !1 ? i.setCSS(i.getLeft(i.currentSlide)) : i.setFade(), i.$slider.trigger("setPosition", [i])
            }, S.prototype.setProps = function() {
                var i = this,
                    s = document.body.style;
                i.positionProp = i.options.vertical === !0 ? "top" : "left", i.positionProp === "top" ? i.$slider.addClass("slick-vertical") : i.$slider.removeClass("slick-vertical"), (s.WebkitTransition !== void 0 || s.MozTransition !== void 0 || s.msTransition !== void 0) && i.options.useCSS === !0 && (i.cssTransitions = !0), i.options.fade && (typeof i.options.zIndex == "number" ? i.options.zIndex < 3 && (i.options.zIndex = 3) : i.options.zIndex = i.defaults.zIndex), s.OTransform !== void 0 && (i.animType = "OTransform", i.transformType = "-o-transform", i.transitionType = "OTransition", s.perspectiveProperty === void 0 && s.webkitPerspective === void 0 && (i.animType = !1)), s.MozTransform !== void 0 && (i.animType = "MozTransform", i.transformType = "-moz-transform", i.transitionType = "MozTransition", s.perspectiveProperty === void 0 && s.MozPerspective === void 0 && (i.animType = !1)), s.webkitTransform !== void 0 && (i.animType = "webkitTransform", i.transformType = "-webkit-transform", i.transitionType = "webkitTransition", s.perspectiveProperty === void 0 && s.webkitPerspective === void 0 && (i.animType = !1)), s.msTransform !== void 0 && (i.animType = "msTransform", i.transformType = "-ms-transform", i.transitionType = "msTransition", s.msTransform === void 0 && (i.animType = !1)), s.transform !== void 0 && i.animType !== !1 && (i.animType = "transform", i.transformType = "transform", i.transitionType = "transition"), i.transformsEnabled = i.options.useTransform && i.animType !== null && i.animType !== !1
            }, S.prototype.setSlideClasses = function(i) {
                var s = this,
                    c, h, y, D;
                if (h = s.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden", "true"), s.$slides.eq(i).addClass("slick-current"), s.options.centerMode === !0) {
                    var j = s.options.slidesToShow % 2 === 0 ? 1 : 0;
                    c = Math.floor(s.options.slidesToShow / 2), s.options.infinite === !0 && (i >= c && i <= s.slideCount - 1 - c ? s.$slides.slice(i - c + j, i + c + 1).addClass("slick-active").attr("aria-hidden", "false") : (y = s.options.slidesToShow + i, h.slice(y - c + 1 + j, y + c + 2).addClass("slick-active").attr("aria-hidden", "false")), i === 0 ? h.eq(h.length - 1 - s.options.slidesToShow).addClass("slick-center") : i === s.slideCount - 1 && h.eq(s.options.slidesToShow).addClass("slick-center")), s.$slides.eq(i).addClass("slick-center")
                } else i >= 0 && i <= s.slideCount - s.options.slidesToShow ? s.$slides.slice(i, i + s.options.slidesToShow).addClass("slick-active").attr("aria-hidden", "false") : h.length <= s.options.slidesToShow ? h.addClass("slick-active").attr("aria-hidden", "false") : (D = s.slideCount % s.options.slidesToShow, y = s.options.infinite === !0 ? s.options.slidesToShow + i : i, s.options.slidesToShow == s.options.slidesToScroll && s.slideCount - i < s.options.slidesToShow ? h.slice(y - (s.options.slidesToShow - D), y + D).addClass("slick-active").attr("aria-hidden", "false") : h.slice(y, y + s.options.slidesToShow).addClass("slick-active").attr("aria-hidden", "false"));
                (s.options.lazyLoad === "ondemand" || s.options.lazyLoad === "anticipated") && s.lazyLoad()
            }, S.prototype.setupInfinite = function() {
                var i = this,
                    s, c, h;
                if (i.options.fade === !0 && (i.options.centerMode = !1), i.options.infinite === !0 && i.options.fade === !1 && (c = null, i.slideCount > i.options.slidesToShow)) {
                    for (i.options.centerMode === !0 ? h = i.options.slidesToShow + 1 : h = i.options.slidesToShow, s = i.slideCount; s > i.slideCount - h; s -= 1) c = s - 1, T(i.$slides[c]).clone(!0).attr("id", "").attr("data-slick-index", c - i.slideCount).prependTo(i.$slideTrack).addClass("slick-cloned");
                    for (s = 0; s < h + i.slideCount; s += 1) c = s, T(i.$slides[c]).clone(!0).attr("id", "").attr("data-slick-index", c + i.slideCount).appendTo(i.$slideTrack).addClass("slick-cloned");
                    i.$slideTrack.find(".slick-cloned").find("[id]").each(function() {
                        T(this).attr("id", "")
                    })
                }
            }, S.prototype.interrupt = function(i) {
                var s = this;
                i || s.autoPlay(), s.interrupted = i
            }, S.prototype.selectHandler = function(i) {
                var s = this,
                    c = T(i.target).is(".slick-slide") ? T(i.target) : T(i.target).parents(".slick-slide"),
                    h = parseInt(c.attr("data-slick-index"));
                if (h || (h = 0), s.slideCount <= s.options.slidesToShow) {
                    s.slideHandler(h, !1, !0);
                    return
                }
                s.slideHandler(h)
            }, S.prototype.slideHandler = function(i, s, c) {
                var h, y, D, j, G = null,
                    L = this,
                    ae;
                if (s = s || !1, !(L.animating === !0 && L.options.waitForAnimate === !0) && !(L.options.fade === !0 && L.currentSlide === i)) {
                    if (s === !1 && L.asNavFor(i), h = i, G = L.getLeft(h), j = L.getLeft(L.currentSlide), L.currentLeft = L.swipeLeft === null ? j : L.swipeLeft, L.options.infinite === !1 && L.options.centerMode === !1 && (i < 0 || i > L.getDotCount() * L.options.slidesToScroll)) {
                        L.options.fade === !1 && (h = L.currentSlide, c !== !0 && L.slideCount > L.options.slidesToShow ? L.animateSlide(j, function() {
                            L.postSlide(h)
                        }) : L.postSlide(h));
                        return
                    } else if (L.options.infinite === !1 && L.options.centerMode === !0 && (i < 0 || i > L.slideCount - L.options.slidesToScroll)) {
                        L.options.fade === !1 && (h = L.currentSlide, c !== !0 && L.slideCount > L.options.slidesToShow ? L.animateSlide(j, function() {
                            L.postSlide(h)
                        }) : L.postSlide(h));
                        return
                    }
                    if (L.options.autoplay && clearInterval(L.autoPlayTimer), h < 0 ? L.slideCount % L.options.slidesToScroll !== 0 ? y = L.slideCount - L.slideCount % L.options.slidesToScroll : y = L.slideCount + h : h >= L.slideCount ? L.slideCount % L.options.slidesToScroll !== 0 ? y = 0 : y = h - L.slideCount : y = h, L.animating = !0, L.$slider.trigger("beforeChange", [L, L.currentSlide, y]), D = L.currentSlide, L.currentSlide = y, L.setSlideClasses(L.currentSlide), L.options.asNavFor && (ae = L.getNavTarget(), ae = ae.slick("getSlick"), ae.slideCount <= ae.options.slidesToShow && ae.setSlideClasses(L.currentSlide)), L.updateDots(), L.updateArrows(), L.options.fade === !0) {
                        c !== !0 ? (L.fadeSlideOut(D), L.fadeSlide(y, function() {
                            L.postSlide(y)
                        })) : L.postSlide(y), L.animateHeight();
                        return
                    }
                    c !== !0 && L.slideCount > L.options.slidesToShow ? L.animateSlide(G, function() {
                        L.postSlide(y)
                    }) : L.postSlide(y)
                }
            }, S.prototype.startLoad = function() {
                var i = this;
                i.options.arrows === !0 && i.slideCount > i.options.slidesToShow && (i.$prevArrow.hide(), i.$nextArrow.hide()), i.options.dots === !0 && i.slideCount > i.options.slidesToShow && i.$dots.hide(), i.$slider.addClass("slick-loading")
            }, S.prototype.swipeDirection = function() {
                var i, s, c, h, y = this;
                return i = y.touchObject.startX - y.touchObject.curX, s = y.touchObject.startY - y.touchObject.curY, c = Math.atan2(s, i), h = Math.round(c * 180 / Math.PI), h < 0 && (h = 360 - Math.abs(h)), h <= 45 && h >= 0 || h <= 360 && h >= 315 ? y.options.rtl === !1 ? "left" : "right" : h >= 135 && h <= 225 ? y.options.rtl === !1 ? "right" : "left" : y.options.verticalSwiping === !0 ? h >= 35 && h <= 135 ? "down" : "up" : "vertical"
            }, S.prototype.swipeEnd = function(i) {
                var s = this,
                    c, h;
                if (s.dragging = !1, s.swiping = !1, s.scrolling) return s.scrolling = !1, !1;
                if (s.interrupted = !1, s.shouldClick = !(s.touchObject.swipeLength > 10), s.touchObject.curX === void 0) return !1;
                if (s.touchObject.edgeHit === !0 && s.$slider.trigger("edge", [s, s.swipeDirection()]), s.touchObject.swipeLength >= s.touchObject.minSwipe) {
                    switch (h = s.swipeDirection(), h) {
                        case "left":
                        case "down":
                            c = s.options.swipeToSlide ? s.checkNavigable(s.currentSlide + s.getSlideCount()) : s.currentSlide + s.getSlideCount(), s.currentDirection = 0;
                            break;
                        case "right":
                        case "up":
                            c = s.options.swipeToSlide ? s.checkNavigable(s.currentSlide - s.getSlideCount()) : s.currentSlide - s.getSlideCount(), s.currentDirection = 1;
                            break
                    }
                    h != "vertical" && (s.slideHandler(c), s.touchObject = {}, s.$slider.trigger("swipe", [s, h]))
                } else s.touchObject.startX !== s.touchObject.curX && (s.slideHandler(s.currentSlide), s.touchObject = {})
            }, S.prototype.swipeHandler = function(i) {
                var s = this;
                if (!(s.options.swipe === !1 || "ontouchend" in document && s.options.swipe === !1) && !(s.options.draggable === !1 && i.type.indexOf("mouse") !== -1)) switch (s.touchObject.fingerCount = i.originalEvent && i.originalEvent.touches !== void 0 ? i.originalEvent.touches.length : 1, s.touchObject.minSwipe = s.listWidth / s.options.touchThreshold, s.options.verticalSwiping === !0 && (s.touchObject.minSwipe = s.listHeight / s.options.touchThreshold), i.data.action) {
                    case "start":
                        s.swipeStart(i);
                        break;
                    case "move":
                        s.swipeMove(i);
                        break;
                    case "end":
                        s.swipeEnd(i);
                        break
                }
            }, S.prototype.swipeMove = function(i) {
                var s = this,
                    c, h, y, D, j, G;
                if (j = i.originalEvent !== void 0 ? i.originalEvent.touches : null, !s.dragging || s.scrolling || j && j.length !== 1) return !1;
                if (c = s.getLeft(s.currentSlide), s.touchObject.curX = j !== void 0 ? j[0].pageX : i.clientX, s.touchObject.curY = j !== void 0 ? j[0].pageY : i.clientY, s.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(s.touchObject.curX - s.touchObject.startX, 2))), G = Math.round(Math.sqrt(Math.pow(s.touchObject.curY - s.touchObject.startY, 2))), !s.options.verticalSwiping && !s.swiping && G > 4) return s.scrolling = !0, !1;
                if (s.options.verticalSwiping === !0 && (s.touchObject.swipeLength = G), h = s.swipeDirection(), i.originalEvent !== void 0 && s.touchObject.swipeLength > 4 && (s.swiping = !0, i.preventDefault()), D = (s.options.rtl === !1 ? 1 : -1) * (s.touchObject.curX > s.touchObject.startX ? 1 : -1), s.options.verticalSwiping === !0 && (D = s.touchObject.curY > s.touchObject.startY ? 1 : -1), y = s.touchObject.swipeLength, s.touchObject.edgeHit = !1, s.options.infinite === !1 && (s.currentSlide === 0 && h === "right" || s.currentSlide >= s.getDotCount() && h === "left") && (y = s.touchObject.swipeLength * s.options.edgeFriction, s.touchObject.edgeHit = !0), s.options.vertical === !1 ? s.swipeLeft = c + y * D : s.swipeLeft = c + y * (s.$list.height() / s.listWidth) * D, s.options.verticalSwiping === !0 && (s.swipeLeft = c + y * D), s.options.fade === !0 || s.options.touchMove === !1) return !1;
                if (s.animating === !0) return s.swipeLeft = null, !1;
                s.setCSS(s.swipeLeft)
            }, S.prototype.swipeStart = function(i) {
                var s = this,
                    c;
                if (s.interrupted = !0, s.touchObject.fingerCount !== 1 || s.slideCount <= s.options.slidesToShow) return s.touchObject = {}, !1;
                i.originalEvent !== void 0 && i.originalEvent.touches !== void 0 && (c = i.originalEvent.touches[0]), s.touchObject.startX = s.touchObject.curX = c !== void 0 ? c.pageX : i.clientX, s.touchObject.startY = s.touchObject.curY = c !== void 0 ? c.pageY : i.clientY, s.dragging = !0
            }, S.prototype.unfilterSlides = S.prototype.slickUnfilter = function() {
                var i = this;
                i.$slidesCache !== null && (i.unload(), i.$slideTrack.children(this.options.slide).detach(), i.$slidesCache.appendTo(i.$slideTrack), i.reinit())
            }, S.prototype.unload = function() {
                var i = this;
                T(".slick-cloned", i.$slider).remove(), i.$dots && i.$dots.remove(), i.$prevArrow && i.htmlExpr.test(i.options.prevArrow) && i.$prevArrow.remove(), i.$nextArrow && i.htmlExpr.test(i.options.nextArrow) && i.$nextArrow.remove(), i.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden", "true").css("width", "")
            }, S.prototype.unslick = function(i) {
                var s = this;
                s.$slider.trigger("unslick", [s, i]), s.destroy()
            }, S.prototype.updateArrows = function() {
                var i = this;
                Math.floor(i.options.slidesToShow / 2), i.options.arrows === !0 && i.slideCount > i.options.slidesToShow && !i.options.infinite && (i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false"), i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false"), i.currentSlide === 0 ? (i.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true"), i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false")) : (i.currentSlide >= i.slideCount - i.options.slidesToShow && i.options.centerMode === !1 || i.currentSlide >= i.slideCount - 1 && i.options.centerMode === !0) && (i.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"), i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")))
            }, S.prototype.updateDots = function() {
                var i = this;
                i.$dots !== null && (i.$dots.find("li").removeClass("slick-active").end(), i.$dots.find("li").eq(Math.floor(i.currentSlide / i.options.slidesToScroll)).addClass("slick-active"))
            }, S.prototype.visibility = function() {
                var i = this;
                i.options.autoplay && (document[i.hidden] ? i.interrupted = !0 : i.interrupted = !1)
            }, T.fn.slick = function() {
                var i = this,
                    s = arguments[0],
                    c = Array.prototype.slice.call(arguments, 1),
                    h = i.length,
                    y, D;
                for (y = 0; y < h; y++)
                    if (typeof s == "object" || typeof s == "undefined" ? i[y].slick = new S(i[y], s) : D = i[y].slick[s].apply(i[y].slick, c), typeof D != "undefined") return D;
                return i
            }
        })
    })(Yi);
    const He = "active";
    (function() {
        V("[data-tabs]").find("[data-tab]").each((S, i) => {
            V(i).on("click", c => {
                const y = V(c.currentTarget).data("tab");
                V(`[data-popup-item="${y}"]`).addClass(He)
            })
        });
        const H = V(".coming-soon-header [data-close]"),
            T = V(".coming-soon-header [data-popup-item]");
        H.on("click", () => {
            T.removeClass(He)
        })
    })(),
    function() {
        document.querySelectorAll("[data-carousel]").forEach(T => {
            const S = V(T);
            S.not(".scroll-wrapper").slick({
                infinite: !0,
                arrows: !1,
                autoplay: !0,
                autoplaySpeed: 0,
                speed: 7e3,
                centerMode: !0,
                cssEase: "linear",
                slidesToShow: 3,
                slidesToScroll: 1,
                dots: !1,
                mobileFirst: !0,
                variableWidth: !0,
                swipeToSlide: !0,
                responsive: [{
                    breakpoint: 990,
                    settings: {
                        arrows: !1,
                        dots: !1
                    }
                }]
            }), S.slick({
                infinite: !0,
                arrows: !0,
                slidesToShow: 1,
                slidesToScroll: 1,
                mobileFirst: !0,
                variableWidth: !0,
                swipeToSlide: !0,
                responsive: [{
                    breakpoint: 990,
                    settings: {
                        arrows: !0,
                        dots: !1
                    }
                }]
            });
            const i = S.find(".slick-next"),
                s = `
      <?xml version="1.0" standalone="no"?>
      <!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 20010904//EN"
      "http://www.w3.org/TR/2001/REC-SVG-20010904/DTD/svg10.dtd">
      <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
      width="163.000000pt" height="105.000000pt" viewBox="0 0 163.000000 105.000000"
      preserveAspectRatio="xMidYMid meet">
      
        <g transform="translate(0.000000,105.000000) scale(0.100000,-0.100000)"
        fill="#000000" stroke="none">
          <path d="M1220 1002 c0 -67 34 -196 67 -251 36 -62 106 -135 166 -174 l50 -32
          -752 -3 c-743 -2 -751 -2 -751 -22 0 -20 7 -20 742 -20 l743 0 -50 -34 c-129
          -87 -214 -251 -215 -414 0 -46 3 -53 18 -50 13 3 19 18 24 78 13 126 51 213
          131 297 50 53 169 123 208 123 14 0 19 7 19 25 0 14 -6 25 -14 25 -33 0 -159
          75 -209 125 -84 82 -137 211 -137 330 0 38 -3 45 -20 45 -17 0 -20 -7 -20 -48z"/>
        </g>
      </svg>
    `;
            i.append(s)
        }), V("[data-carousel-list]").each((T, S) => {
            const i = V(S);
            var s = "",
                c = 500,
                h = "",
                y = !1;
            i.on("init", function(D, j, G) {
                new MutationObserver(function(ae, X) {
                    for (const q of ae) q.type === "attributes" && q.attributeName == "style" && y && i.find(".slick-track").css("transform", h)
                }).observe(i.find(".slick-track")[0], {
                    attributes: !0
                }), i.find(".slick-track .slick-slide").mouseover(function() {
                    s = i.find(".slick-track").attr("style"), h = getComputedStyle(i.find(".slick-track")[0]).transform, y = !0, i.slick("slickPause");
                    let ae = parseFloat(h.split(",")[4]) * -1,
                        X = /translate3d\(([^,]*),/gm,
                        q;
                    if ((q = X.exec(s)) !== null) {
                        let he = parseFloat(q[1]) * -1,
                            U = i.find(".slick-slide").first().width(),
                            Fe = 9e3 / U;
                        c = (he - ae) * Fe
                    } else c = 500;
                    i.find(".slick-track").css("transform", h)
                }), i.find(".slick-track .slick-slide").mouseout(function() {
                    y = !1, i.find(".slick-track").attr("style", s.replace("9000ms", c + "ms")), i.slick("slickPlay")
                })
            })
        }), V("[data-carousel-list]").each((T, S) => {
            V(S).slick({
                infinite: !0,
                arrows: !1,
                autoplay: !0,
                autoplaySpeed: 0,
                speed: 9e3,
                cssEase: "linear",
                slidesToShow: 1,
                slidesToScroll: 1,
                pauseOnHover: !1,
                mobileFirst: !0,
                variableWidth: !0,
                rtl: !1,
                responsive: [{
                    breakpoint: 990,
                    settings: {
                        arrows: !1,
                        dots: !1
                    }
                }]
            })
        })
    }(),
    function() {
        V(".join-our-underline").click(() => {
            window.scrollTo(0, document.body.scrollHeight), V("input.needsclick").focus()
        })
    }(),
    function() {
        const K = V(".main-header .overlay"),
            H = V(".main-header .header-nav");
        V(".main-header .header-icon-menu").on("click", () => {
            K.addClass(He)
        }), K.on("click", () => {
            K.removeClass(He), H.removeClass(He), document.documentElement.classList.remove("prevent-scroll")
        })
    }(),
    function() {
        const K = document.querySelector(".product-sticky-bar"),
            H = document.querySelector(".main-product .product__media-wrapper");
        if (window.innerWidth >= 1200) {
            if (!K && !H) return;
            const i = H.offsetTop;
            window.addEventListener("scroll", () => {
                window.pageYOffset > i ? K.classList.add("sticky") : K.classList.remove("sticky")
            })
        } else {
            if (!K && !H) return;
            const i = H.offsetTop;
            window.addEventListener("scroll", () => {
                window.pageYOffset > i ? K.classList.add("sticky") : K.classList.remove("sticky")
            })
        }
        const S = document.querySelector(".footer").offsetTop;
        K && window.addEventListener("scroll", () => {
            window.pageYOffset > S && K.classList.remove("sticky")
        })
    }(),
    function() {
        V(".faq__link").each((H, T) => {
            V(T).on("click", function(i) {
                if (location.pathname.replace(/^\//, "") == this.pathname.replace(/^\//, "") && location.hostname == this.hostname) {
                    var s = V(this.hash);
                    s = s.length ? s : V("[name=" + this.hash.slice(1) + "]"), s.length && (i.preventDefault(), V("html, body").animate({
                        scrollTop: s.offset().top + -250
                    }, 1e3))
                }
            })
        })
    }(),
    function() {
        V("[data-tab-container]").find("[data-tab-ingredient]").each((H, T) => {
            V(T).on("click", i => {
                const s = V(i.currentTarget),
                    c = s.data("id");
                V("[data-tab-ingredient]").removeClass(He), V("[data-tab-image]").removeClass("show"), V("[data-tab-des]").removeClass("displayed"), s.addClass(He), V(`[data-tab-image="data-image-${c}"]`).addClass("show"), V(`[data-tab-des="data-des-${c}"]`).addClass("displayed")
            })
        })
    }(),
    function() {
        const K = document.querySelector(".article-navigation-bar"),
            H = document.querySelector(".article-hero-banner__image");
        window.addEventListener("scroll", () => {
            if (H) {
                const i = H.getBoundingClientRect().top + 750;
                H.getBoundingClientRect() && window.scrollY > i ? K.classList.add("sticky") : K.classList.remove("sticky")
            }
        });
        const T = document.querySelector(".footer"),
            S = T.getBoundingClientRect().top;
        K && window.addEventListener("scroll", function() {
            T.getBoundingClientRect() && window.scrollY > S && K.classList.remove("sticky")
        })
    }(),

    function() {
        V(".accordion__content__button .pd-button").on("click", function(H) {
            if (location.pathname.replace(/^\//, "") == this.pathname.replace(/^\//, "") && location.hostname == this.hostname) {
                var T = V(this.hash);
                T = T.length ? T : V("[name=" + this.hash.slice(1) + "]"), T.length && (H.preventDefault(), window.innerWidth > 989 ? V("html, body").animate({
                    scrollTop: T.offset().top + -50
                }, 1e3) : V("html, body").animate({
                    scrollTop: T.offset().top + -80
                }, 1e3))
            }
        })
    }(),
    (function() {
  const signupLabel = document.getElementById("signupLabel");
  const popup = document.querySelector(".klaviyo-popup");
  const overlay = document.querySelector(".klaviyo-popup__overlay");
  const closeButtons = document.querySelectorAll(".klaviyo-popup__close svg");

  // OPEN
  if (signupLabel && popup) {
    signupLabel.addEventListener("click", () => {
      popup.classList.add("active");
    });
  }

  // CLOSE via overlay
  if (overlay) {
    overlay.addEventListener("click", () => {
      const activePopup = document.querySelector(".klaviyo-popup.active");
      if (activePopup) activePopup.classList.remove("active");
    });
  }

  // CLOSE via SVG buttons
  closeButtons.forEach(btn => {
    btn.addEventListener("click", () => {
      const activePopup = document.querySelector(".klaviyo-popup.active");
      if (activePopup) activePopup.classList.remove("active");
    });
  });
})();

});